import React, { Component, useRef, Children, isValidElement, cloneElement, createContext, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Field, ErrorMessage } from 'formik';
import ReactDOM from 'react-dom';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var data = [{
  supplier: {
    title: "supplier",
    path: {
      d: "M18.354 5.9l4.83-1.294a1 1 0 0 1 1.224.707l3.624 13.523a1 1 0 0 1-.707 1.225l-8.774 2.35a7.35 7.35 0 0 0-7.075-3.542L8.953 9.454A1 1 0 0 1 9.66 8.23l4.83-1.295 1.035 3.864 3.864-1.035L18.354 5.9zM6.905 21.13L3.347 7.85l-1.932.517a1 1 0 0 1-1.224-.707l-.26-.966A1 1 0 0 1 .64 5.47l1.932-.517 1.932-.518a1 1 0 0 1 1.224.707L9.534 19.35a7.33 7.33 0 0 0-2.629 1.78zM19.34 24.27l9.47-2.537a1 1 0 0 1 1.224.707l.259.966a1 1 0 0 1-.707 1.225l-10.088 2.703a7.306 7.306 0 0 0-.158-3.064zm-9.566-3.11a5.59 5.59 0 1 1 4.942 10.028 5.59 5.59 0 0 1-4.942-10.027zm3.41 6.921a2.128 2.128 0 0 0 .968-2.846 2.128 2.128 0 0 0-2.847-.967 2.128 2.128 0 0 0-.967 2.846 2.128 2.128 0 0 0 2.846.967z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  account: {
    title: "account",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M20.605 18.138c1.252-1.539 1.941-3.598 1.941-5.795 0-4.47-2.885-8.107-6.433-8.107-3.547 0-6.432 3.637-6.432 8.107 0 2.197.69 4.256 1.941 5.796 1.21 1.489 2.806 2.308 4.491 2.308 1.686 0 3.281-.82 4.492-2.309z"
    }, {
      d: "M21.041 19.802c-.083.09-.166.178-.25.263a6.526 6.526 0 0 1-.321.293c-.089.078-.176.158-.267.23-.111.09-.226.17-.342.253-.093.066-.184.135-.279.196-.119.076-.24.144-.363.212-.096.054-.19.11-.286.16-.127.062-.257.115-.387.17-.097.04-.191.086-.29.12-.137.052-.277.09-.418.13-.092.027-.185.06-.278.083-.158.038-.318.061-.478.087-.08.013-.159.032-.239.042a6.205 6.205 0 0 1-1.46-.002c-.079-.01-.155-.029-.233-.04-.162-.026-.324-.05-.483-.089-.093-.022-.181-.054-.272-.08-.143-.042-.286-.08-.426-.132-.096-.035-.188-.079-.282-.118-.133-.056-.265-.11-.394-.174-.095-.047-.187-.103-.28-.156-.125-.07-.25-.138-.37-.216-.094-.06-.183-.126-.274-.192-.117-.083-.233-.164-.346-.256-.09-.072-.177-.15-.265-.228a7.953 7.953 0 0 1-.322-.294c-.086-.085-.168-.175-.252-.265-.067-.073-.138-.139-.203-.214-4.175 1.319-6.925 4.963-7.167 8.078h24.598c-.242-3.114-2.992-6.76-7.166-8.076-.066.076-.137.142-.205.215z"
    }]
  },
  "save-to-favorites": {
    title: "save-to-favorites",
    path: {
      d: "M26.004 28.893V3a1 1 0 0 0-1-1h-18a1 1 0 0 0-1 1v25.893a1 1 0 0 0 1.496.868l8.007-4.583a1 1 0 0 1 .993 0l8.007 4.583a1 1 0 0 0 1.497-.868z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "white-paper-case-study": {
    title: "white-paper-case-study",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M24.026 10.301c.267.26.497.614.688 1.06.19.447.286.856.286 1.228v16.072c0 .372-.134.688-.401.948s-.592.391-.974.391H4.375c-.382 0-.707-.13-.974-.39A1.275 1.275 0 0 1 3 28.66V6.34c0-.373.134-.689.401-.95.267-.26.592-.39.974-.39h12.833c.382 0 .802.093 1.26.279.46.186.822.41 1.09.67l4.468 4.352zM6 9v6h6V9H6zm0 8v2h16v-2H6zm0 4v2h16v-2H6zm0 4v2h16v-2H6zm11.807-12.616V8.61a3.517 3.517 0 0 0-2.032.96 3.307 3.307 0 0 0 0 4.783c.681.66 1.575.99 2.468.99.894 0 1.787-.33 2.468-.99.57-.553.899-1.25.992-1.969h-3.896zm1.24-1.151h2.49a2.507 2.507 0 0 0-2.491-2.49v2.49z"
    }, {
      d: "M27.167 26V12.293c0-.644-.153-1.297-.437-1.962-.282-.659-.643-1.216-1.098-1.659l-4.469-4.353c-.451-.44-1.013-.785-1.677-1.055-.664-.269-1.311-.412-1.944-.412H7v-.513c0-.372.134-.688.401-.948S7.993 1 8.375 1h11.917c.382 0 .802.093 1.26.279.458.186.821.41 1.089.67l5.385 5.278c.267.26.497.614.688 1.06.19.447.286.856.286 1.228v15.146c0 .372-.134.688-.401.948s-.592.391-.974.391h-.458z"
    }]
  },
  shortlist: {
    title: "shortlist",
    path: {
      d: "M3 27a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1H3zm13.585-15.024a.5.5 0 0 0 .5-.5v-1.02a.5.5 0 0 0-.5-.5H7.5a.5.5 0 0 0-.5.5v1.02a.5.5 0 0 0 .5.5h9.085zm0 4a.5.5 0 0 0 .5-.5v-1.02a.5.5 0 0 0-.5-.5H7.5a.5.5 0 0 0-.5.5v1.02a.5.5 0 0 0 .5.5h9.085zm9.217-4.79a.577.577 0 0 0-.814.056l-7.181 8.237-2.568-1.403a.596.596 0 0 0-.752.892l2.728 3.432a1.237 1.237 0 0 0 2.007-.099l.09-.14 6.596-10.227a.577.577 0 0 0-.106-.748z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  newsletter: {
    title: "newsletter",
    path: {
      d: "M27.887 3.186L3.944 16.623a1 1 0 0 0 .163 1.818l6.179 2.13 10.857-9.142-8.571 10v5.12a1 1 0 0 0 1.845.535L17 23l5.436 1.812a1 1 0 0 0 1.279-.675L29.338 4.33a1 1 0 0 0-1.451-1.145z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "email-preferences": {
    title: "email-preferences",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M25.17 15.486a7.431 7.431 0 0 0-3.28.99 7.48 7.48 0 0 0-3.702 7.253L16 23l-2.583 4.084a1 1 0 0 1-1.845-.535v-5.12l8.571-10L9.286 20.57l-6.179-2.13a1 1 0 0 1-.163-1.818L26.887 3.186a1 1 0 0 1 1.451 1.145l-3.167 11.155z",
      fillRule: "nonzero"
    }, {
      d: "M27.423 17.785v1.337a4.47 4.47 0 0 1 1.658.957l1.158-.669 1.36 2.358-1.158.668c.14.636.135 1.29 0 1.912l1.159.67-1.361 2.357-1.159-.669a4.373 4.373 0 0 1-.776.568c-.285.165-.58.294-.88.39L27.421 29h-2.72v-1.337a4.486 4.486 0 0 1-1.66-.957l-1.156.669-1.361-2.357 1.158-.669a4.49 4.49 0 0 1 0-1.913l-1.158-.668 1.362-2.358 1.155.669a4.49 4.49 0 0 1 1.66-.958v-1.336h2.721zm-.306 7.435a2.111 2.111 0 1 0-2.112-3.657 2.111 2.111 0 0 0 2.112 3.657z"
    }]
  },
  "client-center": {
    title: "client-center",
    path: {
      d: "M29.343 14.29c.399.17.657.56.657.992v1.433c0 .434-.26.825-.66.993l-2.98 1.247a9.69 9.69 0 0 1-.933 2.272l1.22 2.976c.166.402.073.864-.234 1.17l-1.008 1.009c-.307.307-.769.4-1.17.235l-2.977-1.222a9.702 9.702 0 0 1-2.271.934l-1.278 3.014a1.076 1.076 0 0 1-.991.657h-1.433c-.434 0-.825-.26-.993-.66l-1.247-2.98a9.69 9.69 0 0 1-2.272-.933l-2.976 1.22a1.077 1.077 0 0 1-1.17-.234l-1.009-1.008a1.077 1.077 0 0 1-.235-1.17l1.222-2.977a9.702 9.702 0 0 1-.934-2.271l-3.014-1.278A1.076 1.076 0 0 1 2 16.718v-1.433c0-.434.26-.825.66-.993l2.98-1.247a9.69 9.69 0 0 1 .933-2.272l-1.22-2.976a1.077 1.077 0 0 1 .234-1.17l1.008-1.009c.307-.307.769-.4 1.17-.235l2.977 1.222a9.702 9.702 0 0 1 2.271-.934l1.278-3.014c.168-.399.558-.657.991-.657h1.433c.434 0 .825.26.993.66l1.247 2.98a9.69 9.69 0 0 1 2.272.933l2.976-1.22a1.077 1.077 0 0 1 1.17.234l1.009 1.008c.307.307.4.769.235 1.17l-1.222 2.977c.405.716.716 1.463.934 2.271l3.014 1.278zM18.52 16.407c.713-.83 1.105-1.942 1.105-3.129 0-2.413-1.642-4.376-3.66-4.376-2.02 0-3.661 1.963-3.661 4.376 0 1.186.392 2.298 1.105 3.13.688.803 1.596 1.246 2.555 1.246.96 0 1.868-.443 2.556-1.247zm.365.782c-.037.041-.077.077-.116.117-.047.048-.094.096-.143.142-.059.055-.12.107-.182.157-.05.043-.1.086-.152.125-.064.049-.129.092-.195.136-.052.036-.105.073-.158.106-.068.041-.138.078-.207.115-.055.029-.108.059-.163.086-.072.034-.146.062-.22.092-.055.022-.109.046-.165.065-.078.028-.158.049-.238.07-.053.015-.105.032-.158.044-.09.021-.181.034-.272.048-.046.007-.09.017-.136.022a3.82 3.82 0 0 1-.831 0c-.045-.006-.089-.016-.133-.023-.092-.013-.184-.027-.275-.047-.052-.012-.103-.03-.155-.044-.08-.022-.162-.043-.242-.07-.054-.02-.107-.043-.16-.065-.076-.03-.151-.059-.225-.094-.054-.025-.106-.055-.16-.084-.07-.037-.141-.074-.21-.116-.053-.032-.104-.068-.156-.104-.066-.045-.132-.089-.197-.138-.05-.039-.1-.082-.15-.124a4.448 4.448 0 0 1-.183-.158c-.05-.046-.096-.095-.144-.143-.038-.04-.078-.075-.116-.116-2.375.712-3.94 2.68-4.078 4.361h13.999c-.138-1.68-1.703-3.649-4.079-4.36z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "sign-in": {
    title: "sign-in",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M11.807 18.297v-2.28H3.618a.5.5 0 0 1-.5-.5V13.02a.5.5 0 0 1 .5-.5h8.189v-2.28a.5.5 0 0 1 .855-.353l3.99 4.029a.5.5 0 0 1 0 .703l-3.99 4.029a.5.5 0 0 1-.855-.352z"
    }, {
      d: "M9 18.264v5.992a.5.5 0 0 0 .5.5h8.188v4.434a.5.5 0 0 0 .725.447l9.387-4.71a.5.5 0 0 0 .275-.446V2.5a.5.5 0 0 0-.5-.5H9.5a.5.5 0 0 0-.5.5v7.773a.5.5 0 0 0 .5.5h.731a.5.5 0 0 0 .5-.5V3.748h13.882l-6.65 3.357a.5.5 0 0 0-.275.446v15.457h-6.924v-4.744a.5.5 0 0 0-.5-.5H9.5a.5.5 0 0 0-.5.5z",
      stroke: "currentColor",
      strokeWidth: ".5"
    }]
  },
  "sign-out": {
    title: "sign-out",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M24.807 18.297v-2.28h-8.189a.5.5 0 0 1-.5-.5V13.02a.5.5 0 0 1 .5-.5h8.189v-2.28a.5.5 0 0 1 .855-.353l3.99 4.029a.5.5 0 0 1 0 .703l-3.99 4.029a.5.5 0 0 1-.855-.352z"
    }, {
      d: "M23.075 18.264v5.992a.5.5 0 0 1-.5.5h-8.188v4.434a.5.5 0 0 1-.724.447l-9.387-4.71A.5.5 0 0 1 4 24.482V2.5a.5.5 0 0 1 .5-.5h18.075a.5.5 0 0 1 .5.5v7.773a.5.5 0 0 1-.5.5h-.73a.5.5 0 0 1-.5-.5V3.748H7.461l6.65 3.357a.5.5 0 0 1 .275.446v15.457h6.925v-4.744a.5.5 0 0 1 .5-.5h.763a.5.5 0 0 1 .5.5z",
      stroke: "currentColor",
      strokeWidth: ".5"
    }]
  },
  "summary-report": {
    title: "summary-report",
    path: {
      d: "M28.6 14.146V29a1 1 0 0 1-1 1h-23a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12.039A8.55 8.55 0 0 0 28.6 14.146zM11.93 25.437V15.6H7.774v9.837h4.154zm6.438 0V18.53h-4.154v6.907h4.154zm6.438 0V21.46h-4.154v3.977h4.154zM22.33 8.481h6.96a5.937 5.937 0 0 1-1.771 3.516 6.32 6.32 0 0 1-4.41 1.77 6.32 6.32 0 0 1-4.41-1.77 5.909 5.909 0 0 1 0-8.543 6.284 6.284 0 0 1 3.63-1.716V8.48zm2.215-2.057V1.975c1.136.01 2.27.447 3.136 1.314.867.866 1.304 2 1.314 3.135h-4.45z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  contact: {
    title: "contact",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M2.5 19.79v-8.457l6.207 4.228zM29.668 22.165v.833a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1v-.833l7.287-5.042 5.724 4a1 1 0 0 0 1.146 0l5.724-4 7.287 5.042z"
    }, {
      d: "M2.5 9.133V8.3a1 1 0 0 1 1-1h25.168a1 1 0 0 1 1 1v.833l-13.005 9.231a1 1 0 0 1-1.158 0L2.5 9.134zM29.668 11.333v8.457L23.46 15.56z"
    }]
  },
  rfq: {
    title: "rfq",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M9.102 11.866h2.478c.56 0 1.015.145 1.363.436.347.29.521.702.521 1.236 0 .439-.124.812-.373 1.12-.25.309-.622.552-1.12.73.623.099 1.009.495 1.157 1.187l.47 2.191h-1.761l-.257-1.909c-.046-.323-.123-.559-.23-.707-.107-.149-.271-.223-.492-.223h-.149v2.84H9.102v-6.9zm1.607 1.34v1.48h.351c.251 0 .442-.074.574-.223a.817.817 0 0 0 .198-.564c0-.23-.058-.404-.173-.52-.115-.115-.29-.172-.524-.172h-.426zm3.517-1.34h3.843v1.39h-2.235v1.435H17.9v1.345h-2.067v2.73h-1.608v-6.9zm7.795 6.777c.185.323.44.484.767.484.194 0 .402-.077.623-.232v1.256a2.311 2.311 0 0 1-.885.188c-.412 0-.748-.113-1.007-.339-.259-.226-.489-.607-.69-1.145-.748-.069-1.325-.435-1.728-1.098-.404-.663-.606-1.457-.606-2.384 0-1.118.237-2 .712-2.648.475-.648 1.091-.972 1.85-.972.765 0 1.384.316 1.857.95.473.632.71 1.511.71 2.636 0 .606-.079 1.145-.235 1.615-.157.47-.348.828-.574 1.075-.226.248-.49.452-.794.614zm-.945-5.441c-.313 0-.555.193-.727.579-.171.385-.257.896-.257 1.533 0 .653.087 1.167.26 1.543.173.376.406.564.7.564.297 0 .529-.195.697-.584.168-.389.252-.907.252-1.553 0-.666-.089-1.18-.267-1.54-.178-.362-.397-.542-.658-.542z",
      id: "a"
    }, {
      d: "M2.5 24.79v-8.457l6.207 4.228zM29.668 27.165v.833a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1v-.833l7.287-5.042 5.724 4a1 1 0 0 0 1.146 0l5.724-4 7.287 5.042zM29.668 16.333v8.457L23.46 20.56z"
    }, {
      d: "M4.776 13.057l-2.296 2.37v-3.035a2 2 0 0 1 .848-1.635l11.6-8.17a2 2 0 0 1 2.304 0l11.6 8.17a2 2 0 0 1 .848 1.635v3.416l-2.24-2.774-11.416-7.928-11.248 7.951z",
      fillRule: "nonzero"
    }]
  },
  "company-contacts": {
    title: "company-contacts",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M5 28h3a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H5v-4h3a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H5v-4h3a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5V3a1 1 0 0 1 1-1h21a1 1 0 0 1 1 1v26a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1zM2 8V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm0 9v-1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm0 9v-1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm21.197-10.5c0-.855-.2-1.623-.6-2.303-.4-.68-.979-1.212-1.735-1.596-.756-.385-1.65-.578-2.68-.578-1.145 0-2.147.26-3.006.78A5.197 5.197 0 0 0 13.2 13.92c-.457.892-.685 1.884-.685 2.974 0 .964.2 1.832.6 2.601.4.77 1.007 1.376 1.82 1.82.812.443 1.806.664 2.982.664.797 0 1.567-.13 2.311-.39.745-.259 1.365-.625 1.86-1.098l-.655-.85a5.694 5.694 0 0 1-1.664.897 5.743 5.743 0 0 1-1.793.275c-.872 0-1.62-.162-2.245-.486a3.326 3.326 0 0 1-1.423-1.374c-.325-.592-.487-1.278-.487-2.06 0-.898.185-1.703.554-2.414.37-.71.882-1.266 1.538-1.667.656-.4 1.4-.6 2.232-.6 1.168 0 2.084.29 2.749.87.664.58.996 1.386.996 2.417a3.89 3.89 0 0 1-.273 1.482c-.181.446-.432.791-.753 1.038a1.658 1.658 0 0 1-.41.257c-.125.051-.252.077-.38.077a.39.39 0 0 1-.232-.065c-.06-.043-.091-.137-.091-.281 0-.13.031-.309.094-.54l1.06-3.89h-1.564l-.153.492a.904.904 0 0 0-.433-.512 1.473 1.473 0 0 0-.71-.167c-.558 0-1.081.171-1.57.515-.488.344-.878.823-1.171 1.439-.293.615-.44 1.315-.44 2.1 0 .633.175 1.147.525 1.541.35.395.815.592 1.397.592.328 0 .624-.057.888-.173.263-.115.52-.325.77-.63.063.29.208.496.437.619.228.123.534.184.917.184.25 0 .514-.044.794-.132.28-.088.552-.22.817-.395h-.012a3.523 3.523 0 0 0 1.33-1.468 4.604 4.604 0 0 0 .47-2.083z"
    }, {
      d: "M17.15 18.477a.822.822 0 0 0 .528-.194c.16-.129.295-.297.404-.504.227-.367.397-.781.513-1.242.115-.46.173-.83.173-1.107 0-.297-.05-.518-.15-.662-.1-.145-.27-.217-.513-.217-.27 0-.53.134-.782.401-.252.268-.456.634-.612 1.099a4.755 4.755 0 0 0-.234 1.523c0 .602.224.903.673.903z"
    }]
  },
  video: {
    title: "video",
    path: {
      d: "M2 23V9a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zM23 12.848v7.287l5.522 3.004A1 1 0 0 0 30 22.26V10.723a1 1 0 0 0-1.478-.878L23 12.848z"
    }
  },
  "arrow-default-right": {
    title: "arrow-default-right",
    path: {
      d: "M18.895 6.306L17.783 7.43a1 1 0 0 0 .003 1.41l5.284 5.282H3a1 1 0 0 0-1 1v1.893a1 1 0 0 0 1 1h20.068L17.781 23.3a1 1 0 0 0 0 1.414l1.115 1.115a1 1 0 0 0 1.417-.003l8.988-9.054a1 1 0 0 0 0-1.409l-8.986-9.057a1 1 0 0 0-1.42 0z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "arrow-default-down": {
    title: "arrow-default-down",
    path: {
      d: "M25.758 18.264l-1.122-1.112a1 1 0 0 0-1.412.003l-5.28 5.284V2.369a1 1 0 0 0-1-1H15.05a1 1 0 0 0-1 1v20.068L8.764 17.15a1 1 0 0 0-1.414 0l-1.115 1.115a1 1 0 0 0 .003 1.416l9.054 8.989a1 1 0 0 0 1.409 0l9.057-8.986a1 1 0 0 0 0-1.42z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "arrow-default-left": {
    title: "arrow-default-left",
    path: {
      d: "M13.105 25.832l1.112-1.122a1 1 0 0 0-.003-1.411L8.93 18.018H29a1 1 0 0 0 1-1v-1.893a1 1 0 0 0-1-1H8.932l5.287-5.286a1 1 0 0 0 0-1.415L13.104 6.31a1 1 0 0 0-1.417.002L2.7 15.366a1 1 0 0 0 0 1.409l8.986 9.057a1 1 0 0 0 1.42 0z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "arrow-default-up": {
    title: "arrow-default-up",
    path: {
      d: "M6.242 13.075l1.122 1.112a1 1 0 0 0 1.412-.003l5.28-5.284v20.07a1 1 0 0 0 1 1h1.893a1 1 0 0 0 1-1V8.902l5.287 5.287a1 1 0 0 0 1.414 0l1.115-1.115a1 1 0 0 0-.003-1.417L16.708 2.67a1 1 0 0 0-1.409 0l-9.057 8.986a1 1 0 0 0 0 1.42z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "arrow-nav-right": {
    title: "arrow-nav-right",
    path: {
      d: "M5.203 28.521l3.736-11.878L5.16 4.116a1 1 0 0 1 1.481-1.14l20.372 12.509a1 1 0 0 1 0 1.704L6.68 29.674a1 1 0 0 1-1.477-1.153z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "arrow-nav-down": {
    title: "arrow-nav-down",
    path: {
      d: "M3.879 3.803l11.878 3.736 12.527-3.78a1 1 0 0 1 1.14 1.481L16.916 25.612a1 1 0 0 1-1.704 0L2.726 5.28A1 1 0 0 1 3.88 3.803z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "arrow-nav-left": {
    title: "arrow-nav-left",
    path: {
      d: "M26.597 28.521l-3.736-11.878 3.78-12.527a1 1 0 0 0-1.481-1.14L4.788 15.484a1 1 0 0 0 0 1.704L25.12 29.674a1 1 0 0 0 1.477-1.153z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "arrow-nav-up": {
    title: "arrow-nav-up",
    path: {
      d: "M27.921 26.197l-11.878-3.736-12.527 3.78a1 1 0 0 1-1.14-1.481L14.884 4.388a1 1 0 0 1 1.704 0L29.074 24.72a1 1 0 0 1-1.153 1.477z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "cert-available-to-download": {
    title: "cert-available-to-download",
    path: {
      d: "M16.974 22.762c.913.218 1.511.22 2.347-.094.812-.304 1.288-.714 1.93-1.486l1.511-.55 2.743 7.536a.25.25 0 0 1-.324.32l-3.298-1.253-1.72 3.08a.25.25 0 0 1-.454-.037l-2.735-7.516zM9.98 21.026c.788.957 1.24 1.366 2.143 1.666.842.281 1.408.251 2.438.002l.13.047-2.742 7.537a.25.25 0 0 1-.453.036l-1.721-3.08-3.298 1.253a.25.25 0 0 1-.324-.319l2.743-7.536 1.084.394zM23.956 9.008c.293.88 1.231 1.7 1.231 2.698 0 .996-.997 1.817-1.231 2.697-.235.88 0 2.111-.587 2.932-.586.821-1.818.88-2.58 1.408-.762.527-1.232 1.7-2.17 2.052-.938.352-1.935-.352-2.932-.352-.997 0-2.052.645-2.932.352-.88-.293-1.407-1.466-2.17-2.052-.762-.587-2.052-.645-2.58-1.408-.528-.762-.235-1.994-.586-2.932-.352-.938-1.232-1.76-1.232-2.756 0-.997.997-1.818 1.232-2.698.234-.88 0-2.11.586-2.932.586-.82 1.818-.88 2.58-1.466.763-.586 1.232-1.642 2.17-1.935.938-.293 1.935.352 2.932.352.997 0 2.053-.645 2.932-.352.88.293 1.408 1.466 2.17 1.994s2.052.645 2.58 1.407c.528.763.293 2.053.587 2.991zm-3.451-1.89a.48.48 0 0 0-.677.046l-5.964 6.841-2.133-1.165a.495.495 0 0 0-.624.74l2.266 2.852a1.027 1.027 0 0 0 1.667-.082l.074-.116 5.478-8.495a.479.479 0 0 0-.087-.621z"
    }
  },
  "cert-3rd-party-sourced": {
    title: "cert-3rd-party-sourced",
    path: {
      d: "M28.558 11.668c.438 1.315 1.84 2.542 1.84 4.032 0 1.49-1.49 2.717-1.84 4.032-.35 1.315 0 3.155-.876 4.383-.877 1.227-2.718 1.314-3.857 2.103-1.14.789-1.84 2.542-3.243 3.068-1.402.526-2.893-.526-4.383-.526-1.49 0-3.067.964-4.382.526-1.315-.438-2.104-2.191-3.243-3.068-1.14-.876-3.068-.964-3.857-2.103-.789-1.14-.35-2.98-.876-4.383C3.315 18.33 2 17.102 2 15.612c0-1.49 1.49-2.717 1.84-4.032.351-1.314 0-3.155.877-4.382.877-1.227 2.717-1.315 3.857-2.191 1.14-.877 1.84-2.455 3.243-2.893 1.402-.438 2.892.526 4.382.526 1.49 0 3.068-.964 4.383-.526 1.315.438 2.104 2.191 3.243 2.98 1.14.79 3.068.965 3.857 2.104.788 1.14.438 3.068.876 4.47zm-10.834 4.347h-3.3a2.448 2.448 0 0 0-2.436 2.437v2.11h8.173v-2.11c0-1.337-1.1-2.437-2.437-2.437zm-5.26-.238a2.195 2.195 0 0 0-1.22-.386H8.333a2.13 2.13 0 0 0-2.14 2.14v1.872h4.904v-.95c0-1.1.535-2.081 1.367-2.676zm11.204-.386h-2.913c-.416 0-.802.119-1.13.327a3.323 3.323 0 0 1 1.427 2.734v.951h4.756v-1.872a2.13 2.13 0 0 0-2.14-2.14zm-7.609-.267a2.675 2.675 0 1 0 0-5.35 2.675 2.675 0 0 0 0 5.35zm6.152-.625a2.348 2.348 0 1 0 0-4.695 2.348 2.348 0 0 0 0 4.695zm-12.422 0a2.348 2.348 0 1 0 0-4.695 2.348 2.348 0 0 0 0 4.695z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "cert-self-reported": {
    title: "cert-self-reported",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M28.558 11.668c.438 1.315 1.84 2.542 1.84 4.032 0 1.49-1.49 2.717-1.84 4.032-.35 1.315 0 3.155-.876 4.383-.877 1.227-2.718 1.314-3.857 2.103-1.14.789-1.84 2.542-3.243 3.068-1.402.526-2.893-.526-4.383-.526-1.49 0-3.067.964-4.382.526-1.315-.438-2.104-2.191-3.243-3.068-1.14-.876-3.068-.964-3.857-2.103-.789-1.14-.35-2.98-.876-4.383C3.315 18.33 2 17.102 2 15.612c0-1.49 1.49-2.717 1.84-4.032.351-1.314 0-3.155.877-4.382.877-1.227 2.717-1.315 3.857-2.191 1.14-.877 1.84-2.455 3.243-2.893 1.402-.438 2.892.526 4.382.526 1.49 0 3.068-.964 4.383-.526 1.315.438 2.104 2.191 3.243 2.98 1.14.79 3.068.965 3.857 2.104.788 1.14.438 3.068.876 4.47zM8 15.43c0 2.059 1.327 3.74 3.317 4.916L9.66 24l4.56-2.308c.62.11 1.617.163 2.281.163 4.695 0 8.5-2.873 8.5-6.425C25 11.88 21.195 9 16.5 9S8 11.879 8 15.43z"
    }, {
      d: "M13.713 14.4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM16.835 14.4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM19.957 14.4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
    }]
  },
  add: {
    title: "add",
    path: {
      d: "M13.712 13.712H7.5a1 1 0 0 0-1 1v2.6a1 1 0 0 0 1 1h6.212v6.212a1 1 0 0 0 1 1h2.6a1 1 0 0 0 1-1v-6.212h6.212a1 1 0 0 0 1-1v-2.6a1 1 0 0 0-1-1h-6.212V7.5a1 1 0 0 0-1-1h-2.6a1 1 0 0 0-1 1v6.212zM30 16c0 2.54-.626 4.882-1.878 7.027a13.937 13.937 0 0 1-5.095 5.095C20.882 29.374 18.54 30 16 30s-4.882-.626-7.027-1.878a13.937 13.937 0 0 1-5.095-5.095C2.626 20.882 2 18.54 2 16s.626-4.882 1.878-7.027a13.937 13.937 0 0 1 5.095-5.095C11.118 2.626 13.46 2 16 2s4.882.626 7.027 1.878a13.937 13.937 0 0 1 5.095 5.095C29.374 11.118 30 13.46 30 16z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "delete": {
    title: "delete",
    path: {
      d: "M30 16c0 2.54-.626 4.882-1.878 7.027a13.937 13.937 0 0 1-5.095 5.095C20.882 29.374 18.54 30 16 30s-4.882-.626-7.027-1.878a13.937 13.937 0 0 1-5.095-5.095C2.626 20.882 2 18.54 2 16s.626-4.882 1.878-7.027a13.937 13.937 0 0 1 5.095-5.095C11.118 2.626 13.46 2 16 2s4.882.626 7.027 1.878a13.937 13.937 0 0 1 5.095 5.095C29.374 11.118 30 13.46 30 16zM7.828 13.75a1 1 0 0 0-1 1v2.435a1 1 0 0 0 1 1h16.344a1 1 0 0 0 1-1V14.75a1 1 0 0 0-1-1H7.828z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "folder-close": {
    title: "folder-close",
    path: {
      d: "M5 7h5.965a1 1 0 0 1 .64.232l2.145 1.787h14.29a1 1 0 0 1 1 1v15.116a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "folder-open": {
    title: "folder-open",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M30.247 15.309l-2.6 10.923a1 1 0 0 1-.973.768H4.317a1 1 0 0 1-.966-1.26l2.952-10.923a1 1 0 0 1 .966-.74h22.005a1 1 0 0 1 .973 1.232z",
      fillRule: "nonzero"
    }, {
      d: "M3 6h5.965a1 1 0 0 1 .64.232l2.145 1.787h14.29a1 1 0 0 1 1 1v3.039H5.794a1 1 0 0 0-.965.739L2 23.267V7a1 1 0 0 1 1-1z"
    }]
  },
  categories: {
    title: "categories",
    g: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    path: [{
      d: "M28.77 22.693V8.16a1 1 0 0 0-1-1H12.977L10.76 5.315a1 1 0 0 0-.64-.232H5V4a1 1 0 0 1 1-1h6.12a1 1 0 0 1 .64.232l2.216 1.846H29.77a1 1 0 0 1 1 1v15.615a1 1 0 0 1-1 1h-1z"
    }, {
      d: "M2 6.806h6.12a1 1 0 0 1 .64.231l2.216 1.847h14.793a1 1 0 0 1 1 1v15.614a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7.806a1 1 0 0 1 1-1z"
    }]
  },
  pdf: {
    title: "pdf",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M26.938 7.674c.291.278.541.656.75 1.134.208.478.312.916.312 1.314v17.2c0 .398-.146.736-.438 1.015a1.481 1.481 0 0 1-1.062.418h-21c-.417 0-.77-.14-1.063-.418A1.352 1.352 0 0 1 4 27.322V3.433c0-.398.146-.736.438-1.015A1.481 1.481 0 0 1 5.5 2h14c.417 0 .875.1 1.375.299.5.199.896.438 1.188.716l4.875 4.659zm-8.97 10.316c-.947-.736-1.708-1.92-2.28-3.553.124-.687.197-1.642.218-2.867v-.448c0-.05-.005-.09-.015-.119a.32.32 0 0 0 .062-.12c.094-.467.047-.806-.14-1.015-.126-.149-.308-.224-.547-.224h-.344c-.323 0-.542.2-.656.598-.136.497-.17 1.132-.102 1.903.068.772.227 1.565.477 2.382-.375 1.254-.917 2.558-1.625 3.911a36.028 36.028 0 0 1-1.672 2.942c0-.02-.01-.04-.031-.06-.094-.15-.214-.18-.36-.09-.885.448-1.573.928-2.062 1.441-.49.513-.782.968-.875 1.366-.042.259-.01.438.093.538.052.04.084.064.094.074l.375.18c.136.07.281.104.438.104.927 0 2.187-1.304 3.78-3.912 1.782-.587 3.824-1 6.126-1.239.656.328 1.333.592 2.031.791.698.2 1.297.299 1.797.299.677 0 1.047-.19 1.11-.567v-.015l.03-.03c.011-.01.016-.02.016-.03.146-.299.136-.557-.031-.776-.313-.488-1.234-.732-2.766-.732-.604 0-1.213.035-1.828.104a11.943 11.943 0 0 1-1.312-.836z",
      fillRule: "nonzero"
    }, {
      d: "M8.969 24.127c.541-.24 1.255-1.026 2.14-2.36a8.744 8.744 0 0 0-1.367 1.255c-.38.438-.638.806-.773 1.105zM15.188 10.39c-.157.419-.167 1.076-.032 1.972.01-.07.047-.289.11-.657 0-.03.036-.244.109-.642a.33.33 0 0 1 .063-.12c-.01-.01-.016-.02-.016-.03a.111.111 0 0 1-.016-.044.837.837 0 0 0-.203-.538c0 .01-.005.02-.015.03v.03zM23.344 20.02c-.25-.238-.98-.357-2.188-.357.792.278 1.438.418 1.938.418.146 0 .24-.005.281-.015 0-.01-.01-.025-.031-.045zM13.25 20.26a23.744 23.744 0 0 1 4.438-1.21 2.362 2.362 0 0 1-.204-.141 2.765 2.765 0 0 1-.25-.202c-.791-.667-1.453-1.543-1.984-2.628-.281.856-.714 1.837-1.297 2.942-.312.557-.547.97-.703 1.239z"
    }]
  },
  "image-file": {
    title: "image-file",
    path: {
      d: "M26.672 7.938c.288.291.535.687.741 1.187.206.5.31.958.31 1.375v18c0 .417-.145.77-.433 1.063a1.421 1.421 0 0 1-1.05.437H5.483c-.412 0-.762-.146-1.05-.438A1.455 1.455 0 0 1 4 28.5v-25c0-.417.144-.77.432-1.063A1.421 1.421 0 0 1 5.482 2h13.839c.411 0 .864.104 1.359.313.494.208.885.458 1.173.75l4.819 4.874zM23.769 21l-4.943-5-5.93 6-1.977-2-2.965 3v3h15.815v-5zm-12.85-3c.824 0 1.524-.292 2.1-.875.577-.583.865-1.292.865-2.125s-.288-1.542-.865-2.125a2.843 2.843 0 0 0-2.1-.875c-.824 0-1.524.292-2.1.875-.577.583-.865 1.292-.865 2.125s.288 1.542.865 2.125a2.843 2.843 0 0 0 2.1.875z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  excel: {
    title: "excel",
    path: {
      d: "M26.938 7.674c.291.278.541.656.75 1.134.208.478.312.916.312 1.314v17.2c0 .398-.146.736-.438 1.015a1.481 1.481 0 0 1-1.062.418h-21c-.417 0-.77-.14-1.063-.418A1.352 1.352 0 0 1 4 27.322V3.433c0-.398.146-.736.438-1.015A1.481 1.481 0 0 1 5.5 2h14c.417 0 .875.1 1.375.299.5.199.896.438 1.188.716l4.875 4.659zM10.466 22.546v1.596h4.235v-1.596h-1.13l1.553-2.426c.05-.07.1-.153.15-.248.05-.096.089-.163.113-.204.025-.04.043-.06.053-.06h.03c.01.04.036.09.076.15.02.04.043.078.067.114l.09.12.1.128 1.612 2.426H16.27v1.596h4.387v-1.596h-1.025l-2.895-4.113 2.94-4.25h1.01v-1.611h-4.206v1.612h1.116l-1.553 2.395a6.825 6.825 0 0 1-.287.452l-.03.045h-.03a.521.521 0 0 0-.075-.15 1.87 1.87 0 0 0-.256-.347l-1.598-2.395h1.146v-1.612h-4.372v1.612h1.026l2.848 4.098-2.925 4.264h-1.025z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "top-page": {
    title: "top-page",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M24.026 10.301c.267.26.497.614.688 1.06.19.447.286.856.286 1.228v16.072c0 .372-.134.688-.401.948s-.592.391-.974.391H4.375c-.382 0-.707-.13-.974-.39A1.275 1.275 0 0 1 3 28.66V6.34c0-.373.134-.689.401-.95.267-.26.592-.39.974-.39h12.833c.382 0 .802.093 1.26.279.46.186.822.41 1.09.67l4.468 4.352zM6 17v2h16v-2H6zm0 4v2h16v-2H6zm0 4v2h16v-2H6z"
    }, {
      d: "M27.167 26V12.293c0-.644-.153-1.297-.437-1.962-.282-.659-.643-1.216-1.098-1.659l-4.469-4.353c-.451-.44-1.013-.785-1.677-1.055-.664-.269-1.311-.412-1.944-.412H7v-.513c0-.372.134-.688.401-.948S7.993 1 8.375 1h11.917c.382 0 .802.093 1.26.279.458.186.821.41 1.089.67l5.385 5.278c.267.26.497.614.688 1.06.19.447.286.856.286 1.228v15.146c0 .372-.134.688-.401.948s-.592.391-.974.391h-.458z"
    }]
  },
  "zip-file": {
    title: "zip-file",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M9 2v1.214h1.25V4.43H9v1.214h1.25v1.214H9v1.214h1.25v1.215H9V10.5h1.25v1.214c-.691 0-1.25.543-1.25 1.215v4.857C9 18.457 9.559 19 10.25 19h2.5c.691 0 1.25-.543 1.25-1.214v-4.857c0-.672-.559-1.215-1.25-1.215V9.286H14V8.07h-1.25V6.857H14V5.643h-1.25V4.429H14V3.214h-1.25V2h6.57c.412 0 .865.104 1.36.313.494.208.885.458 1.173.75l4.819 4.875c.288.291.535.687.741 1.187.206.5.31.958.31 1.375v18c0 .417-.145.77-.433 1.063a1.421 1.421 0 0 1-1.05.437H5.483c-.412 0-.762-.146-1.05-.438A1.455 1.455 0 0 1 4 28.5v-25c0-.417.144-.77.432-1.063A1.421 1.421 0 0 1 5.482 2H9z"
    }, {
      d: "M10 15h3v3h-3z"
    }]
  },
  "entry-page": {
    title: "entry-page",
    g: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    path: [{
      d: "M19.705 27.053h6.348V4.947h-6.348a1 1 0 0 1-1-1v-.814a1 1 0 0 1 1-1h8.162a1 1 0 0 1 1 1v25.734a1 1 0 0 1-1 1h-8.162a1 1 0 0 1-1-1v-.814a1 1 0 0 1 1-1z"
    }, {
      d: "M3.61 13.92c-.382 0-.595.411-.595.792v2.576c0 .381.213.792.595.792h7.379v3.763a1 1 0 0 0 1.624.781l7.304-5.843a1 1 0 0 0 0-1.562l-7.304-5.843a1 1 0 0 0-1.624.78v3.764h-7.38z"
    }]
  },
  "exit-page": {
    title: "exit-page",
    g: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    path: [{
      d: "M11.434 13.92c-.381 0-.594.411-.594.792v2.576c0 .381.213.792.594.792h7.38v3.763a1 1 0 0 0 1.624.781l7.304-5.843a1 1 0 0 0 0-1.562l-7.304-5.843a1 1 0 0 0-1.625.78v3.764h-7.379z"
    }, {
      d: "M11.948 27.134H5.599V5.028h6.349a1 1 0 0 0 1-1v-.814a1 1 0 0 0-1-1H3.786a1 1 0 0 0-1 1v25.734a1 1 0 0 0 1 1h8.162a1 1 0 0 0 1-1v-.814a1 1 0 0 0-1-1z"
    }]
  },
  download: {
    title: "download",
    g: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    path: [{
      d: "M26.92 20v6.349H4.813V20a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8.162a1 1 0 0 0 1 1h25.733a1 1 0 0 0 1-1V20a1 1 0 0 0-1-1h-.813a1 1 0 0 0-1 1z"
    }, {
      d: "M13.787 3.743c0-.381.41-.594.792-.594h2.576c.38 0 .792.213.792.594v7.38h3.763a1 1 0 0 1 .78 1.624l-5.842 7.304a1 1 0 0 1-1.562 0l-5.843-7.304a1 1 0 0 1 .78-1.625h3.764v-7.38z"
    }]
  },
  upload: {
    title: "upload",
    g: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    path: [{
      d: "M26.92 20v6.349H4.813V20a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8.162a1 1 0 0 0 1 1h25.733a1 1 0 0 0 1-1V20a1 1 0 0 0-1-1h-.813a1 1 0 0 0-1 1z"
    }, {
      d: "M13.787 20.432c0 .382.41.595.792.595h2.576c.38 0 .792-.213.792-.595v-7.379h3.763a1 1 0 0 0 .78-1.624l-5.842-7.304a1 1 0 0 0-1.562 0l-5.843 7.304a1 1 0 0 0 .78 1.624h3.764v7.38z"
    }]
  },
  "external-link": {
    title: "external-link",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M4.003 5L4 8.004v15.992L4.004 27a1 1 0 0 0 1 1h21.992a1 1 0 0 0 1-1L28 23.997v-4.663l-3-3.318.005 8.984H6.995V7H16l-3.333-3-7.663.001a1 1 0 0 0-1 1z"
    }, {
      d: "M18.255 16.228c-.279.26-.715.104-.975-.175l-1.756-1.883c-.26-.28-.385-.725-.106-.985l5.396-5.033L18.248 5.4a1 1 0 0 1 .656-1.679l9.327-.707a1 1 0 0 1 1.065 1.142l-1.357 9.254a1 1 0 0 1-1.72.537l-2.567-2.752-5.397 5.033z",
      fillRule: "nonzero"
    }]
  },
  "product-line": {
    title: "product-line",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M29.63 19.282a2.25 2.25 0 0 0-.644-1.852L15.99 4.433a4.006 4.006 0 0 0-2.882-1.191l-6.45.06a3.375 3.375 0 0 0-.515.045A3.21 3.21 0 0 1 8.93 1.69l6.228-.059a3.868 3.868 0 0 1 2.783 1.15l12.548 12.55a2.198 2.198 0 0 1-.018 3.11l-.84.84z"
    }, {
      d: "M5.843 8.034a1.541 1.541 0 0 1 2.18-.017 1.54 1.54 0 0 1-.018 2.179c-.607.606-1.583.614-2.18.018a1.542 1.542 0 0 1 .018-2.18M3.561 5.752a3.21 3.21 0 0 1 2.248-.941l6.227-.059a3.868 3.868 0 0 1 2.783 1.15l12.55 12.55a2.198 2.198 0 0 1-.02 3.11l-7.986 7.987a2.197 2.197 0 0 1-3.11.018L3.704 17.018a3.868 3.868 0 0 1-1.15-2.783l.059-6.228c.008-.875.37-1.676.948-2.255zM18.876 13.4l-1.148.77a4.796 4.796 0 0 0-.787-.314l-.235-1.368a.302.302 0 0 0-.283-.22h-1.384a.302.302 0 0 0-.283.22l-.252 1.352a3.35 3.35 0 0 0-.77.33l-1.148-.801c-.095-.063-.268-.048-.363.047l-.959.959c-.094.094-.11.268-.047.362l.786 1.132a5.336 5.336 0 0 0-.345.818l-1.369.267c-.125 0-.236.142-.236.268l.016 1.368c0 .126.094.252.22.283l1.384.252c.063.283.189.534.315.786l-.771 1.148c-.078.11-.078.267.016.361l.975.975c.094.095.251.095.361.016l1.149-.77c.251.125.519.236.802.33l.251 1.352c.032.126.142.236.268.236h1.384a.27.27 0 0 0 .267-.236l.267-1.368c.267-.078.535-.189.803-.33l1.132.786c.094.064.267.047.346-.031l.975-.975c.094-.094.11-.267.047-.362l-.802-1.147c.125-.253.251-.504.33-.771l1.337-.268a.27.27 0 0 0 .236-.267l-.016-1.368c.015-.142-.094-.252-.22-.283l-1.353-.252a4.798 4.798 0 0 0-.314-.786l.77-1.148a.264.264 0 0 0-.031-.346l-.975-.975a.264.264 0 0 0-.346-.032z"
    }, {
      d: "M17.382 19.58a2.373 2.373 0 0 1-3.334 0 2.359 2.359 0 0 1 0-3.333 2.345 2.345 0 0 1 3.334 0 2.358 2.358 0 0 1 0 3.334"
    }]
  },
  product: {
    title: "product",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M8.287 8.477a1.541 1.541 0 0 1 2.18-.017 1.54 1.54 0 0 1-.019 2.18c-.607.606-1.583.614-2.18.018a1.542 1.542 0 0 1 .019-2.18M6.005 6.195a3.21 3.21 0 0 1 2.248-.941l6.227-.059a3.868 3.868 0 0 1 2.783 1.15l12.549 12.55a2.198 2.198 0 0 1-.018 3.11l-7.987 7.986a2.197 2.197 0 0 1-3.11.018L6.148 17.462a3.868 3.868 0 0 1-1.15-2.783l.058-6.228c.008-.875.37-1.677.95-2.255zm15.314 7.648l-1.148.77a4.796 4.796 0 0 0-.786-.314l-.236-1.368a.302.302 0 0 0-.283-.22h-1.384a.302.302 0 0 0-.283.22l-.252 1.352a3.35 3.35 0 0 0-.77.33l-1.148-.802c-.094-.062-.268-.047-.362.047l-.96.96c-.094.094-.11.267-.046.362l.786 1.132a5.336 5.336 0 0 0-.346.818l-1.368.267c-.126 0-.236.142-.236.267l.016 1.368c0 .126.094.252.22.284l1.384.251c.063.283.189.535.314.786l-.77 1.148c-.079.11-.079.268.015.362l.976.975c.094.095.251.095.361.016l1.149-.77c.25.125.518.235.801.33l.252 1.352c.031.126.142.236.267.236h1.384a.27.27 0 0 0 .268-.236l.267-1.368c.267-.079.535-.189.802-.33l1.132.786c.095.063.268.047.346-.032l.975-.975c.094-.094.11-.267.048-.361l-.802-1.148c.125-.252.251-.504.33-.77l1.337-.268a.27.27 0 0 0 .235-.267l-.016-1.368c.016-.142-.094-.252-.22-.284l-1.352-.251a4.798 4.798 0 0 0-.315-.786l.77-1.149a.264.264 0 0 0-.03-.346l-.976-.975a.264.264 0 0 0-.346-.031z"
    }, {
      d: "M19.977 20.338c-.999.999-2.652.999-3.65 0a2.583 2.583 0 0 1-.001-3.652 2.568 2.568 0 0 1 3.652 0 2.583 2.583 0 0 1 0 3.652"
    }]
  },
  "services-capabilities": {
    title: "services-capabilities",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M16.112 10.662l-5.134 4.766-.967-.968 2.476-2.476c.155-.155.11-.437-.092-.638-.195-.196-.487-.243-.638-.092L9.28 13.73l-1.46-1.46 1.93-1.93c.151-.151.106-.433-.095-.634-.196-.196-.486-.244-.635-.095l-1.93 1.93-1.46-1.46 2.476-2.476c.156-.156.11-.437-.091-.639-.196-.196-.488-.242-.639-.091L4.901 9.35 3.08 7.529c-.203-.203-.245-.49-.087-.648L7.38 2.49c.155-.154.438-.121.648.088l8.083 8.083zm5.229 5.229l8.58 8.58c.203.203.245.49.087.648l-4.389 4.39c-.155.154-.438.121-.648-.088L23.15 27.6l2.476-2.476c.156-.156.11-.437-.091-.639-.196-.196-.488-.242-.639-.091l-2.476 2.476-1.46-1.46 1.378-1.377c.154-.154.109-.436-.093-.638-.195-.195-.487-.243-.637-.092l-1.378 1.377-1.46-1.46 2.477-2.476c.155-.155.11-.437-.092-.638-.195-.196-.487-.243-.638-.092L18.04 22.49l-1.46-1.46-.127-.126 4.888-5.012z",
      fillRule: "nonzero"
    }, {
      d: "M11.344 15.094L3.75 7.5l7.594 7.594zm6.12 6.12L24.75 28.5l-7.285-7.285z",
      stroke: "currentColor"
    }, {
      d: "M3.165 24.641c-1.09 1.09-1.045 2.835.044 3.97 1.134 1.089 2.88 1.089 3.969-.045L20.916 14.48c1.179-1.134 1.875-1.483 2.835-1.178.96.35 2.312.35 3.577-.48 2.704-1.744 2.528-5.015 2.528-5.015l-.217-.35s-2.443 1.57-2.748 1.746c-.393.305-1.744.916-2.965-.96-1.265-1.876-.22-3.053.13-3.271.305-.175 2.747-1.788 2.747-1.788l-.218-.35s-2.835-1.439-5.495.132c0 .087-.654.48-.916.698-1.701 1.526-1.701 3.227-1.396 4.623.263 1.265 0 1.7-1.002 2.791L3.166 24.641zm1.004.916c.567-.567 1.483-.567 2.093 0 .523.567.523 1.527 0 2.05-.61.567-1.526.654-2.093.043-.567-.523-.567-1.526 0-2.093z"
    }]
  },
  cad: {
    title: "cad",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M16.553 2.22L28.5 7.512 23.03 10.22l-6.668-2.66a.482.482 0 0 0-.413-.003l-6.59 2.663-5.6-2.708 11.985-5.293a1 1 0 0 1 .81 0zM8.638 21.82a.492.492 0 0 0 .114.163.79.79 0 0 0 .098.068l5.895 2.65v5.445l-11.09-5.283a1 1 0 0 1-.57-.903V9.432l5.51 2.778v9.427c.014.1.025.142.043.182z"
    }, {
      d: "M15.094 17.1l-4.433 2.15v-6.775l4.433-2.149zM16.136 18.86l4.603 2.068-4.603 2.23-4.603-2.23z"
    }, {
      d: "M28.71 24.892l-11.203 5.284V24.73l6.012-2.65a.52.52 0 0 0 .194-.19.567.567 0 0 0 .052-.168c.004-.03.006-3.19.008-9.483l5.51-2.777v14.525a1 1 0 0 1-.573.905z"
    }, {
      d: "M21.605 12.475v6.774l-4.434-2.148v-6.775z"
    }]
  },
  catalogs: {
    title: "catalogs",
    path: {
      d: "M6.79 4.11c.356 0 .644.287.644.643v23.163a.643.643 0 0 1-.643.643H1.643A.643.643 0 0 1 1 27.916V4.753c0-.356.288-.644.643-.644h5.148zm7.722 0c.355 0 .643.287.643.643v23.163a.643.643 0 0 1-.643.643H9.364a.643.643 0 0 1-.643-.643V4.753c0-.356.288-.644.643-.644h5.148zm16.44 21.676a.643.643 0 0 1-.355.843l-4.742 1.982a.643.643 0 0 1-.843-.348l-8.917-21.38a.643.643 0 0 1 .347-.844l4.742-1.981a.643.643 0 0 1 .843.347l8.924 21.381zM6.146 27.272v-.643h-3.86v.643h3.86zm0-1.93v-1.287h-3.86v1.287h3.86zm0-18.016v-1.93h-3.86v1.93h3.86zM2.93 10.543a1.287 1.287 0 1 0 2.574 0 1.287 1.287 0 0 0-2.574 0zm10.938 16.73v-.644h-3.86v.643h3.86zm0-1.931v-1.287h-3.86v1.287h3.86zm0-18.016v-1.93h-3.86v1.93h3.86zm-3.217 3.217a1.287 1.287 0 1 0 2.574 0 1.287 1.287 0 0 0-2.574 0zm6.878-3.558l.747 1.783L21.84 7.28 21.094 5.5l-3.565 1.486zm7.676 18.408l3.565-1.486-.496-1.19-3.564 1.486.495 1.19zm.747 1.783l3.564-1.487-.25-.591-3.565 1.486.25.592zm-3.475-16.678v-.006a1.287 1.287 0 0 0-1.685-.689 1.287 1.287 0 1 0 1.685.695z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  search: {
    title: "search",
    path: {
      d: "M23.429 14.654a8.818 8.818 0 0 1-8.822 8.821 8.818 8.818 0 0 1-8.821-8.821 8.818 8.818 0 0 1 8.821-8.822 8.818 8.818 0 0 1 8.822 8.822m.278 7.103c1.625-2.09 2.507-4.596 2.507-7.15C26.214 8.2 21.014 3 14.607 3 8.2 3 3 8.2 3 14.607c0 6.407 5.2 11.607 11.607 11.607 2.6 0 5.154-.882 7.15-2.507l4.029 4.029a1 1 0 0 0 1.414 0l.536-.536a1 1 0 0 0 0-1.414l-4.029-4.029z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "zoom-in": {
    title: "zoom-in",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M13.633 13.385v-3.73a1 1 0 0 1 1-1h1.115a1 1 0 0 1 1 1v3.73h3.73a1 1 0 0 1 1 1V15.5a1 1 0 0 1-1 1h-3.73v3.73a1 1 0 0 1-1 1h-1.115a1 1 0 0 1-1-1V16.5h-3.73a1 1 0 0 1-1-1v-1.115a1 1 0 0 1 1-1h3.73z"
    }, {
      d: "M15.054 24.263a9.157 9.157 0 0 1-9.161-9.161 9.157 9.157 0 0 1 9.16-9.16 9.157 9.157 0 0 1 9.161 9.16 9.157 9.157 0 0 1-9.16 9.16zm9.45-1.784c1.687-2.17 2.603-4.774 2.603-7.425C27.107 8.4 21.707 3 15.054 3 8.4 3 3 8.4 3 15.054c0 6.653 5.4 12.053 12.054 12.053 2.7 0 5.351-.916 7.425-2.603l4.21 4.21a1 1 0 0 0 1.415 0l.61-.61a1 1 0 0 0 0-1.415l-4.21-4.21z"
    }]
  },
  "zoom-out": {
    title: "zoom-out",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M9 14h12.11v3H9z"
    }, {
      d: "M15.054 24.263a9.157 9.157 0 0 1-9.161-9.161 9.157 9.157 0 0 1 9.16-9.16 9.157 9.157 0 0 1 9.161 9.16 9.157 9.157 0 0 1-9.16 9.16zm9.45-1.784c1.687-2.17 2.603-4.774 2.603-7.425C27.107 8.4 21.707 3 15.054 3 8.4 3 3 8.4 3 15.054c0 6.653 5.4 12.053 12.054 12.053 2.7 0 5.351-.916 7.425-2.603l4.21 4.21a1 1 0 0 0 1.415 0l.61-.61a1 1 0 0 0 0-1.415l-4.21-4.21z"
    }]
  },
  checkmark: {
    title: "checkmark",
    path: {
      d: "M27.604 3.372a1.155 1.155 0 0 0-1.628.112L11.614 19.958 6.477 17.15a1.19 1.19 0 0 0-1.503 1.784l5.457 6.865a2.473 2.473 0 0 0 4.014-.198l.179-.278L27.816 4.867a1.153 1.153 0 0 0-.212-1.495z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  website: {
    title: "website",
    path: {
      d: "M29.801 16.85h-4.617c-.087 2.23-.56 4.218-1.44 6.298a17.022 17.022 0 0 1 2.86 1.684c1.837-2.155 2.963-4.97 3.197-7.982zm-4.484 9.343a16.49 16.49 0 0 0-2.387-1.34c-.908 1.646-2.121 3.157-3.608 4.52 2.276-.58 4.352-1.675 5.995-3.18zm-18.553-.058a13.404 13.404 0 0 0 5.99 3.196 17.475 17.475 0 0 1-3.605-4.53c-.962.486-1.69.889-2.385 1.334zm-1.292-1.242a17.035 17.035 0 0 1 2.862-1.683c-.897-2.171-1.357-4.09-1.444-6.296H2.272c.237 2.955 1.363 5.769 3.2 7.98zm-3.2-9.804h4.685c.103-2.01.63-4.424 1.435-6.3-1-.464-1.953-1.025-2.858-1.683-1.848 2.165-3.022 5.038-3.261 7.983zm4.554-9.34c.736.5 1.553.958 2.385 1.337.958-1.694 2.15-3.212 3.54-4.474a13.869 13.869 0 0 0-5.925 3.137zm18.433.01c-1.728-1.545-3.796-2.632-5.989-3.115 1.459 1.327 2.677 2.843 3.59 4.494 1.181-.594 1.802-.942 2.399-1.38zm-1.969 9.33c-.1-1.846-.588-3.973-1.33-5.652-1.704.548-3.344.867-5.01.947v4.705h6.34zm-1.325 7.403c.853-1.883 1.248-3.468 1.329-5.578h-6.345v4.583c1.885.143 3.55.463 5.016.995zM16.95 28.92c1.759-1.42 3.217-3.038 4.248-4.785-1.38-.489-2.68-.745-4.248-.819v5.604zm-6.068-4.787c1.056 1.743 2.543 3.406 4.243 4.786v-5.603c-1.566.074-2.865.33-4.243.817zm4.243-7.218H8.723c.134 2.199.52 3.8 1.323 5.58a17.754 17.754 0 0 1 5.078-1.005v-4.575zm-5.012-7.47c-.74 1.677-1.228 3.801-1.328 5.645h6.34v-4.705c-1.793-.081-3.442-.387-5.012-.94zm5.012-6.375c-1.691 1.324-3.172 2.981-4.18 4.724 1.445.46 2.677.694 4.18.765V3.069zm1.825 5.49c1.629-.073 2.877-.298 4.186-.756-.98-1.695-2.429-3.303-4.186-4.721v5.476zM26.6 7.107a17.021 17.021 0 0 1-2.858 1.683c.778 1.879 1.334 4.363 1.44 6.298H29.8c-.236-2.922-1.395-5.799-3.2-7.981z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  map: {
    title: "map",
    path: {
      d: "M15.956 2a9.799 9.799 0 0 0-9.8 9.8c0 2.116.684 4.542 1.835 6.16L15.956 30l7.964-12.04c1.151-1.618 1.836-4.013 1.836-6.16 0-5.413-4.387-9.8-9.8-9.8zm0 13.533a3.744 3.744 0 0 1-3.734-3.733 3.744 3.744 0 0 1 3.734-3.733 3.744 3.744 0 0 1 3.733 3.733 3.744 3.744 0 0 1-3.733 3.733z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  open: {
    title: "open",
    path: {
      d: "M12.615 12.615V3a1 1 0 0 1 1-1h4.77a1 1 0 0 1 1 1v9.615H29a1 1 0 0 1 1 1v4.77a1 1 0 0 1-1 1h-9.615V29a1 1 0 0 1-1 1h-4.77a1 1 0 0 1-1-1v-9.615H3a1 1 0 0 1-1-1v-4.77a1 1 0 0 1 1-1h9.615z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  close: {
    title: "close",
    path: {
      d: "M11.213 16L4.414 9.2a1 1 0 0 1 0-1.413l3.373-3.373a1 1 0 0 1 1.414 0l6.799 6.8 6.8-6.8a1 1 0 0 1 1.413 0l3.373 3.373a1 1 0 0 1 0 1.414L20.786 16l6.8 6.8a1 1 0 0 1 0 1.413l-3.373 3.373a1 1 0 0 1-1.414 0L16 20.786l-6.8 6.8a1 1 0 0 1-1.413 0l-3.373-3.373a1 1 0 0 1 0-1.414l6.8-6.799z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "copy-clipboard": {
    title: "copy-clipboard",
    path: {
      d: "M15.222 2c-1.227 0-2.236 1.028-2.236 2.28v.976h-1.248l-.798 1.302h8.565l-.799-1.302h-1.248v-.977C17.458 3.028 16.45 2 15.222 2zm0 1.302c.542 0 .959.425.959.977v.977h-1.917v-.977c0-.552.416-.977.958-.977zM5 6.907V29a1 1 0 0 0 1 1h18.444a1 1 0 0 0 1-1v-2.581h-10.86c-.335 0-.64-.31-.64-.652V12.093a.67.67 0 0 1 .58-.651h9.643a.64.64 0 0 1 .449.183l.828.844V6.907a1 1 0 0 0-1-1h-3.841l.589.957c.123.2.13.452.018.66a.637.637 0 0 1-.557.336H9.792a.637.637 0 0 1-.558-.336.662.662 0 0 1 .018-.66l.59-.957H6a1 1 0 0 0-1 1zm10.222 6.837v10.372a1 1 0 0 0 1 1H27a1 1 0 0 0 1-1v-6.163h-4.472c-.335 0-.64-.31-.64-.65v-4.559h-6.666a1 1 0 0 0-1 1zm8.945-.735v3.642h3.574l-3.574-3.642zm-6.479 3.642h.03a.616.616 0 0 1 .06 0h3.194c.338-.005.649.307.649.651 0 .344-.311.656-.649.651h-3.194c-.335.025-.655-.27-.679-.61-.024-.34.255-.668.589-.692zm0 2.605h.03a.616.616 0 0 1 .06 0h7.666c.338-.005.65.307.65.651 0 .344-.312.656-.65.651h-7.666c-.335.024-.655-.27-.679-.61-.024-.341.255-.668.589-.692zm0 2.604h.03a.616.616 0 0 1 .06 0h7.666c.338-.004.65.307.65.652 0 .344-.312.656-.65.65h-7.666c-.335.025-.655-.269-.679-.61-.024-.34.255-.667.589-.692z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  blockquote: {
    title: "blockquote",
    path: {
      d: "M29.897 14.59c.26 0 .471.216.471.48V26.52a.477.477 0 0 1-.473.48H18.56a.478.478 0 0 1-.474-.48l-.012-11.93C18.333 9.805 22.255 6 27.06 6c.261 0 .473.217.473.474v3.822a.476.476 0 0 1-.472.476h-.001c-2.19 0-3.995 1.67-4.23 3.818h7.068zm-16.076 0c.26 0 .472.216.472.48V26.52a.477.477 0 0 1-.474.48H2.486a.478.478 0 0 1-.475-.48L2 14.591C2.258 9.805 6.18 6 10.983 6c.262 0 .473.217.473.474v3.822a.476.476 0 0 1-.472.476c-2.191 0-3.995 1.67-4.23 3.818h7.067z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "help-info": {
    title: "help-info",
    path: {
      d: "M21.096 15.227a6.54 6.54 0 0 1-2.262 1.975c-.515.344-.858.687-1.03 1.088-.115.258-.2.601-.258 1.002-.029.315-.315.545-.63.545h-2.777a.624.624 0 0 1-.63-.66c.057-.772.258-1.373.573-1.832.4-.544 1.116-1.202 2.147-1.918a3.987 3.987 0 0 0 1.26-1.23c.315-.488.458-1.06.458-1.719 0-.658-.172-1.202-.544-1.603-.372-.4-.859-.601-1.518-.601a1.99 1.99 0 0 0-1.345.487c-.23.2-.372.458-.458.801-.115.401-.487.659-.916.659l-2.577-.058a.558.558 0 0 1-.544-.6c.086-1.375.63-2.406 1.575-3.15 1.087-.83 2.49-1.26 4.265-1.26 1.89 0 3.379.487 4.467 1.432 1.087.945 1.632 2.233 1.632 3.865 0 1.03-.315 1.947-.888 2.777zm-3.579 8.703c0 .487-.4.888-.887.888h-2.262a.892.892 0 0 1-.888-.888v-1.46c0-.486.401-.887.888-.887h2.262c.487 0 .887.4.887.887v1.46zM16 2C8.27 2 2 8.27 2 16s6.27 14 14 14 14-6.27 14-14S23.73 2 16 2z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  assets: {
    title: "assets",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M9.5 5.15V7.1h14.49a1 1 0 0 1 1 1v15.594h2a1 1 0 0 0 1-1V5.15a1 1 0 0 0-1-1H10.5a1 1 0 0 0-1 1z",
      fillRule: "nonzero"
    }, {
      d: "M21.818 28H6a1 1 0 0 1-1-1V9.912a1 1 0 0 1 1-1h15.818a1 1 0 0 1 1 1V27a1 1 0 0 1-1 1z"
    }]
  },
  "failed-retry": {
    title: "failed-retry",
    path: {
      d: "M29.546 25.249L17.898 5.083c-.644-1.112-2.254-1.112-2.898 0L3.351 25.249c-.644 1.112.147 2.517 1.434 2.517h23.298a1.676 1.676 0 0 0 1.463-2.517zm-13.463-13.99c.702-.176 1.405.175 1.727.819.117.234.146.498.117.732a53.757 53.757 0 0 0-.117 2.224c-.059 1.142-.147 2.312-.205 3.454-.03.351-.03.702-.059 1.083-.029.614-.497 1.083-1.112 1.083a1.12 1.12 0 0 1-1.112-1.054c-.088-1.785-.205-3.57-.293-5.356-.029-.468-.058-.966-.088-1.434 0-.703.469-1.376 1.142-1.551zm.38 13.404c-.82 0-1.463-.673-1.463-1.492 0-.82.673-1.493 1.493-1.493.82 0 1.463.673 1.463 1.522-.03.79-.702 1.463-1.493 1.463z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  print: {
    title: "print",
    g: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    path: [{
      d: "M9.06 3h14a1 1 0 0 1 1 1v3h-16V4a1 1 0 0 1 1-1zM28.954 9H3.046a1 1 0 0 0-1 1v12.326a1 1 0 0 0 1 1h2.97v-5.318h19.848v5.318h3.09a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1zm-.908 3.845h-3v-2h3v2z"
    }, {
      d: "M8 20h16v9H8z"
    }]
  },
  more: {
    title: "more",
    path: {
      d: "M5.39 13.172a3.287 3.287 0 1 1 0 6.574 3.287 3.287 0 0 1 0-6.574M16.353 13.172a3.287 3.287 0 1 1 0 6.574 3.287 3.287 0 0 1 0-6.574M27.11 13.092a3.287 3.287 0 1 1 0 6.573 3.287 3.287 0 0 1 0-6.573"
    }
  },
  sent: {
    title: "sent",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M10.364 11.21a3 3 0 0 0 1.317.305h.353v1.397H8.772l-2.174 8.553h5.029c.29 0 .61.297.61.562v.001c.294 1.594 1.758 2.758 3.47 2.759 1.735 0 3.177-1.188 3.468-2.75.079-.287.314-.572.628-.572h5.082l-2.24-8.553H19.19v-1.397h.353c.473 0 .92-.11 1.319-.305h3.181c.158 0 .295.1.334.244l2.971 11.034a.303.303 0 0 1 .009.13.291.291 0 0 1 .003.042v6.878c0 .178-.154.323-.345.323H4.391c-.19 0-.344-.145-.344-.323V22.66c0-.016.001-.032.004-.047a.303.303 0 0 1 .007-.125L7.03 11.454a.341.341 0 0 1 .334-.244h3z",
      fillRule: "nonzero"
    }, {
      d: "M14.034 15.113c0 .29.312.451.601.451h1.954c.29 0 .601-.161.601-.45v-5.6h2.353a1 1 0 0 0 .781-1.624l-3.931-4.914a1 1 0 0 0-1.562 0L10.9 7.89a1 1 0 0 0 .78 1.625h2.354v5.598z"
    }]
  },
  received: {
    title: "received",
    g: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    path: [{
      d: "M9.226 11.21c.053.081.11.16.172.237l1.171 1.465H8.772l-2.174 8.553h5.029c.29 0 .61.297.61.562v.001c.294 1.594 1.758 2.758 3.47 2.759 1.735 0 3.177-1.188 3.468-2.75.079-.287.314-.572.628-.572h5.082l-2.24-8.553h-1.872l1.172-1.465a3 3 0 0 0 .172-.237h1.926c.158 0 .295.1.334.244l2.971 11.034a.303.303 0 0 1 .009.13.291.291 0 0 1 .003.042v6.878c0 .178-.154.323-.345.323H4.391c-.19 0-.344-.145-.344-.323V22.66c0-.016.001-.032.004-.047a.303.303 0 0 1 .007-.125L7.03 11.454a.341.341 0 0 1 .334-.244h1.862z"
    }, {
      d: "M17.19 3.051c0-.289-.312-.45-.601-.45h-1.954c-.29 0-.601.161-.601.45v5.6H11.68a1 1 0 0 0-.781 1.624l3.931 4.914a1 1 0 0 0 1.562 0l3.931-4.914a1 1 0 0 0-.78-1.625H17.19V3.051z"
    }]
  },
  attach: {
    title: "attach",
    path: {
      d: "M27.102 28.552c-.96.965-2.153 1.448-3.576 1.448-1.642 0-3.071-.61-4.287-1.832L5.062 13.948C3.687 12.543 3 10.888 3 8.982c0-1.943.669-3.592 2.007-4.948C6.345 2.678 7.981 2 9.915 2c1.922 0 3.582.69 4.981 2.07l11.039 11.105a.561.561 0 0 1 .182.404c0 .195-.185.479-.556.852-.371.372-.654.559-.849.559a.576.576 0 0 1-.42-.184L13.237 5.683c-.961-.94-2.062-1.41-3.303-1.41-1.289 0-2.378.457-3.266 1.374-.888.916-1.332 2.021-1.332 3.316 0 1.283.463 2.389 1.387 3.317l14.159 14.238c.766.77 1.648 1.155 2.645 1.155.779 0 1.423-.257 1.934-.77.511-.513.767-1.16.767-1.942 0-1.002-.383-1.888-1.15-2.657l-10.6-10.647a1.562 1.562 0 0 0-1.095-.44 1.184 1.184 0 0 0-1.223 1.228c0 .39.152.751.456 1.081l7.481 7.513a.561.561 0 0 1 .183.403c0 .196-.189.483-.566.862-.377.378-.663.568-.858.568a.557.557 0 0 1-.401-.184l-7.48-7.513c-.767-.745-1.15-1.655-1.15-2.73 0-1.002.347-1.85 1.04-2.547.693-.696 1.539-1.045 2.536-1.045 1.07 0 1.977.385 2.719 1.155l10.6 10.646c1.217 1.198 1.825 2.633 1.825 4.307 0 1.43-.48 2.626-1.442 3.591z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  attributes: {
    title: "attributes",
    path: {
      d: "M16 27v-3h13a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H16zm-5 0H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h8v3zm15-9v-3h3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-3zm-5 0H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h18v3zM11 9V6h18a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H11zM6 9H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3v3zm2-5h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm15 9h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1zm-10 9h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  calendar: {
    title: "calendar",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M12.522 16.616h2.882v-2.88h-2.882zM16.846 16.616h2.882v-2.88h-2.882zM21.169 16.616h2.882v-2.88h-2.882zM8.2 20.939h2.881v-2.88H8.2zM12.522 20.939h2.882v-2.88h-2.882zM16.846 20.939h2.882v-2.88h-2.882zM21.169 20.939h2.882v-2.88h-2.882zM8.2 25.262h2.881v-2.88H8.2zM12.522 25.262h2.882v-2.88h-2.882zM16.846 25.262h2.882v-2.88h-2.882z"
    }, {
      d: "M20 3v2.5h-8.05V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2.5H4a1 1 0 0 0-1 1V29a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V6.5a1 1 0 0 0-1-1h-1.95V3a1 1 0 0 0-1-1H21a1 1 0 0 0-1 1zm2 5h2V4h-2v4zM8 8h2V4H8v4zM6 27h20V11.327H6V27z"
    }]
  },
  chat: {
    title: "chat",
    path: {
      d: "M26.71 24.64c.11.216.244.424.398.624.155.2.276.357.36.47.084.113.223.273.415.477.191.207.315.341.368.405l.065.074c.03.037.055.064.071.08a.976.976 0 0 1 .12.171l.04.08.031.098.008.105-.016.104a.6.6 0 0 1-.208.357.475.475 0 0 1-.352.114 13.794 13.794 0 0 1-1.372-.26 13.353 13.353 0 0 1-4.443-2.072c-.958.172-1.894.258-2.81.258-2.888 0-5.4-.712-7.544-2.138.62.044 1.087.066 1.407.066 1.714 0 3.36-.243 4.937-.728 1.576-.486 2.982-1.182 4.218-2.09 1.332-.993 2.354-2.137 3.069-3.432a8.413 8.413 0 0 0 .701-6.574c1.374.766 2.46 1.728 3.261 2.882.798 1.155 1.198 2.396 1.198 3.724 0 1.296-.377 2.508-1.134 3.636-.758 1.128-1.796 2.081-3.116 2.857.106.26.216.498.327.712zM18.895 6.11c1.73.74 3.097 1.747 4.097 3.02 1.003 1.274 1.502 2.662 1.502 4.162s-.5 2.887-1.502 4.16c-1 1.274-2.366 2.28-4.097 3.021-1.73.74-3.614 1.109-5.648 1.109a15.81 15.81 0 0 1-2.811-.26 13.368 13.368 0 0 1-4.443 2.073c-.383.097-.841.184-1.374.259a.538.538 0 0 1-.558-.47.31.31 0 0 1-.016-.104.363.363 0 0 1 .04-.202l.04-.082.055-.09.064-.08.071-.08.064-.073c.054-.065.176-.2.367-.406.193-.205.331-.365.417-.477.084-.114.205-.27.36-.47.154-.2.286-.408.399-.624a8.87 8.87 0 0 0 .327-.712c-1.321-.776-2.36-1.733-3.116-2.866C2.38 15.784 2 14.575 2 13.291c0-1.5.501-2.888 1.502-4.163 1.002-1.272 2.367-2.28 4.097-3.019C9.331 5.369 11.213 5 13.248 5c2.034 0 3.917.37 5.648 1.109z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  dashboard: {
    title: "dashboard",
    path: {
      d: "M4.276 12.253l1.984 2.614c-.968 1.114-1.742 2.42-2.178 3.824a12.248 12.248 0 0 0-.532 4.405l.048.533H1.129l-.048-.484c-.387-3.63.63-7.358 2.807-10.36.146-.193.242-.338.388-.532zm8.81-5.324c.145 0 .242-.049.387-.049l-.387 4.55c-.92.097-1.84.29-2.711.63a8.94 8.94 0 0 0-2.71 1.549l-2.082-2.711a14.901 14.901 0 0 1 7.503-3.97zm17.813 16.264l-.048.484h-7.89l.193-.677c.339-1.21.436-2.517.242-3.728a12.737 12.737 0 0 0-.145-.629l3.34-3.679.145-.145.097-.145c.29-.63.145-1.114-.048-1.356-.146-.242-.388-.484-.678-.58a1.508 1.508 0 0 0-1.21.048l-3.582 1.936c-.678-.774-1.5-1.452-2.42-2.033a10.355 10.355 0 0 0-3.922-1.259l.388-4.743c7.26-.29 13.892 4.743 15.345 12.101.29 1.452.387 2.905.193 4.405zM25.72 13.9c.098.097.05.145 0 .242l-8.035 8.81c-.774.872-2.178.968-3.05.145-.87-.822-.968-2.178-.145-3.05.146-.144.34-.338.533-.435l10.407-5.809c.097 0 .242 0 .29.097zm-9.729 8.568a.976.976 0 0 0 1.065-.871.976.976 0 0 0-.871-1.065.976.976 0 0 0-1.065.871.976.976 0 0 0 .871 1.065z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  edit: {
    title: "edit",
    path: {
      d: "M5.857 20.878L19.868 6.866l.01-.009 5.265 5.265-14.011 14.012-.01.009-5.265-5.265zm-1.589 1.408l5.446 5.446-.015.004.006.005L2 30l2.259-7.705.005.006.004-.015zM28.091 5.008a3.106 3.106 0 0 1-.001 4.393l-.01.009-.777.777-.517.518-.01.01-5.49-5.491.786-.787.528-.527a3.106 3.106 0 0 1 4.392 0l1.099 1.098z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  forms: {
    title: "forms",
    path: {
      d: "M11.75 2.63l-.677 1.703h9.854l-.676-1.702A1 1 0 0 0 19.32 2H12.68a1 1 0 0 0-.93.63zM6 6.334a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1V29a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6.333zM10.667 12v2.333H13V12h-2.333zm4.666 0v2.333h6V12h-6zm-4.666 4.667V19H13v-2.333h-2.333zm4.666 0V19h6v-2.333h-6zm-4.666 4.666v2.334H13v-2.334h-2.333zm4.666 0v2.334h6v-2.334h-6z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "funnel-analysis": {
    title: "funnel-analysis",
    path: {
      d: "M29.8 6.854L18.79 18.68a1 1 0 0 0-.268.682v6.843a1 1 0 0 1-.462.843l-2.967 1.896a1 1 0 0 1-1.538-.843v-8.742a1 1 0 0 0-.266-.678L2.334 6.823a1 1 0 0 1-.266-.679V5.04a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v1.134a1 1 0 0 1-.268.681z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "grid-view": {
    title: "grid-view",
    path: {
      d: "M3 14.097h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10.097a1 1 0 0 0 1 1zM19 14.097h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H19a1 1 0 0 0-1 1v10.097a1 1 0 0 0 1 1zM3 30.105h10a1 1 0 0 0 1-1V19.008a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10.097a1 1 0 0 0 1 1zM19 30.105h10a1 1 0 0 0 1-1V19.008a1 1 0 0 0-1-1H19a1 1 0 0 0-1 1v10.097a1 1 0 0 0 1 1z"
    }
  },
  "list-view": {
    title: "list-view",
    path: {
      d: "M3 27.92h7.84a1 1 0 0 0 1-1V19a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v7.92a1 1 0 0 0 1 1zM3 14h7.92a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zM14.923 6.846h13.539a.923.923 0 0 0 0-1.846H14.923a.923.923 0 1 0 0 1.846zM14.923 9.923h13.539a.923.923 0 0 0 0-1.846H14.923a.923.923 0 1 0 0 1.846zM14.923 13h13.539a.923.923 0 0 0 0-1.846H14.923a.923.923 0 1 0 0 1.846zM14.923 20.846h13.539a.923.923 0 0 0 0-1.846H14.923a.923.923 0 1 0 0 1.846zM14.923 23.923h13.539a.923.923 0 0 0 0-1.846H14.923a.923.923 0 1 0 0 1.846zM14.923 27h13.539a.923.923 0 0 0 0-1.846H14.923a.923.923 0 1 0 0 1.846z"
    }
  },
  history: {
    title: "history",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M16 9.844v7.843a.5.5 0 0 0 .277.447l5.567 2.782a.794.794 0 0 0 1.08-.387.876.876 0 0 0-.4-1.136l-4.835-2.482V9.844a.844.844 0 1 0-1.689 0z"
    }, {
      d: "M16.889 3C9.85 3 4.192 8.684 3.778 15.79h-2.07c-.69 0-.966.426-.414.994l3.036 3.41c.552.57 1.38.57 1.794 0l3.036-3.41c.414-.568.138-.995-.552-.995h-2.07c.414-5.542 4.83-9.947 10.35-9.947 5.66 0 10.352 4.832 10.352 10.658s-4.693 10.658-10.351 10.658c-2.208 0-4.278-.71-6.073-1.99-.552-.426-1.518-.284-1.932.285-.414.568-.276 1.563.276 1.99C11.368 29.146 14.13 30 16.89 30 24.066 30 30 23.89 30 16.5S24.066 3 16.889 3z"
    }]
  },
  notification: {
    title: "notification",
    path: {
      d: "M29.25 24c0 .542-.2 1.01-.6 1.406A1.947 1.947 0 0 1 27.23 26h-7.068c0 1.104-.394 2.047-1.183 2.828-.79.782-1.74 1.172-2.856 1.172-1.114 0-2.066-.39-2.854-1.172-.79-.78-1.183-1.724-1.183-2.828H5.019c-.546 0-1.02-.198-1.42-.594C3.2 25.011 3 24.542 3 24a13.912 13.912 0 0 0 1.437-1.375c.431-.48.878-1.102 1.34-1.867.463-.766.855-1.592 1.176-2.477.32-.885.583-1.959.789-3.219.205-1.26.308-2.614.308-4.062 0-1.583.615-3.054 1.845-4.415 1.23-1.359 2.845-2.184 4.843-2.475a1.529 1.529 0 0 1-.126-.61c0-.417.147-.77.441-1.062A1.467 1.467 0 0 1 16.124 2c.422 0 .78.146 1.074.438.294.292.442.645.442 1.062 0 .208-.042.411-.127.61 1.998.291 3.613 1.116 4.844 2.475 1.23 1.36 1.845 2.832 1.845 4.415 0 1.448.103 2.802.308 4.062.205 1.26.467 2.334.788 3.22.322.884.713 1.71 1.176 2.476.463.765.909 1.387 1.34 1.867.432.478.91.938 1.435 1.375zM16.1 28.45a1.8 1.8 0 0 0 1.8-1.8h-3.6a1.8 1.8 0 0 0 1.8 1.8z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  phone: {
    title: "phone",
    path: {
      d: "M9.507 4.236l3.105 3.229c.87.745.87 2.235 0 2.98l-2.484 2.484c1.74 3.726 5.34 7.328 8.943 8.943l2.484-2.484c.869-.87 2.235-.87 3.105 0l3.104 3.105c.87.869.87 2.235 0 3.104l-3.104 3.105C19.195 34.167-2.043 12.805 3.298 7.465l3.105-3.23c.869-.745 2.235-.745 3.104 0zm8.446-.497c-.994-.249-.621-1.863.497-1.615 5.589 1.49 9.935 5.962 11.426 11.55.248.994-1.366 1.367-1.615.373C26.895 9.08 23.045 5.105 17.953 3.74zm-.994 3.85c-.993-.249-.62-1.863.373-1.615a12.299 12.299 0 0 1 8.694 8.694c.248.994-1.242 1.49-1.615.373a10.728 10.728 0 0 0-7.452-7.452z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  publish: {
    title: "publish",
    path: {
      d: "M24.688 11.676c-.183.432-.5.648-.956.648h-4.145v7.252c0 .28-.104.524-.308.728a1 1 0 0 1-.729.308h-4.147a1 1 0 0 1-.729-.308.998.998 0 0 1-.307-.728v-7.252H9.22c-.455 0-.773-.216-.957-.648-.183-.42-.108-.793.227-1.117l7.257-7.251A.961.961 0 0 1 16.476 3c.292 0 .535.102.73.308l7.256 7.25c.335.325.41.697.226 1.118m5.264 10.49v5.18c0 .43-.15.798-.453 1.1a1.496 1.496 0 0 1-1.101.454H4.556a1.5 1.5 0 0 1-1.102-.454 1.5 1.5 0 0 1-.454-1.1v-5.18a1.5 1.5 0 0 1 .454-1.101 1.5 1.5 0 0 1 1.102-.453h6.915c.228.604.607 1.1 1.142 1.49a2.983 2.983 0 0 0 1.79.581h4.147c.658 0 1.255-.194 1.79-.581a3.198 3.198 0 0 0 1.142-1.49h6.916c.432 0 .8.15 1.1.453.304.302.454.67.454 1.1m-2.072 3.627a.997.997 0 0 0-.309-.729.997.997 0 0 0-.729-.306.994.994 0 0 0-.727.306.997.997 0 0 0-.31.73c0 .279.104.523.31.727a.991.991 0 0 0 .727.308c.281 0 .525-.102.73-.308a.994.994 0 0 0 .308-.728m-4.148 0a.994.994 0 0 0-.306-.729 1 1 0 0 0-.73-.306c-.28 0-.523.102-.73.306a.999.999 0 0 0-.306.73c0 .279.102.523.307.727a1 1 0 0 0 .73.308c.28 0 .522-.102.729-.308a.992.992 0 0 0 .306-.728",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  share: {
    title: "share",
    path: {
      d: "M24 19a5 5 0 1 1-4.888 3.953l-6.345-3.172A4.985 4.985 0 0 1 9 21.5a5 5 0 0 1 0-10c1.504 0 2.85.668 3.767 1.72l6.345-3.173A5 5 0 1 1 24 14a4.984 4.984 0 0 1-3.767-1.72l-6.345 3.173a5.02 5.02 0 0 1 0 2.094l6.345 3.172A4.985 4.985 0 0 1 24 19z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "tree-view": {
    title: "tree-view",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M7.769 15.067h12.564v1.867H7.769zM7.77 25.022h12.563v1.867H8.77a1 1 0 0 1-1-1v-.867z"
    }, {
      d: "M7.778 25.868V8h1.867v18.868h-.867a1 1 0 0 1-1-1z"
    }, {
      d: "M4 3.866A1.87 1.87 0 0 1 5.884 2h5.655a1.87 1.87 0 0 1 1.884 1.866v5.601a1.87 1.87 0 0 1-1.884 1.866H5.884A1.87 1.87 0 0 1 4 9.467v-5.6zM20.333 23.529c0-.894.725-1.618 1.633-1.618h4.901c.902 0 1.633.718 1.633 1.618v4.854c0 .893-.725 1.617-1.633 1.617h-4.9a1.621 1.621 0 0 1-1.634-1.617v-4.854zM20.333 13.573c0-.893.725-1.617 1.633-1.617h4.901c.902 0 1.633.717 1.633 1.617v4.854c0 .893-.725 1.617-1.633 1.617h-4.9a1.621 1.621 0 0 1-1.634-1.617v-4.854z"
    }]
  },
  "flag-advanced-search-attribute-column-sort": {
    title: "flag-advanced-search-attribute-column-sort",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm5.166-15.16a.708.708 0 0 0 .703-.703.698.698 0 0 0-.208-.494l-4.922-4.921a.696.696 0 0 0-.493-.209.696.696 0 0 0-.494.21l-4.921 4.92a.696.696 0 0 0-.209.494c0 .385.318.703.703.703h9.84zm.495 4.01a.697.697 0 0 0 .208-.495.708.708 0 0 0-.704-.703h-9.84a.708.708 0 0 0-.703.703c0 .186.077.362.209.494l4.92 4.92a.698.698 0 0 0 .495.21.698.698 0 0 0 .493-.21l4.922-4.92z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-asset-download-view": {
    title: "flag-asset-download-view",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm8.532-13.13h-1.654c-.245 0-.35.105-.35.35v3.436H9.612V17.22c0-.245-.105-.35-.35-.35H7.608c-.245 0-.446.105-.446.35v5.472c0 .245.2.413.446.413h16.924c.245 0 .445-.168.445-.413v-1.655-3.817c0-.245-.2-.35-.445-.35zm-9.798-9.99v4.74H10.98l5.09 6.363 5.09-6.362h-3.754V6.88c0-.245-.264-.382-.509-.382h-1.654c-.245 0-.51.137-.51.382z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-client-website-activity": {
    title: "flag-client-website-activity",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm6.874-8.083c1.303-1.467 2.078-3.422 2.2-5.5h-3.3c-.041 1.63-.407 2.974-.978 4.278.734.326 1.426.733 2.078 1.222zm-5.297 2.974c1.793-.325 3.464-1.14 4.727-2.363a10.616 10.616 0 0 0-1.875-1.06c-.692 1.304-1.67 2.445-2.852 3.423zm-5.785-3.463c-.652.326-1.263.651-1.875 1.059a8.71 8.71 0 0 0 4.727 2.363 10.958 10.958 0 0 1-2.852-3.422zm-4.645-4.97c.123 2.037.897 3.992 2.2 5.5a10.694 10.694 0 0 1 2.078-1.223c-.57-1.344-.936-2.647-.977-4.277H7.147zm2.241-6.316c-1.303 1.467-2.118 3.464-2.241 5.501h3.342c.04-1.222.366-2.935.977-4.279a10.686 10.686 0 0 1-2.078-1.222zm5.256-2.933c-1.793.285-3.423 1.14-4.685 2.323.57.407 1.222.773 1.874 1.059.693-1.264 1.63-2.445 2.81-3.382zm5.745 3.422c.652-.326 1.304-.652 1.874-1.1-1.264-1.181-2.893-2.037-4.686-2.281 1.142.937 2.119 2.077 2.812 3.381zm-3.871 5.012h4.4c-.04-1.222-.366-2.77-.937-3.993-1.1.366-2.241.61-3.463.651v3.342zm0 4.074c1.222.082 2.404.285 3.463.692.57-1.222.897-2.321.937-3.951h-4.4v3.26zm0 .815v4.115c1.222-.938 2.363-2.119 3.137-3.504-.977-.367-1.915-.57-3.137-.61zm-.815 0c-1.222.04-2.159.244-3.137.61.775 1.345 1.915 2.567 3.137 3.505v-4.115zm0-4.074h-4.44c.081 1.63.366 2.73.936 3.951 1.1-.407 2.282-.652 3.504-.692v-3.26zm0-4.157c-1.222-.04-2.362-.243-3.463-.65-.57 1.222-.896 2.77-.936 3.992h4.399v-3.342zm0-.815V7.453c-1.222.897-2.362 2.119-3.097 3.464.978.326 1.875.529 3.097.57zm.815-4.033v4.033c1.222-.04 2.12-.203 3.096-.57-.733-1.344-1.874-2.525-3.096-3.463zm8.556 8.19c-.122-2.037-.937-4.034-2.2-5.5-.652.488-1.344.896-2.078 1.221.57 1.304.937 3.057.978 4.279h3.3z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-compared-item": {
    title: "flag-compared-item",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm7.78-13.211h-5.191v-2.024c0-.602-.333-.764-.796-.36l-4.273 3.758c-.463.404-.45 1.066.011 1.47l4.257 3.758c.462.405.8.243.8-.36V20.89h5.192c.624 0 1.049-.43 1.049-1.032V17.94c0-.603-.425-1.151-1.049-1.151zm-6.549-4.914l-4.26-3.758c-.462-.404-.807-.242-.807.36v2.227H6.987c-.623 0-1.057.346-1.057.949v1.917c0 .601.434 1.235 1.057 1.235h5.177v1.939c0 .602.338.764.8.36l4.272-3.758c.462-.405.457-1.066-.005-1.47z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-high-value-firmographic": {
    title: "flag-high-value-firmographic",
    path: {
      d: "M2 16C2 8.268 8.268 2 16 2c7.731 0 14 6.268 14 14s-6.269 14-14 14C8.268 30 2 23.732 2 16zm13.785-.064c.739-.864 1.146-2.02 1.146-3.254 0-2.51-1.703-4.551-3.797-4.551-2.094 0-3.797 2.042-3.797 4.551 0 1.234.407 2.39 1.146 3.254.714.836 1.656 1.296 2.65 1.296.996 0 1.937-.46 2.652-1.296zm.257 1.77a3.79 3.79 0 0 1-.337.312c-.052.043-.103.088-.157.129-.066.05-.134.095-.202.141-.055.038-.109.076-.165.11-.07.043-.142.081-.214.12-.057.03-.112.061-.169.089-.075.036-.151.065-.228.096-.057.023-.113.048-.171.068-.082.028-.164.05-.248.073-.054.015-.108.033-.164.046-.093.021-.187.034-.281.049-.048.007-.094.018-.142.023a3.952 3.952 0 0 1-.862 0c-.046-.007-.091-.017-.137-.024-.095-.014-.191-.028-.285-.05-.055-.011-.107-.03-.16-.044-.085-.024-.17-.045-.252-.074-.057-.02-.11-.044-.167-.067-.078-.03-.156-.061-.232-.097-.056-.027-.11-.058-.166-.088-.073-.039-.147-.077-.218-.12-.055-.034-.108-.072-.162-.109-.069-.046-.137-.092-.204-.143-.053-.04-.104-.085-.156-.129a4.617 4.617 0 0 1-.19-.165c-.051-.048-.1-.098-.15-.149-.039-.04-.08-.077-.12-.12-2.463.74-4.087 2.787-4.23 4.535l14.52.001c-.077-.954-.596-1.997-1.452-2.868a6.535 6.535 0 0 0-2.778-1.667c-.038.043-.08.08-.12.121zm9.91-2.156a1 1 0 0 0 1-1v-.012a1 1 0 0 0-1-1h-1.915v-2.016a1 1 0 0 0-1-1h-.08a1 1 0 0 0-1 1v2.016h-1.914a1 1 0 0 0-1 1v.012a1 1 0 0 0 1 1h1.915v2.016a1 1 0 0 0 1 1h.08a1 1 0 0 0 1-1V15.55h1.914z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "flag-high-value-page-view": {
    title: "flag-high-value-page-view",
    path: {
      d: "M2 16C2 8.268 8.268 2 16 2c7.731 0 14 6.268 14 14s-6.269 14-14 14C8.268 30 2 23.732 2 16zm5.085-2.567l8.37 11.029a1 1 0 0 0 1.593 0l8.37-11.03H7.084zm18.332-1.662L21.44 8.33a1 1 0 0 0-.655-.244h-9.078a1 1 0 0 0-.656.245L7.085 11.77h18.332z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "flag-keyword-part-number-search": {
    title: "flag-keyword-part-number-search",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm4.122-15.13a5.277 5.277 0 0 1-5.28 5.28 5.277 5.277 0 0 1-5.28-5.28 5.277 5.277 0 0 1 5.28-5.28 5.277 5.277 0 0 1 5.28 5.28zm3 7.086l-2.834-2.835c.973-1.25 1.501-2.75 1.501-4.28a6.95 6.95 0 0 0-6.947-6.946 6.95 6.95 0 0 0-6.947 6.947 6.95 6.95 0 0 0 6.947 6.947 6.803 6.803 0 0 0 4.28-1.5l2.834 2.834a.8.8 0 0 0 .583.25.8.8 0 0 0 .584-.25.806.806 0 0 0 0-1.167z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-navigator-cad": {
    title: "flag-navigator-cad",
    path: {
      d: "M15.951 29.902C8.246 29.902 2 23.656 2 15.951S8.246 2 15.951 2s13.951 6.246 13.951 13.951-6.246 13.951-13.951 13.951zm.065-25.086L6.883 8.85l4.127 1.996 4.859-1.963a.355.355 0 0 1 .304.002l4.916 1.961 4.032-1.996-9.105-4.034zm-5.537 14.581a.466.466 0 0 1-.031-.134v-6.95l-4.063-2.048v11.176l8.596 4.095V21.52l-4.346-1.953a.582.582 0 0 1-.072-.05.363.363 0 0 1-.084-.12zm4.76-3.478v-4.994l-3.269 1.584v4.994l3.269-1.584zm.768 1.296l-3.394 1.525 3.394 1.644L19.4 18.74l-3.393-1.525zm9.692 4.248V10.287l-4.063 2.048c0 4.639-.003 6.969-.005 6.99a.418.418 0 0 1-.039.125.383.383 0 0 1-.143.14l-4.432 1.953v4.015l8.682-4.095zm-5.66-8.954l-3.27-1.584v4.994l3.27 1.584v-4.994z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  "flag-navigator-page-emailed": {
    title: "flag-navigator-page-emailed",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zM6.174 18.57l4.528-2.983-4.528-2.982v5.964zm19.82 1.675l-5.316-3.556-4.034 2.725a1 1 0 0 1-1.12 0l-4.034-2.725-5.316 3.556v.293a1 1 0 0 0 1 1h17.82a1 1 0 0 0 1-1v-.293zm-19.82-9.191l9.344 6.412a1 1 0 0 0 1.132 0l9.344-6.412v-.293a1 1 0 0 0-1-1H7.174a1 1 0 0 0-1 1v.293zm19.82 1.551l-4.529 2.982 4.529 2.982v-5.964z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-navigator-page-printed": {
    title: "flag-navigator-page-printed",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zM11.866 7.717a1 1 0 0 0-1 1v1.551h10.347v-1.55a1 1 0 0 0-1-1h-8.347zm12.158 3.827H7.976a1 1 0 0 0-1 1v7.136a1 1 0 0 0 1 1h1.567v-3.392H22.38v3.392h1.645a1 1 0 0 0 1-1v-7.136a1 1 0 0 0-1-1zm-13.073 6.975v5.858h10.098V18.52H10.951z"
    }, {
      d: "M23.79 13.996h-1.94V12.72h1.94z"
    }]
  },
  "flag-navigator-page-saved": {
    title: "flag-navigator-page-saved",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm5.791-6.721V8.895a1 1 0 0 0-1-1H10.86a1 1 0 0 0-1 1v14.384a1 1 0 0 0 1.497.867l3.97-2.277a1 1 0 0 1 .996 0l3.97 2.277a1 1 0 0 0 1.498-.867z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-phone-call": {
    title: "flag-phone-call",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zM11.355 7.453a1.76 1.76 0 0 0-2.244 0L6.866 9.787c-3.86 3.86 11.491 19.301 15.441 15.351l2.244-2.244a1.572 1.572 0 0 0 0-2.244l-2.244-2.245a1.572 1.572 0 0 0-2.244 0l-1.796 1.796c-2.603-1.167-5.206-3.77-6.463-6.464l1.795-1.795c.629-.539.629-1.616 0-2.155l-2.244-2.334zm6.104-.359c3.681.988 6.464 3.86 7.451 7.451.18.718 1.347.449 1.167-.27-1.077-4.039-4.219-7.27-8.258-8.348-.808-.18-1.078.988-.36 1.167zm-.718 2.783a7.754 7.754 0 0 1 5.387 5.386c.269.808 1.346.45 1.167-.269A8.89 8.89 0 0 0 17.01 8.71c-.719-.18-.988.987-.27 1.167z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-product-service-view": {
    title: "flag-product-service-view",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm-1.805-9.642a4.717 4.717 0 1 1 3.61-8.716 4.717 4.717 0 0 1-3.61 8.716zm-3.818 3.667l1.61-1.546a7.64 7.64 0 0 0 2.269.94l.045 2.232a9.735 9.735 0 0 0 3.398 0l.045-2.232a7.678 7.678 0 0 0 2.269-.94l1.61 1.546a9.739 9.739 0 0 0 2.402-2.402l-1.546-1.61a7.662 7.662 0 0 0 .94-2.27l2.232-.044a9.744 9.744 0 0 0 0-3.398l-2.233-.045a7.664 7.664 0 0 0-.94-2.269l1.547-1.61a9.739 9.739 0 0 0-2.402-2.403l-1.61 1.547a7.682 7.682 0 0 0-2.27-.94L17.7 6.349a9.735 9.735 0 0 0-3.398 0l-.045 2.232a7.653 7.653 0 0 0-2.269.94l-1.61-1.546a9.739 9.739 0 0 0-2.403 2.402l1.547 1.61a7.64 7.64 0 0 0-.94 2.27l-2.232.044a9.744 9.744 0 0 0 0 3.398l2.232.045c.19.801.507 1.568.94 2.269l-1.546 1.609a9.745 9.745 0 0 0 2.402 2.403z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-shortlisted": {
    title: "flag-shortlisted",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm-9.052-6.74h18.148c.385 0 .698-.31.698-.694V8.694A.696.696 0 0 0 25.096 8H6.948a.696.696 0 0 0-.698.694v13.872c0 .383.312.694.698.694z"
    }, {
      d: "M8.344 21.18v-11.1H23.7v11.1H8.344zm7.935-8.341a.5.5 0 0 0 .5-.5v-.402a.5.5 0 0 0-.5-.5h-6.04a.5.5 0 0 0-.5.5v.402a.5.5 0 0 0 .5.5h6.04zm0 2.774a.5.5 0 0 0 .5-.5v-.401a.5.5 0 0 0-.5-.5h-6.04a.5.5 0 0 0-.5.5v.401a.5.5 0 0 0 .5.5h6.04zm6.584-3.322a.405.405 0 0 0-.568.039l-5.012 5.713-1.793-.973a.418.418 0 0 0-.457.039.41.41 0 0 0-.067.58l1.904 2.38a.866.866 0 0 0 1.4-.069l.063-.096 4.604-7.095a.398.398 0 0 0-.074-.518z"
    }]
  },
  "flag-submitted-rfi": {
    title: "flag-submitted-rfi",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zM6.3 14.522l2.084-2.114 7.454-5.175 7.555 5.152 2.057 2.503v-3.005a2 2 0 0 0-.862-1.645l-7.575-5.24a2 2 0 0 0-2.276 0l-7.575 5.24a2 2 0 0 0-.862 1.645v2.639zm.121 6.605l4.39-2.99-4.39-2.992v5.982zm19.218 1.68l-5.155-3.566-3.881 2.712a1 1 0 0 1-1.146 0l-3.882-2.712-5.154 3.566v.297a1 1 0 0 0 1 1H24.64a1 1 0 0 0 1-1v-.297zm0-7.662l-4.391 2.991 4.39 2.991v-5.982zm-9.489-2.588a1.292 1.292 0 1 0 0-2.584 1.292 1.292 0 0 0 0 2.584zM14.858 14.1v5.815h2.585V14.1h-2.585z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "flag-thomas-activity-in-session": {
    title: "flag-thomas-activity-in-session",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14C8.27 30 2 23.732 2 16S8.269 2 16 2zm-5.07 7.614h9.292V6.2H10.93v3.414zm0 12.671h3.098v-9.257H10.93v9.257zm6.194 0h3.098v-9.257h-3.098v9.257zm-6.188 1.81v.357h.377v1.123h.372v-1.123h.376v-.358h-1.125zm2.333 0v.539h-.419v-.54h-.38v1.481h.38v-.584h.419v.584h.38v-1.48h-.38zm1.409 1.504c.364 0 .623-.274.623-.766 0-.494-.255-.762-.62-.762-.364 0-.623.273-.623.766s.255.762.62.762zm2.03-.024h.35v-1.48h-.338l-.165.395c-.085.2-.146.362-.169.446a4.146 4.146 0 0 0-.169-.446l-.165-.396h-.342v1.481h.35v-.353c0-.146-.002-.28-.008-.394.04.11.11.282.156.388l.176.41.177-.41c.046-.106.115-.277.155-.388a8.169 8.169 0 0 0-.008.394v.353zm1.682 0h.403l-.488-1.48h-.376l-.487 1.48h.399l.073-.26h.403l.073.26zm1.301.024c.323 0 .555-.14.555-.479 0-.277-.15-.391-.488-.48-.172-.045-.22-.07-.22-.125 0-.053.027-.09.138-.09.136 0 .255.05.374.139l.18-.322a.824.824 0 0 0-.535-.171c-.324 0-.53.188-.53.468 0 .296.156.393.48.476.18.046.229.08.229.135 0 .07-.043.095-.175.095a.763.763 0 0 1-.393-.148l-.181.322c.14.101.35.18.566.18zm1.37-1.372h.319v-.13h-.802v.13h.32v.758h.163v-.758zm1.261.744h.133v-.875h-.144l-.198.466a2.345 2.345 0 0 0-.06.15c-.013-.036-.041-.1-.063-.15l-.202-.466h-.139v.875h.128v-.462c0-.053-.002-.13-.003-.154.01.025.036.088.058.137l.216.493.219-.493.058-.137c-.002.025-.003.1-.003.154v.462z",
      fillRule: "nonzero"
    }, {
      d: "M14.682 24.428c-.153 0-.239.138-.239.405 0 .266.09.408.243.408.152 0 .238-.138.238-.404 0-.267-.09-.409-.242-.409M18.205 24.899c-.048-.194-.07-.276-.088-.378-.017.102-.039.186-.087.378l-.026.099h.227l-.026-.1z"
    }]
  },
  "thomas-registered-user": {
    title: "thomas-registered-user",
    path: {
      d: "M16 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14zm5.497-5.217a.772.772 0 0 0 .738-1.011l-1.884-5.878 4.981-3.652a.774.774 0 1 0-.455-1.399l-6.173-.024-1.933-5.866a.774.774 0 0 0-1.471 0l-1.931 5.864-6.176.027a.773.773 0 1 0-.455 1.399l4.98 3.647-1.884 5.882a.775.775 0 0 0 1.19.865l5.01-3.609 5.012 3.609a.766.766 0 0 0 .451.146z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "social-blog": {
    title: "social-blog",
    path: {
      d: "M6.906 20.666V3a1 1 0 0 1 1-1h3.392a1 1 0 0 1 1 1v17.666c0 2.206 1.814 4.001 4.045 4.001 2.23 0 4.045-1.795 4.045-4 0-2.207-1.815-4-4.045-4h-1.695a1 1 0 0 1-1-1v-3.333a1 1 0 0 1 1-1h1.695c5.202 0 9.437 4.187 9.437 9.332 0 5.145-4.235 9.334-9.437 9.334-5.203 0-9.437-4.189-9.437-9.334z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "social-facebook": {
    title: "social-facebook",
    path: {
      d: "M21.843 11.068H18.42V8.163c0-1.092.711-1.347 1.212-1.347H21.7a1 1 0 0 0 1-1V3.013a1 1 0 0 0-.996-1L18.475 2c-4.694 0-5.76 3.578-5.76 5.868v3.199H11a1 1 0 0 0-1 1v2.944a1 1 0 0 0 1 1h1.714V30h4.709a1 1 0 0 0 1-1V16.011h2.988a1 1 0 0 0 .99-.855l.43-2.942a1 1 0 0 0-.988-1.146z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "social-google-plus": {
    title: "social-google-plus",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M25.99 13.176v-4.16a.573.573 0 0 0-.575-.575H24.22a.574.574 0 0 0-.575.575v4.16H19.47a.574.574 0 0 0-.575.574v1.196c0 .316.257.574.575.574h4.175v4.176c0 .316.258.574.575.574h1.195a.574.574 0 0 0 .574-.574v-4.16h4.176a.575.575 0 0 0 .574-.575v-1.195a.572.572 0 0 0-.558-.59h-4.192z"
    }, {
      d: "M9.21 5.957a1.926 1.926 0 0 1 1.551-.683c1.553 0 3.105 1.863 3.462 4.036a3.932 3.932 0 0 1-.73 3.105 1.92 1.92 0 0 1-1.552.683c-1.552 0-3.104-1.925-3.461-4.098a3.8 3.8 0 0 1 .73-3.043zM6.818 22.272c0-1.723 2.188-3.245 4.656-3.245a5.53 5.53 0 0 1 1.553.233l.497.342c1.148.791 1.924 1.304 2.142 2.142.023.206.023.416 0 .62 0 2.143-1.553 3.245-4.766 3.245-2.158 0-4.036-1.459-4.036-3.337H6.82zm9.313-5.433a4.894 4.894 0 0 1-1.676-1.816c0-.513 0-.746 1.195-1.646a5.465 5.465 0 0 0 2.282-4.284 5.71 5.71 0 0 0-1.21-3.664h.59a.553.553 0 0 0 .34-.108L19.3 4.126a.573.573 0 0 0-.341-1.01h-7.343a7.411 7.411 0 0 0-2.406.389 6.319 6.319 0 0 0-4.548 5.541 5.898 5.898 0 0 0 5.897 5.9l.11-.001a3.121 3.121 0 0 0-.108.776c.001.514.14 1.018.403 1.46h-.108a8.01 8.01 0 0 0-7.343 4.004A4.373 4.373 0 0 0 3 23.063c.01.632.194 1.25.528 1.786a6.536 6.536 0 0 0 4.269 2.747 13.74 13.74 0 0 0 3.368.357 10.86 10.86 0 0 0 2.996-.403 5.978 5.978 0 0 0 4.797-5.465 5.684 5.684 0 0 0-2.826-5.246z"
    }]
  },
  "social-instagram": {
    title: "social-instagram",
    g: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    path: [{
      d: "M25.333 2H6.667A4.66 4.66 0 0 0 2 6.667v18.666A4.66 4.66 0 0 0 6.667 30h18.666A4.66 4.66 0 0 0 30 25.333V6.667A4.66 4.66 0 0 0 25.333 2zm1.556 23.333a1.54 1.54 0 0 1-1.556 1.556H6.667a1.54 1.54 0 0 1-1.556-1.556V14.444h4.885c-.125.498-.218 1.027-.218 1.556 0 3.422 2.8 6.222 6.222 6.222 3.422 0 6.222-2.8 6.222-6.222 0-.529-.062-1.058-.218-1.556h4.885v10.89zm-14-9.333A3.12 3.12 0 0 1 16 12.889 3.12 3.12 0 0 1 19.111 16 3.12 3.12 0 0 1 16 19.111 3.12 3.12 0 0 1 12.889 16zm14-4.667h-6.782A6.161 6.161 0 0 0 16 9.778a6.161 6.161 0 0 0-4.107 1.555H5.111V6.667A1.54 1.54 0 0 1 6.667 5.11h18.666a1.54 1.54 0 0 1 1.556 1.556v4.666z"
    }, {
      d: "M22.222 6.667h3.111v3.111h-3.111z"
    }]
  },
  "social-linkedin": {
    title: "social-linkedin",
    path: {
      d: "M18.178 12.008v1.376l.002.677c1.623-1.591 3.296-2.794 5.97-2.794 3.155 0 6.206 1.321 6.206 5.628v11.903a1 1 0 0 1-.985 1l-3.565.053a1 1 0 0 1-1.015-1v-8.83c0-2.171-.544-3.57-3.136-3.57-2.284 0-3.24.409-3.24 3.414v8.93a1 1 0 0 1-.988 1l-4.73.057v-17.8a1 1 0 0 1 .987-1l3.482-.044a1 1 0 0 1 1.012 1zM8.28 5.202a3.14 3.14 0 1 1-6.28 0 3.14 3.14 0 0 1 6.281 0zM2.211 12.115v16.787a1 1 0 0 0 1.013 1l3.737-.047a1 1 0 0 0 .987-1V12.069a1 1 0 0 0-1.012-1l-3.737.046a1 1 0 0 0-.988 1z"
    }
  },
  "social-twitter": {
    title: "social-twitter",
    path: {
      d: "M26.5 7.001a5.714 5.714 0 0 0 2.506-3.152 11.398 11.398 0 0 1-3.617 1.383 5.696 5.696 0 0 0-9.853 3.897c0 .445.048.88.145 1.299a16.173 16.173 0 0 1-11.744-5.95c-.491.839-.771 1.817-.771 2.863A5.692 5.692 0 0 0 5.7 12.083a5.684 5.684 0 0 1-2.582-.714v.071a5.7 5.7 0 0 0 4.57 5.587 5.726 5.726 0 0 1-2.571.097 5.696 5.696 0 0 0 5.319 3.957A11.42 11.42 0 0 1 3.36 23.52c-.46 0-.914-.028-1.361-.08A16.12 16.12 0 0 0 10.734 26c10.48 0 16.21-8.681 16.21-16.21 0-.247-.004-.494-.014-.738a11.478 11.478 0 0 0 2.842-2.948c-1.02.454-2.118.76-3.272.897z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "social-you-tube": {
    title: "social-you-tube",
    path: {
      d: "M11.033 22.328l-.002-14.085 11.818 7.067-11.816 7.018zM28.657 6.03c-1.066-1.277-2.259-1.284-2.807-1.359-3.917-.322-9.793-.322-9.793-.322-.014 0-5.89 0-9.81.322-.546.075-1.739.082-2.805 1.36-.839.972-1.111 3.184-1.111 3.184s-.281 2.598-.281 5.194v2.433c0 2.598.281 5.193.281 5.193s.272 2.212 1.111 3.185c1.066 1.278 2.466 1.237 3.09 1.373 2.238.246 9.518.32 9.518.32s5.883-.009 9.8-.334c.548-.074 1.741-.081 2.807-1.359.84-.973 1.112-3.185 1.112-3.185s.28-2.595.28-5.193V14.41c0-2.596-.28-5.194-.28-5.194s-.273-2.212-1.112-3.185z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  distributor: {
    title: "distributor",
    path: {
      d: "M17.419 7h10.656c.923.005 1.67.753 1.675 1.675V22.36a1.684 1.684 0 0 1-1.67 1.67h-1.483a3.756 3.756 0 0 1-3.545 2.43 3.818 3.818 0 0 1-3.54-2.43h-7.5a3.755 3.755 0 0 1-3.536 2.43 3.817 3.817 0 0 1-3.54-2.43h-1.26A1.685 1.685 0 0 1 2 22.366v-5.59a2.6 2.6 0 0 1 .41-1.404l3.675-5.774c.324-.512.888-.82 1.494-.82h5.54c.713.001 1.29.58 1.292 1.29v8.395c0 .03.441.03 1.324 0v-9.78c0-.93.754-1.684 1.684-1.684zm-9.42 3.824a.727.727 0 0 0-.615.34L4.79 15.241a.731.731 0 0 0 .617 1.122h4.944a.73.73 0 0 0 .73-.73v-4.08a.73.73 0 0 0-.73-.729H8zm14.863 13.763a1.897 1.897 0 1 0 0-3.793 1.897 1.897 0 0 0 0 3.793zm-14.483 0a1.897 1.897 0 1 0 0-3.793 1.897 1.897 0 0 0 0 3.793z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  manufacture: {
    title: "manufacture",
    path: {
      d: "M23.42 17.947h4.452v-2.36h-4.451v2.36zm0 3.846h4.452v-2.36h-4.451v2.36zm-6.36-3.846h4.452v-2.36H17.06v2.36zm0 3.846h4.452v-2.36H17.06v2.36zm-6.372-3.846h4.451v-2.36h-4.451v2.36zm0 3.846h4.451v-2.36h-4.451v2.36zm-6.349-3.846H8.79v-2.36H4.34v2.36zm0 3.846H8.79v-2.36H4.34v2.36zM24.352 9.05v2.618h-3.903L15.5 6.71a1 1 0 0 0-1.709.706v3.808a.407.407 0 0 1-.407.408H9.356a1 1 0 0 1-.782-.377L3.782 5.238A1 1 0 0 0 2 5.861V27a1 1 0 0 0 1 1h26.175a1 1 0 0 0 1-1V12.036a1 1 0 0 0-.384-.788l-3.824-2.986a1 1 0 0 0-1.615.788z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  "thomas-social-icon": {
    title: "thomas-social-icon",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      fillRule: "nonzero",
      d: "M7 25.381h5.689V12.378H7zM24.88 6.69V1H7v5.69zM19.19 25.381h5.689V12.378H19.19z"
    }, {
      d: "M7.012 28.04v.63h.733v1.986h.725V28.67h.733v-.631zM11.555 28.04v.953h-.815v-.953h-.741v2.616h.741v-1.031h.815v1.03h.739V28.04zM14.299 28.63c-.292 0-.457.243-.457.714s.173.722.464.722c.291 0 .456-.244.456-.715 0-.47-.172-.721-.463-.721m0 2.067c-.71 0-1.208-.474-1.208-1.346 0-.87.505-1.353 1.215-1.353.71 0 1.207.475 1.207 1.346 0 .87-.504 1.353-1.214 1.353M18.254 30.656v-.624c0-.258.004-.494.015-.695a14.06 14.06 0 0 1-.303.684l-.344.725-.344-.725a14.06 14.06 0 0 1-.303-.684c.011.201.015.437.015.695v.624h-.68V28.04h.665l.322.7c.157.336.288.642.329.788.044-.149.164-.434.329-.788l.321-.7h.658v2.617h-.68zM21.162 29.449c-.093-.337-.134-.479-.168-.655-.034.176-.075.322-.168.655l-.049.172h.434l-.049-.172zm.366 1.207l-.142-.46h-.785l-.142.46h-.777l.95-2.617h.732l.95 2.617h-.786zM24.063 30.697a2.09 2.09 0 0 1-1.103-.317l.352-.569c.19.13.523.262.766.262.258 0 .34-.045.34-.168 0-.098-.093-.157-.445-.24-.631-.145-.934-.317-.934-.84 0-.494.4-.827 1.032-.827.444 0 .766.109 1.043.303l-.352.568c-.232-.157-.463-.246-.728-.246-.217 0-.27.067-.27.16 0 .098.094.142.43.22.658.158.95.36.95.85 0 .597-.453.844-1.08.844M26.066 28.135v.533h-.094v-.533h-.182v-.091h.458v.09zM26.84 28.668v-.33l.001-.11a4.155 4.155 0 0 1-.04.098l-.151.351-.15-.351a4.155 4.155 0 0 1-.04-.098l.002.11v.33h-.089v-.625h.096l.14.333c.016.035.035.081.044.107.008-.026.026-.07.042-.107l.137-.333h.1v.625h-.092z"
    }]
  },
  trash: {
    title: "trash",
    path: {
      d: "M3.06 25.99a2 2 0 002 2.01h13.47a2 2 0 002.01-2.01l.77-16.66h-19l.75 16.66zm12.3-13.32c0-.58.35-1.05.89-1.05.59 0 .9.47.9 1.05v11.5c0 .6-.31 1.05-.88 1.05-.57 0-.9-.46-.9-1.05v-11.5h-.01zm-4.46 0c0-.58.32-1.05.9-1.05.55 0 .89.47.89 1.05v11.5c0 .6-.34 1.05-.9 1.05-.57 0-.89-.46-.89-1.05v-11.5zm-4.5 0c0-.58.33-1.05.89-1.05.58 0 .9.47.9 1.05v11.5c0 .6-.32 1.05-.89 1.05-.57 0-.89-.46-.89-1.05v-11.5H6.4zm15.57-8.61h-5.54V1.05c0-.61-.27-1.05-.86-1.05H8.11c-.6 0-.93.44-.93 1.05v3.01h-5.5c-.58 0-.95.47-.95 1.12v1.28c0 .65.36 1.31.94 1.31H22c.6 0 .9-.7.9-1.31V5.18c-.02-.65-.34-1.12-.93-1.12zm-7.4 0H9.03V2.03h5.53v2.03h.01z",
      fill: "currentColor"
    }
  },
  menu: {
    title: "menu-icon",
    g: {
      fill: "currentColor",
      fillRule: "evenodd"
    },
    path: [{
      d: "M30.427,2.016c0,1.112-0.865,2.013-1.931,2.013H1.93C0.865,4.029,0,3.126,0,2.016l0,0  c0-1.112,0.865-2.014,1.93-2.014h26.564C29.562,0.002,30.427,0.906,30.427,2.016L30.427,2.016z"
    }, {
      d: "M30.427,10.583c0,1.113-0.865,2.014-1.931,2.014H1.93C0.865,12.597,0,11.696,0,10.583l0,0  c0-1.109,0.865-2.013,1.93-2.013h26.564C29.562,8.569,30.427,9.473,30.427,10.583L30.427,10.583"
    }, {
      d: "M30.427,19.149c0,1.112-0.865,2.014-1.931,2.014H1.93c-1.065,0-1.93-0.901-1.93-2.014l0,0  c0-1.11,0.865-2.015,1.93-2.015h26.564C29.562,17.134,30.427,18.039,30.427,19.149L30.427,19.149z"
    }]
  },
  lock: {
    title: "lock",
    path: {
      d: "M15.45 9.33V7.3c0-2.3-1.87-4.17-4.17-4.17h-.27a4.17 4.17 0 00-4.17 4.17v2.04c-1.05.08-2.1.2-3.13.34V7.28A7.3 7.3 0 0111.02 0h.28a7.3 7.3 0 017.28 7.29v2.38a53.45 53.45 0 00-3.13-.34zM1.48 12.61a52.06 52.06 0 0119.36 0 1.8 1.8 0 011.47 1.79v10.98c0 .78-.55 1.46-1.32 1.6l-1 .2a47.51 47.51 0 01-17.66 0l-1-.2A1.63 1.63 0 010 25.38V14.23c0-.78.56-1.45 1.33-1.6l.15-.02zm11.5 10.25a5.02 5.02 0 01-3.65 0 .4.4 0 01-.23-.52l.95-2.68a1.79 1.79 0 112.22 0l.95 2.68a.4.4 0 01-.24.52z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  gear: {
    title: "gear",
    path: {
      d: "M27.74 13.76c0-.45-.26-.86-.65-1.03l-2.99-1.32c-.21-.84-.52-1.61-.92-2.36l1.2-3.08c.17-.41.08-.9-.23-1.21l-1-1.04c-.3-.32-.76-.42-1.15-.25l-2.95 1.27a9.37 9.37 0 00-2.25-.97L15.56.68a1.07 1.07 0 00-.98-.68h-1.42c-.43 0-.82.27-.98.68L10.9 3.8c-.79.22-1.54.55-2.25.97L5.71 3.5c-.4-.17-.85-.07-1.16.25l-1 1.04c-.3.32-.4.8-.23 1.21L4.53 9.1c-.4.74-.71 1.53-.92 2.35l-2.96 1.3c-.4.16-.65.57-.65 1.02v1.48c0 .45.26.86.65 1.03l2.99 1.32c.2.83.52 1.62.92 2.36l-1.2 3.08c-.17.42-.08.9.22 1.21l1 1.04c.3.32.77.42 1.16.25l2.95-1.27c.7.42 1.47.75 2.25.97l1.24 3.09c.16.41.55.68.98.68h1.42c.43 0 .82-.27.98-.68l1.27-3.12a9.38 9.38 0 002.25-.97l2.95 1.27c.4.17.85.07 1.16-.25l1-1.04c.3-.32.4-.8.23-1.21L23.2 19.9c.4-.74.71-1.53.92-2.35l2.96-1.3c.4-.17.65-.57.65-1.02v-1.48zm-8.12.74c0 1.62-.64 3.14-1.8 4.27a5.93 5.93 0 01-8.34 0 5.98 5.98 0 1110.14-4.27z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  },
  covid: {
    title: "Covid-19 Response Supplier",
    path: {
      d: "M27.6 9.86l-3.22-5.57a.89.89 0 00-1.2-.32l-5.1 2.97V1.02a.88.88 0 00-.87-.87h-6.42a.88.88 0 00-.87.87v5.92L4.78 3.97a.9.9 0 00-1.2.32L.39 9.86a.9.9 0 00.32 1.2L5.83 14 .7 16.95c-.4.26-.55.78-.3 1.2l3.22 5.56c.23.41.75.56 1.2.32l5.1-2.97v5.92c0 .47.38.87.87.87h6.42c.46 0 .87-.38.87-.87v-5.92L23.22 24a.9.9 0 001.2-.32l3.2-5.57a.9.9 0 00-.32-1.2L22.17 14l5.13-2.95c.4-.26.55-.78.3-1.2z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  users: {
    title: "users",
    path: {
      d: "M7.068 13.882a3.443 3.443 0 100-6.886 3.443 3.443 0 000 6.886zM11.451 16.56a3.646 3.646 0 00-3.12-1.766h-2.56c-1.853 0-3.413 1.383-3.619 3.207L1.8 21.003c-.059.382.206.735.589.824 1.471.323 3.03.47 4.678.47.824 0 1.619-.029 2.413-.117l.324-2.56a4.86 4.86 0 011.648-3.06zM24.482 13.882a3.443 3.443 0 100-6.886 3.443 3.443 0 000 6.886zM29.406 18.03c-.206-1.824-1.766-3.207-3.62-3.207h-2.56a3.646 3.646 0 00-3.119 1.766 4.624 4.624 0 011.678 3.06l.323 2.56a21.72 21.72 0 002.413.118c1.619 0 3.208-.176 4.679-.47a.77.77 0 00.588-.825l-.382-3.001zM17.042 16.56h-2.56c-1.854 0-3.413 1.382-3.62 3.207l-.352 2.972c-.06.382.206.765.588.824 1.472.323 3.06.47 4.679.47 1.618 0 3.208-.176 4.679-.47a.77.77 0 00.588-.824l-.353-2.972a3.683 3.683 0 00-3.649-3.208zM15.779 15.617a3.443 3.443 0 100-6.886 3.443 3.443 0 000 6.886z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  },
  billing: {
    title: "billing",
    g: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    path: [{
      d: "M3.32 15.29H.12v11h3.2zM27.02 20.39l-6.63 2.57h-.07l-.12.07h-.06c-.25.06-.43.12-.68.12h-7.98a.68.68 0 01-.67-.68c0-.36.3-.67.67-.67h7.92c.13 0 .25 0 .37-.06h.06a1.1 1.1 0 00-.5-2.09H15a.56.56 0 01-.49-.25 6.87 6.87 0 00-4.97-2.15H4.54v6.94l8.72 3.13c1.72.62 3.63.5 5.28-.3l12.28-5.9a3.47 3.47 0 00-3.8-.73zM19.28 13.94a6.84 6.84 0 006.82-6.82A6.84 6.84 0 0019.28.31a6.84 6.84 0 00-6.82 6.81 6.84 6.84 0 006.82 6.82zm0-6.14a2.6 2.6 0 01-2.58-2.58c0-1.17.8-2.21 1.9-2.46V2.7c0-.37.31-.67.68-.67.37 0 .68.3.68.67v.06c1.1.31 1.9 1.3 1.9 2.46 0 .37-.3.67-.68.67a.68.68 0 01-.67-.67 1.23 1.23 0 00-2.46 0c0 .67.55 1.23 1.23 1.23a2.6 2.6 0 012.58 2.58 2.5 2.5 0 01-1.9 2.45v.06c0 .37-.31.68-.68.68a.68.68 0 01-.68-.68v-.06a2.56 2.56 0 01-1.9-2.45c0-.37.3-.68.68-.68.37 0 .67.3.67.68a1.23 1.23 0 002.46 0c0-.68-.55-1.23-1.23-1.23z"
    }]
  }
}];

var getClassNames = function getClassNames(classes) {
  return classes.filter(Boolean).join(" ");
};

var config = {
  color: {
    // Primary: Green
    green: "icon--primary",
    primary: "icon--primary",
    // Secondary: Blue
    blue: "icon--secondary",
    secondary: "icon--secondary",
    // Darker Blues
    "blue-medium": "icon--blue-medium",
    "medium-blue": "icon--blue-medium",
    "blue-dark": "icon--blue-dark",
    "dark-blue": "icon--blue-dark",
    // Cyans
    cyan: "icon--info",
    info: "icon--info",
    // Grays
    gray: "icon--gray",
    "gray-medium": "icon--gray-medium",
    "medium-gray": "icon--gray-medium",
    "gray-dark": "icon--gray-dark",
    "dark-gray": "icon--gray-dark",
    // Light + Dark
    light: "icon--light",
    white: "icon--light",
    dark: "icon--dark",
    black: "icon--dark",
    // Reds
    red: "icon--danger",
    danger: "icon--danger",
    // Yellows
    yellow: "icon--warning",
    warning: "icon--warning"
  },
  size: {
    xs: "icon--xs",
    sm: "icon--sm",
    base: "icon--base",
    md: "icon--md",
    lg: "icon--lg",
    xl: "icon--xl"
  }
};

var Icon = function Icon(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      disableTitle = _ref.disableTitle,
      size = _ref.size,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["children", "className", "color", "disableTitle", "size", "type"]); // Consolidate icon properties: size, color, etc.


  var classes = getClassNames(["icon", config.color[color], config.size[size], className]);

  var PathItem = function PathItem(_ref2) {
    var props = _extends({}, _ref2);

    return (
      /*#__PURE__*/
      React.createElement("path", props)
    );
  };

  var SVG = function SVG(_ref3) {
    var title = _ref3.title,
        children = _ref3.children;
    return (
      /*#__PURE__*/
      React.createElement("svg", _extends({
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        className: classes
      }, props), !!disableTitle ? null :
      /*#__PURE__*/
      React.createElement("title", null, title), children)
    );
  };

  if (children) {
    return (
      /*#__PURE__*/
      React.createElement(SVG, {
        disableTitle: true
      }, children)
    );
  }

  var renderIconFromLib = data.map(function (icon, index) {
    var _icon$type = icon[type],
        path = _icon$type.path,
        g = _icon$type.g,
        title = _icon$type.title; // For SVG icon with multiple paths

    if (g) {
      var PathList = path.map(function (iconPath, index) {
        return (
          /*#__PURE__*/
          React.createElement(PathItem, _extends({
            key: index
          }, iconPath))
        );
      });
      return (
        /*#__PURE__*/
        React.createElement(SVG, {
          key: index,
          title: title
        },
        /*#__PURE__*/
        React.createElement("g", g, PathList))
      );
    } // SVG Icon with single path


    return (
      /*#__PURE__*/
      React.createElement(SVG, {
        key: index,
        title: title
      },
      /*#__PURE__*/
      React.createElement(PathItem, path))
    );
  });
  return renderIconFromLib;
};

Icon.defaultProps = {
  type: "emailPref"
};
Icon.propTypes = {
  type: PropTypes.string.isRequired,
  color: PropTypes.oneOf(Object.keys(config.color)),
  size: PropTypes.oneOf(Object.keys(config.size))
};
var config$1 = {
  color: {
    primary: "spinner-primary",
    secondary: "spinner-secondary",
    light: "spinner-light",
    // default
    dark: "spinner-dark"
  },
  variant: {
    horizontal: "horizontal-spinner",
    vertical: "vertical-spinner"
  }
};

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      color = _ref.color,
      variant = _ref.variant,
      other = _objectWithoutProperties(_ref, ["className", "color", "variant"]);

  var classes = ["spinner", "v5", className, config$1.color[color], config$1.variant[variant]];
  return (
    /*#__PURE__*/
    React.createElement("div", _extends({
      className: getClassNames(classes)
    }, other),
    /*#__PURE__*/
    React.createElement("div", {
      className: "rect1"
    }),
    /*#__PURE__*/
    React.createElement("div", {
      className: "rect2"
    }),
    /*#__PURE__*/
    React.createElement("div", {
      className: "rect3"
    }),
    /*#__PURE__*/
    React.createElement("div", {
      className: "rect4"
    }),
    /*#__PURE__*/
    React.createElement("div", {
      className: "rect5"
    }))
  );
};

Spinner.defaultProps = {
  color: "light"
};
Spinner.propTypes = {
  color: PropTypes.oneOf(Object.keys(config$1.color)),
  variant: PropTypes.oneOf(Object.keys(config$1.variant))
};
var config$2 = {
  color: {
    primary: "btn-primary",
    secondary: "btn-secondary",
    transparent: "btn-transparent"
  },
  display: {
    block: "d-block",
    inline: "d-inline",
    "inline-block": "d-inline-block"
  },
  size: {
    sm: "btn-sm",
    md: "btn-md",
    lg: "btn-lg",
    xl: "btn-xl",
    block: "btn-block",
    "sm-block": "btn-sm btn-block",
    "md-block": "btn-md btn-block",
    "lg-block": "btn-lg btn-block",
    "xl-block": "btn-xl btn-block"
  },
  variant: {
    btn: "btn",
    link: "btn btn-link" // gradient: "btn-gradient",
    // solid: "btn-solid",
    // outline: "btn-outline"

  }
};

var RenderButtonText = function RenderButtonText(_ref) {
  var icon = _ref.icon,
      text = _ref.text;

  if (icon) {
    return (
      /*#__PURE__*/
      React.createElement(React.Fragment, null,
      /*#__PURE__*/
      React.createElement(Icon, {
        type: icon,
        style: text ? {
          marginRight: ".2rem"
        } : null
      }), text)
    );
  }

  return text;
}; // --• Button Component


var Button = function Button(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      display = props.display,
      disabled = props.disabled,
      href = props.href,
      icon = props.icon,
      loading = props.loading,
      size = props.size,
      tabIndex = props.tabIndex,
      type = props.type,
      variant = props.variant,
      other = _objectWithoutProperties(props, ["children", "className", "color", "display", "disabled", "href", "icon", "loading", "size", "tabIndex", "type", "variant"]); // Combine values from size, color, & className and set to className prop.


  var classes = [config$2.variant[variant], config$2.color[color], config$2.display[display], config$2.size[size], className]; // Note: To use React Link just pass <Link> as a child to Button.

  if (href) {
    return (
      /*#__PURE__*/
      React.createElement("a", _extends({
        href: disabled ? "#" : href,
        className: getClassNames(classes),
        tabIndex: tabIndex,
        type: type,
        disabled: disabled
      }, other),
      /*#__PURE__*/
      React.createElement(RenderButtonText, {
        icon: icon,
        text: children
      }))
    );
  }

  return (
    /*#__PURE__*/
    React.createElement("button", _extends({
      className: getClassNames(classes),
      tabIndex: tabIndex,
      type: type,
      disabled: disabled ? disabled : loading
    }, other), loading ?
    /*#__PURE__*/
    React.createElement(Spinner, null) :
    /*#__PURE__*/
    React.createElement(RenderButtonText, {
      icon: icon,
      text: children
    }))
  );
};

Button.defaultProps = {
  color: "primary",
  loading: false,
  tabIndex: 0,
  type: "button",
  variant: "btn"
};
Button.propTypes = {
  color: PropTypes.oneOf(Object.keys(config$2.color)),
  size: PropTypes.oneOf(Object.keys(config$2.size)),
  variant: PropTypes.oneOf(Object.keys(config$2.variant))
};

var Card = function Card(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return (
    /*#__PURE__*/
    React.createElement("div", _extends({
      className: "content-card ".concat(className ? className : "")
    }, props), children)
  );
};

var config$3 = {
  size: {
    xxs: "container--xxs",
    xs: "container--xs",
    sm: "container--sm",
    md: "container--md",
    lg: "container--lg",
    xl: "container--xl",
    fluid: "container--fluid"
  }
};

var Container = function Container(_ref) {
  var className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      other = _objectWithoutProperties(_ref, ["className", "children", "size"]);

  var classes = ["container", className, config$3.size[size]];
  return (
    /*#__PURE__*/
    React.createElement("div", _extends({
      className: getClassNames(classes)
    }, other), children)
  );
};

Container.propTypes = {
  size: PropTypes.oneOf(Object.keys(config$3.size))
}; // https://kazzkiq.github.io/balloon.css/

var LabelToolTip = function LabelToolTip(_ref) {
  var tooltip = _ref.tooltip,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "up" : _ref$position;
  return (
    /*#__PURE__*/
    React.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        return e.preventDefault();
      },
      className: "label-tooltip",
      "aria-label": tooltip,
      "data-balloon-pos": position
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      type: "help-info",
      disableTitle: true
    }))
  );
};

LabelToolTip.defaultProps = {
  position: "up"
};
LabelToolTip.propTypes = {
  position: PropTypes.oneOf(["up", "down", "left", "right", "up-left", "up-right", "down-left", "down-right"])
};

var LabelHelpText = function LabelHelpText(_ref) {
  var value = _ref.value;
  return (
    /*#__PURE__*/
    React.createElement("span", {
      className: "labelHelpText font-size-sm"
    }, "(", value, ")")
  );
};

var RenderLabelText = function RenderLabelText(_ref2) {
  var label = _ref2.label,
      helpText = _ref2.helpText,
      tooltip = _ref2.tooltip,
      position = _ref2.position;

  switch (true) {
    case !!tooltip && !!helpText:
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null, label,
        /*#__PURE__*/
        React.createElement(LabelToolTip, {
          tooltip: tooltip,
          position: position
        }),
        /*#__PURE__*/
        React.createElement(LabelHelpText, {
          value: helpText
        }))
      );

    case !!tooltip:
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null, label,
        /*#__PURE__*/
        React.createElement(LabelToolTip, {
          tooltip: tooltip,
          position: position
        }))
      );

    case !!helpText:
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null, label,
        /*#__PURE__*/
        React.createElement(LabelHelpText, {
          value: helpText
        }))
      );

    default:
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null, label)
      );
  }
};

var Label = function Label(props) {
  var className = props.className,
      label = props.label,
      helpText = props.helpText,
      children = props.children,
      tooltip = props.tooltip,
      tooltipPosition = props.tooltipPosition,
      other = _objectWithoutProperties(props, ["className", "label", "helpText", "children", "tooltip", "tooltipPosition"]);

  return (
    /*#__PURE__*/
    React.createElement("label", _extends({
      className: className ? "label ".concat(className) : "label"
    }, other),
    /*#__PURE__*/
    React.createElement(RenderLabelText, {
      helpText: helpText,
      tooltip: tooltip,
      position: tooltipPosition,
      label: label
    }), children)
  );
};

Label.defaultProps = {
  helpText: false
};

var BoxCheckbox = function BoxCheckbox(props) {
  var handleFocus = function handleFocus(e) {
    var isFocus = document.activeElement == e.target ? true : false;
    e.target.parentElement.setAttribute("data-focused", isFocus);
  };

  var className = props.className,
      checked = props.checked,
      disabled = props.disabled,
      label = props.label,
      type = props.type,
      other = _objectWithoutProperties(props, ["className", "checked", "disabled", "label", "type"]);

  return (
    /*#__PURE__*/
    React.createElement(Label, {
      className: className ? "box-checkbox ".concat(className) : "box-checkbox",
      "data-checked": !!checked,
      "data-focused": false,
      onFocus: handleFocus,
      onBlur: handleFocus,
      disabled: disabled,
      label: label
    },
    /*#__PURE__*/
    React.createElement("input", _extends({
      className: "box-input",
      type: type,
      checked: checked,
      tabIndex: 0,
      disabled: disabled
    }, other)))
  );
};

BoxCheckbox.defaultProps = {
  disabled: false,
  label: "Enter Label Value",
  type: "checkbox"
};
BoxCheckbox.propTypes = {
  checked: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired
};
var config$4 = {
  display: {
    inline: "d-inline",
    "inline-block": "d-inline-block",
    block: "d-block"
  },
  position: {
    left: "checkbox-left",
    right: "checkbox-right"
  }
};

var RenderToolTip = function RenderToolTip(_ref) {
  var label = _ref.label,
      tooltip = _ref.tooltip,
      position = _ref.position;

  if (tooltip) {
    return (
      /*#__PURE__*/
      React.createElement("span", {
        className: "tooltip-wrapper"
      }, label,
      /*#__PURE__*/
      React.createElement(LabelToolTip, {
        tooltip: tooltip,
        position: position
      }))
    );
  }

  return label || false;
};

var Checkbox = function Checkbox(props) {
  var className = props.className,
      disabled = props.disabled,
      display = props.display,
      id = props.id,
      inverted = props.inverted,
      label = props.label,
      position = props.position,
      tabIndex = props.tabIndex,
      tooltip = props.tooltip,
      tooltipPosition = props.tooltipPosition,
      other = _objectWithoutProperties(props, ["className", "disabled", "display", "id", "inverted", "label", "position", "tabIndex", "tooltip", "tooltipPosition"]);

  var classes = getClassNames(["form-field", "checkbox-form-field", className, config$4.display[display]]);
  var labelClasses = getClassNames([config$4.position[position], disabled ? "disabled" : null, inverted ? "label-inverted" : null]);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: classes,
      "data-checked": props.value
    },
    /*#__PURE__*/
    React.createElement(Label, {
      className: labelClasses,
      htmlFor: id
    },
    /*#__PURE__*/
    React.createElement("input", _extends({
      id: id,
      className: "checkbox",
      disabled: disabled,
      tabIndex: tabIndex,
      type: "checkbox"
    }, other)),
    /*#__PURE__*/
    React.createElement("div", {
      className: "pseudo-checkbox"
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      type: "checkmark"
    })),
    /*#__PURE__*/
    React.createElement(RenderToolTip, {
      label: label,
      tooltip: tooltip,
      position: tooltipPosition
    })))
  );
};

Checkbox.defaultProps = {
  position: "left",
  tabIndex: 0
};
Checkbox.propTypes = {
  position: PropTypes.oneOf(Object.keys(config$4.position)),
  tooltipPosition: PropTypes.oneOf(["left", "right", "up", "down"])
};

var FormikDebug = function FormikDebug(props) {
  return (
    /*#__PURE__*/
    React.createElement("pre", {
      style: {
        background: "#f6f8fa",
        fontSize: ".65rem",
        padding: ".5rem"
      }
    },
    /*#__PURE__*/
    React.createElement("strong", null, "Props"), " = ", JSON.stringify(props, null, 2))
  );
};

var FormikBoxCheckbox = function FormikBoxCheckbox(props) {
  var className = props.className,
      htmlId = props.htmlId,
      fieldName = props.fieldName,
      labelText = props.labelText,
      validate = props.validate,
      type = props.type,
      onChange = props.onChange,
      others = _objectWithoutProperties(props, ["className", "htmlId", "fieldName", "labelText", "validate", "type", "onChange"]);

  return (
    /*#__PURE__*/
    // Note: imported from Thomas.UI React Blue Print Project.
    // Original Author: Ben
    // Modified: DK
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Field, _extends({
      name: fieldName
    }, others, {
      validate: validate,
      type: type
    }), function (_ref) {
      var field = _ref.field,
          meta = _ref.meta;
      var isValidClassName;

      if (meta.touched && validate) {
        isValidClassName = !!meta.error ? "is-invalid" : "is-valid";
      }

      return (
        /*#__PURE__*/
        React.createElement(BoxCheckbox, _extends({
          id: htmlId,
          label: labelText,
          className: isValidClassName
        }, others, field, {
          type: type
        }))
      );
    }),
    /*#__PURE__*/
    React.createElement(ErrorMessage, {
      id: "".concat(htmlId, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: fieldName
    }))
  );
};

FormikBoxCheckbox.defaultProps = {
  type: "checkbox"
};

var FormikCheckbox = function FormikCheckbox(props) {
  var htmlId = props.htmlId,
      fieldName = props.fieldName,
      labelText = props.labelText,
      labelHelpText = props.labelHelpText,
      validate = props.validate,
      others = _objectWithoutProperties(props, ["htmlId", "fieldName", "labelText", "labelHelpText", "validate"]);

  return (
    /*#__PURE__*/
    // Note: imported from Thomas.UI React Blue Print Project.
    // Original Author: Ben
    // Modified: DK
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Field, _extends({
      name: fieldName,
      validate: validate,
      type: "checkbox"
    }, others), function (_ref) {
      var field = _ref.field,
          meta = _ref.meta;
      var isValidClassName;

      if (meta.touched && validate) {
        isValidClassName = !!meta.error ? "is-invalid" : "is-valid";
      }

      return (
        /*#__PURE__*/
        React.createElement(Checkbox, _extends({
          id: htmlId,
          className: isValidClassName,
          label: labelText
        }, others, field))
      );
    }),
    /*#__PURE__*/
    React.createElement(ErrorMessage, {
      id: "".concat(htmlId, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: fieldName
    }))
  );
};

var RenderIcon = function RenderIcon(_ref) {
  var validation = _ref.validation;
  if (!validation) return false;
  var iconType = validation === "is-valid" ? "checkmark" : "close";
  return (
    /*#__PURE__*/
    React.createElement("span", {
      className: "validation-icon"
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      type: iconType
    }))
  );
};

var RenderPasswordToggle = function RenderPasswordToggle(_ref2) {
  var isHidden = _ref2.isHidden,
      onClick = _ref2.onClick;
  return (
    /*#__PURE__*/
    React.createElement("span", {
      className: "input-action link font-size-xs",
      onClick: onClick
    }, isHidden ? "Show" : "Hide")
  );
};

var InputField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputField, _React$Component);

  var _super = _createSuper(InputField);

  function InputField(props) {
    var _this;

    _classCallCheck(this, InputField);

    _this = _super.call(this, props);
    _this.state = {
      type: props.type,
      hidden: props.type === "password"
    };
    _this.inputRef =
    /*#__PURE__*/
    React.createRef();
    _this.handlePasswordToggle = _this.handlePasswordToggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputField, [{
    key: "handlePasswordToggle",
    value: function handlePasswordToggle() {
      this.setState({
        hidden: !this.state.hidden,
        type: this.state.hidden ? "text" : "password"
      });
      this.state.hidden && this.inputRef.current.focus();
    } // ---• Input Component

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          id = _this$props.id,
          status = _this$props.status,
          label = _this$props.label,
          labelHelpText = _this$props.labelHelpText,
          tooltip = _this$props.tooltip,
          tooltipPosition = _this$props.tooltipPosition,
          type = _this$props.type,
          passwordToggle = _this$props.passwordToggle,
          onChange = _this$props.onChange,
          other = _objectWithoutProperties(_this$props, ["className", "id", "status", "label", "labelHelpText", "tooltip", "tooltipPosition", "type", "passwordToggle", "onChange"]);

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: status ? "form-field ".concat(status) : "form-field"
        }, label &&
        /*#__PURE__*/
        React.createElement(Label, {
          label: label,
          helpText: labelHelpText,
          htmlFor: id,
          tooltip: tooltip,
          tooltipPosition: tooltipPosition
        }), type === "password" && !!passwordToggle &&
        /*#__PURE__*/
        React.createElement(RenderPasswordToggle, {
          isHidden: this.state.hidden,
          onClick: this.handlePasswordToggle
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: "input-group"
        },
        /*#__PURE__*/
        React.createElement("input", _extends({
          id: id,
          className: className ? "form-control ".concat(className) : "form-control",
          type: this.state.type,
          onChange: onChange,
          ref: this.inputRef
        }, other)),
        /*#__PURE__*/
        React.createElement(RenderIcon, {
          validation: status
        })))
      );
    }
  }]);

  return InputField;
}(React.Component);

InputField.defaultProps = {
  type: "text",
  passwordToggle: true
};
InputField.propTypes = {
  type: PropTypes.string,
  status: PropTypes.oneOf(["is-valid", "is-invalid"])
};

var FormikInputField = function FormikInputField(props) {
  var htmlId = props.htmlId,
      fieldName = props.fieldName,
      labelText = props.labelText,
      labelHelpText = props.labelHelpText,
      validate = props.validate,
      inlineValSuccess = props.inlineValSuccess,
      inlineValError = props.inlineValError,
      others = _objectWithoutProperties(props, ["htmlId", "fieldName", "labelText", "labelHelpText", "validate", "inlineValSuccess", "inlineValError"]);

  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Field, _extends({
      name: fieldName,
      validate: validate
    }, others), function (_ref) {
      var field = _ref.field,
          meta = _ref.meta;
      field.value = field.value || ""; // Validation Classname Output

      var isValidClassName;

      if (meta.touched && validate) {
        // Update: 4/21/20 --> Allow on/off of each validation type (success or error)
        switch (true) {
          // Turn off success inline validation
          case !inlineValSuccess && !meta.error:
            isValidClassName = null;
            break;
          // Turn off error inline validation

          case !inlineValError && !!meta.error:
            isValidClassName = null;
            break;

          default:
            isValidClassName = !!meta.error ? "is-invalid" : "is-valid";
            break;
        }
      }

      return (
        /*#__PURE__*/
        React.createElement(InputField, _extends({
          id: htmlId,
          label: labelText,
          labelHelpText: labelHelpText,
          status: isValidClassName
        }, field, others))
      );
    }), inlineValError &&
    /*#__PURE__*/
    React.createElement(ErrorMessage, {
      id: "".concat(htmlId, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: fieldName || htmlId
    }))
  );
};

FormikInputField.defaultProps = {
  inlineValSuccess: true,
  inlineValError: true
};
var config$5 = {
  position: {
    left: "radio-left",
    right: "radio-right",
    top: "radio-top",
    "top-center": "radio-top-center",
    bottom: "radio-bottom",
    "bottom-center": "radio-bottom-center"
  }
};

var RenderToolTip$1 = function RenderToolTip(_ref) {
  var label = _ref.label,
      tooltip = _ref.tooltip,
      position = _ref.position;

  if (tooltip) {
    return (
      /*#__PURE__*/
      React.createElement("span", {
        className: "tooltip-wrapper"
      }, label,
      /*#__PURE__*/
      React.createElement(LabelToolTip, {
        tooltip: tooltip,
        position: position
      }))
    );
  }

  return label;
};

var Radio = function Radio(_ref2) {
  var className = _ref2.className,
      disabled = _ref2.disabled,
      id = _ref2.id,
      inverted = _ref2.inverted,
      label = _ref2.label,
      tooltip = _ref2.tooltip,
      tooltipPosition = _ref2.tooltipPosition,
      position = _ref2.position,
      other = _objectWithoutProperties(_ref2, ["className", "disabled", "id", "inverted", "label", "tooltip", "tooltipPosition", "position"]);

  var labelClasses = [className, config$5.position[position], disabled ? "disabled" : null, inverted ? "label-inverted" : null];
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "form-field radio-form-field"
    },
    /*#__PURE__*/
    React.createElement(Label, {
      className: getClassNames(labelClasses),
      htmlFor: id
    },
    /*#__PURE__*/
    React.createElement("input", _extends({
      id: id,
      className: "radio",
      type: "radio",
      disabled: disabled,
      tabIndex: "0"
    }, other)),
    /*#__PURE__*/
    React.createElement("div", {
      className: "pseudo-radio"
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "icon"
    })),
    /*#__PURE__*/
    React.createElement(RenderToolTip$1, {
      label: label,
      tooltip: tooltip,
      position: tooltipPosition
    })))
  );
};

Radio.defaultProps = {
  position: "left",
  disabled: false
};
Radio.propTypes = {
  position: PropTypes.oneOf(Object.keys(config$5.position))
};

var FormikRadio = function FormikRadio(_ref) {
  var htmlId = _ref.htmlId,
      fieldName = _ref.fieldName,
      labelText = _ref.labelText,
      validate = _ref.validate,
      others = _objectWithoutProperties(_ref, ["htmlId", "fieldName", "labelText", "validate"]);

  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Field, _extends({
      name: fieldName,
      validate: validate,
      type: "radio"
    }, others), function (_ref2) {
      var field = _ref2.field,
          meta = _ref2.meta;
      var isValidClassName;

      if (meta.touched && validate) {
        isValidClassName = !!meta.error ? "is-invalid" : "is-valid";
      }

      return (
        /*#__PURE__*/
        React.createElement(Radio, _extends({
          id: htmlId,
          label: labelText,
          className: isValidClassName
        }, others, field))
      );
    }),
    /*#__PURE__*/
    React.createElement(ErrorMessage, {
      id: "".concat(htmlId, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: fieldName
    }))
  );
};

var Select = function Select(_ref) {
  var id = _ref.id,
      className = _ref.className,
      label = _ref.label,
      labelHelpText = _ref.labelHelpText,
      status = _ref.status,
      onChange = _ref.onChange,
      defaultOption = _ref.defaultOption,
      options = _ref.options,
      optionGroups = _ref.optionGroups,
      other = _objectWithoutProperties(_ref, ["id", "className", "label", "labelHelpText", "status", "onChange", "defaultOption", "options", "optionGroups"]); // Configure select: Code imported from Thomas.UI/Blueprint


  var makeSelectOption = function makeSelectOption(data, index) {
    return (
      /*#__PURE__*/
      React.createElement("option", {
        key: index,
        value: data.value
      }, data.name)
    );
  };

  var selectOptions = [];

  if (optionGroups) {
    optionGroups.forEach(function (og) {
      // make select options for this group
      var groupOptions = og.options.map(makeSelectOption); // make optgroup with label and options

      var optionGroup =
      /*#__PURE__*/
      React.createElement("optgroup", {
        label: og.label
      }, groupOptions);
      selectOptions.push(optionGroup);
    });
  } else {
    selectOptions = options ? options.map(makeSelectOption) : null;
  }

  if (!defaultOption) {
    defaultOption =
    /*#__PURE__*/
    React.createElement("option", {
      value: ""
    }, "- Select -");
  }

  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: status ? "form-field ".concat(status) : "form-field"
    },
    /*#__PURE__*/
    React.createElement(Label, {
      id: id,
      label: label,
      helpText: labelHelpText
    }),
    /*#__PURE__*/
    React.createElement("select", _extends({
      id: id,
      className: className ? "form-control ".concat(className) : "form-control",
      onChange: onChange
    }, other), defaultOption, selectOptions))
  );
};

var StackedSelect = function StackedSelect(_ref) {
  var htmlId = _ref.htmlId,
      fieldName = _ref.fieldName,
      labelText = _ref.labelText,
      validate = _ref.validate,
      others = _objectWithoutProperties(_ref, ["htmlId", "fieldName", "labelText", "validate"]);

  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Field, _extends({
      name: fieldName,
      validate: validate
    }, others), function (_ref2) {
      var field = _ref2.field,
          meta = _ref2.meta,
          setFieldValue = _ref2.form.setFieldValue;
      var isValidClassName;

      if (meta.touched && validate) {
        isValidClassName = !!meta.error ? "is-invalid" : "is-valid";
      }

      return (
        /*#__PURE__*/
        React.createElement(Select, _extends({
          id: htmlId,
          label: labelText,
          status: isValidClassName
        }, others, field))
      );
    }),
    /*#__PURE__*/
    React.createElement(ErrorMessage, {
      id: "".concat(htmlId, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: fieldName
    }))
  );
};

var TextArea = function TextArea(_ref) {
  var className = _ref.className,
      id = _ref.id,
      label = _ref.label,
      labelHelpText = _ref.labelHelpText,
      tooltip = _ref.tooltip,
      tooltipPosition = _ref.tooltipPosition,
      status = _ref.status,
      props = _objectWithoutProperties(_ref, ["className", "id", "label", "labelHelpText", "tooltip", "tooltipPosition", "status"]);

  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: status ? "form-field ".concat(status) : "form-field"
    },
    /*#__PURE__*/
    React.createElement(Label, {
      id: id,
      label: label,
      helpText: labelHelpText,
      tooltip: tooltip,
      tooltipPosition: tooltipPosition
    }),
    /*#__PURE__*/
    React.createElement("textarea", _extends({
      id: id,
      className: className ? "form-control ".concat(className) : "form-control",
      rows: "10"
    }, props)))
  );
};

TextArea.propTypes = {
  status: PropTypes.oneOf(["is-valid", "is-invalid"])
};

var FormikTextArea = function FormikTextArea(props) {
  var htmlId = props.htmlId,
      fieldName = props.fieldName,
      labelText = props.labelText,
      labelHelpText = props.labelHelpText,
      validate = props.validate,
      others = _objectWithoutProperties(props, ["htmlId", "fieldName", "labelText", "labelHelpText", "validate"]);

  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(Field, _extends({
      name: fieldName,
      validate: validate
    }, others), function (_ref) {
      var field = _ref.field,
          meta = _ref.meta;
      var isValidClassName;

      if (meta.touched && validate) {
        isValidClassName = !!meta.error ? "is-invalid" : "is-valid";
      }

      return (
        /*#__PURE__*/
        React.createElement(TextArea, _extends({
          id: htmlId,
          label: labelText,
          labelHelpText: labelHelpText,
          status: isValidClassName
        }, field, others))
      );
    }),
    /*#__PURE__*/
    React.createElement(ErrorMessage, {
      id: "".concat(htmlId, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: fieldName || htmlId
    }))
  );
};

var index =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  FormikDebug: FormikDebug,
  FormikBoxCheckbox: FormikBoxCheckbox,
  FormikCheckbox: FormikCheckbox,
  FormikInputField: FormikInputField,
  FormikRadio: FormikRadio,
  FormikSelect: StackedSelect,
  FormikTextArea: FormikTextArea
}); // Last Modified: David K 04/01/20.

var FileUploadInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FileUploadInput, _Component);

  var _super = _createSuper(FileUploadInput);

  function FileUploadInput(props) {
    var _this;

    _classCallCheck(this, FileUploadInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "clearInput", function () {
      _this.inputRef.current.value = null;
    });

    _defineProperty(_assertThisInitialized(_this), "sendInput", function (e) {
      // send value to parent
      _this.props.onChange(e); // clear html input


      _this.clearInput();
    });

    _this.inputRef =
    /*#__PURE__*/
    React.createRef();
    return _this;
  }

  _createClass(FileUploadInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          helpText = _this$props.helpText,
          id = _this$props.id,
          name = _this$props.name,
          props = _objectWithoutProperties(_this$props, ["className", "helpText", "id", "name"]);

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: "file-upload"
        },
        /*#__PURE__*/
        React.createElement("label", {
          className: "file-upload__label form-control",
          htmlFor: id || name
        }, "Choose file"),
        /*#__PURE__*/
        React.createElement("input", _extends({
          className: "file-upload__input",
          id: id,
          type: "file",
          name: id,
          onChange: this.sendInput,
          ref: this.inputRef
        }, props)), helpText &&
        /*#__PURE__*/
        React.createElement("span", {
          className: "file-upload__helpText"
        }, helpText))
      );
    }
  }]);

  return FileUploadInput;
}(Component);

FileUploadInput.defaultProps = {
  id: "rfi-test-id",
  name: "rfi-test-name"
};
var config$6 = {
  color: {
    "default": "tag--default",
    inverted: "tag--inverted",
    success: "tag--success",
    warning: "tag--warning",
    failed: "tag--failed"
  }
};

var Tag = function Tag(_ref) {
  var className = _ref.className,
      children = _ref.children,
      color = _ref.color,
      label = _ref.label,
      type = _ref.type,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["className", "children", "color", "label", "type", "onClick"]);

  var classes = getClassNames(["tag", config$6.color[color], className]);
  return (
    /*#__PURE__*/
    React.createElement(type, _objectSpread2({
      className: classes
    }, props), label, children, onClick &&
    /*#__PURE__*/
    React.createElement(Button, {
      size: "sm",
      color: "transparent",
      className: "btn-tag",
      onClick: onClick,
      icon: "close"
    }))
  );
};

Tag.defaultProps = {
  color: "default",
  type: "span"
};
Tag.propTypes = {
  type: PropTypes.any.isRequired,
  color: PropTypes.oneOf(Object.keys(config$6.color))
};

var FileUploadList = function FileUploadList(_ref) {
  var files = _ref.files,
      deleteFile = _ref.deleteFile,
      isUploading = _ref.isUploading;
  return (
    /*#__PURE__*/
    React.createElement("ul", {
      className: "file-upload__list"
    }, isUploading &&
    /*#__PURE__*/
    React.createElement(Tag, null,
    /*#__PURE__*/
    React.createElement(Spinner, {
      color: "secondary"
    })), files.map(function (_ref2) {
      var key = _ref2.key,
          fileName = _ref2.fileName;
      return (
        /*#__PURE__*/
        React.createElement(Tag, {
          key: key,
          label: fileName,
          type: "li",
          onClick: function onClick() {
            return deleteFile(key, fileName);
          }
        })
      );
    }))
  );
};

var FileUploadForm =
/*#__PURE__*/
function (_Component) {
  _inherits(FileUploadForm, _Component);

  var _super = _createSuper(FileUploadForm);

  function FileUploadForm() {
    var _this;

    _classCallCheck(this, FileUploadForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      var value = e.target.files[0];

      _this.props.onFileUpload(value);
    });

    return _this;
  }

  _createClass(FileUploadForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          labelHelpText = _this$props.labelHelpText,
          helpText = _this$props.helpText,
          id = _this$props.id,
          tooltip = _this$props.tooltip,
          tooltipPosition = _this$props.tooltipPosition;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: "form-field"
        }, label &&
        /*#__PURE__*/
        React.createElement(Label, {
          label: label,
          helpText: labelHelpText,
          htmlFor: id,
          tooltip: tooltip,
          tooltipPosition: tooltipPosition
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: "custom-file"
        },
        /*#__PURE__*/
        React.createElement("div", {
          id: "fileUploadSwapArea",
          style: {
            width: "100%"
          }
        },
        /*#__PURE__*/
        React.createElement(FileUploadInput, {
          onChange: this.onChange,
          className: "custom-file-input",
          helpText: helpText
        }),
        /*#__PURE__*/
        React.createElement(FileUploadList, {
          isUploading: this.props.isUploading,
          files: this.props.files,
          deleteFile: this.props.deleteFile
        }))))
      );
    }
  }]);

  return FileUploadForm;
}(Component);

FileUploadForm.propTypes = {
  isUploading: PropTypes.bool
};
var index$1 =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  BoxCheckbox: BoxCheckbox,
  Checkbox: Checkbox,
  Formik: index,
  FileUpload: FileUploadForm,
  InputField: InputField,
  Label: Label,
  Radio: Radio,
  Select: Select,
  TextArea: TextArea
});
var config$7 = {
  align: {
    center: "text-center",
    left: "text-left",
    right: "text-right"
  },
  color: {
    dark: "logo--dark",
    light: "logo--light"
  },
  size: {
    xs: "logo--xs",
    sm: "logo--sm",
    md: "logo--md",
    lg: "logo--lg"
  }
}; // Logo Component

var Logo = function Logo(_ref) {
  var align = _ref.align,
      caption = _ref.caption,
      color = _ref.color,
      size = _ref.size,
      other = _objectWithoutProperties(_ref, ["align", "caption", "color", "size"]);

  return (
    /*#__PURE__*/
    React.createElement("div", _extends({
      className: "logo ".concat(config$7.color[color], " ").concat(config$7.size[size])
    }, other),
    /*#__PURE__*/
    React.createElement("figure", {
      className: "logo__figure ".concat(config$7.align[align])
    },
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 344.13 65.35",
      className: "thomas-svg-logo"
    },
    /*#__PURE__*/
    React.createElement("path", {
      fill: "#48b2e8",
      d: "M0 0h40.8v13.6H0z"
    }),
    /*#__PURE__*/
    React.createElement("svg", {
      viewBox: "0 0 344.13 65.35"
    },
    /*#__PURE__*/
    React.createElement("path", {
      fill: "#48b2e8",
      d: "M0 0h40.8v13.6H0z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      fill: "currentColor",
      d: "M0 27.2h13.6v36.87H0zm27.2 0h13.6v36.87H27.2zm64.98 8.88v28H81.95v-28H71.62V27.2h30.88v8.88zm43.48 28V49.55h-11.49v14.53h-10.44V27.2h10.43v13.44h11.49V27.2h10.43v36.88zm38.68.59c-10 0-17-6.69-17-19s7.11-19.05 17.11-19.05 17 6.69 17 19-7.09 19.05-17.11 19.05zm0-29.14c-4.11 0-6.43 3.43-6.43 10.07s2.42 10.17 6.54 10.17 6.43-3.43 6.43-10.07-2.43-10.17-6.54-10.17zm55.77 28.55v-8.8c0-3.64.05-7 .21-9.8-1.11 2.74-3 7-4.27 9.64l-4.85 10.22-4.85-10.21c-1.26-2.64-3.16-6.9-4.27-9.64.16 2.85.21 6.17.21 9.8v8.79h-9.59V27.2h9.38l4.53 9.88a98.51 98.51 0 014.64 11.1 105.18 105.18 0 014.64-11.1l4.56-9.88h9.28v36.88zm46.16 0l-2-6.48H263.2l-2 6.48h-11l13.39-36.89h10.33l13.42 36.89zm-5.16-17c-1.32-4.74-1.9-6.75-2.37-9.22-.47 2.48-1.05 4.53-2.37 9.22l-.69 2.42h6.11zm40.9 17.59a29.41 29.41 0 01-15.56-4.48l5-8c2.69 1.84 7.38 3.69 10.8 3.69 3.64 0 4.8-.63 4.8-2.37 0-1.37-1.32-2.21-6.27-3.37-8.91-2.06-13.18-4.48-13.18-11.86 0-7 5.64-11.65 14.55-11.65 6.27 0 10.8 1.53 14.7 4.27l-5 8a17.87 17.87 0 00-10.28-3.48c-3.06 0-3.79.95-3.79 2.27s1.32 2 6.06 3.11c9.28 2.21 13.39 5.06 13.39 12 .01 8.39-6.37 11.87-15.22 11.87zm24.79-36.96v4.52h-.79v-4.52h-1.56v-.78h3.88v.78zm6.55 4.52V28.5c-.06.15-.21.53-.34.83l-1.29 3-1.27-3c-.13-.3-.28-.68-.34-.83v3.73h-.75v-5.3h.82l1.19 2.82c.13.3.29.69.36.91.08-.22.23-.6.36-.91l1.17-2.82h.85v5.3z"
    }))), caption &&
    /*#__PURE__*/
    React.createElement("figcaption", {
      className: "logo__figure-caption"
    }, "For Industry.")))
  );
};

Logo.defaultProps = {
  align: "center",
  caption: true,
  color: "dark",
  size: "md"
};
Logo.propTypes = {
  align: PropTypes.oneOf(Object.keys(config$7.align)),
  caption: PropTypes.bool,
  color: PropTypes.oneOf(Object.keys(config$7.color)),
  size: PropTypes.oneOf(Object.keys(config$7.size))
};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace(n) {
  return n && n['default'] || n;
}

var tabbable_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = findTabbableDescendants;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */

  var tabbableNode = /input|select|textarea|button|object/;

  function hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0; // If the node is empty, this is good enough

    if (zeroSize && !element.innerHTML) return true; // Otherwise we need to check some styles

    var style = window.getComputedStyle(element);
    return zeroSize ? style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
  }

  function visible(element) {
    var parentElement = element;

    while (parentElement) {
      if (parentElement === document.body) break;
      if (hidesContents(parentElement)) return false;
      parentElement = parentElement.parentNode;
    }

    return true;
  }

  function focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
  }

  function tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
  }

  function findTabbableDescendants(element) {
    return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
  }

  module.exports = exports["default"];
});
unwrapExports(tabbable_1);
var focusManager = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.handleBlur = handleBlur;
  exports.handleFocus = handleFocus;
  exports.markForFocusLater = markForFocusLater;
  exports.returnFocus = returnFocus;
  exports.popWithoutFocus = popWithoutFocus;
  exports.setupScopedFocus = setupScopedFocus;
  exports.teardownScopedFocus = teardownScopedFocus;

  var _tabbable2 = _interopRequireDefault(tabbable_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var focusLaterElements = [];
  var modalElement = null;
  var needToFocus = false;

  function handleBlur() {
    needToFocus = true;
  }

  function handleFocus() {
    if (needToFocus) {
      needToFocus = false;

      if (!modalElement) {
        return;
      } // need to see how jQuery shims document.on('focusin') so we don't need the
      // setTimeout, firefox doesn't support focusin, if it did, we could focus
      // the element outside of a setTimeout. Side-effect of this implementation
      // is that the document.body gets focus, and then we focus our element right
      // after, seems fine.


      setTimeout(function () {
        if (modalElement.contains(document.activeElement)) {
          return;
        }

        var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
        el.focus();
      }, 0);
    }
  }

  function markForFocusLater() {
    focusLaterElements.push(document.activeElement);
  }
  /* eslint-disable no-console */


  function returnFocus() {
    var toFocus = null;

    try {
      if (focusLaterElements.length !== 0) {
        toFocus = focusLaterElements.pop();
        toFocus.focus();
      }

      return;
    } catch (e) {
      console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
    }
  }
  /* eslint-enable no-console */


  function popWithoutFocus() {
    focusLaterElements.length > 0 && focusLaterElements.pop();
  }

  function setupScopedFocus(element) {
    modalElement = element;

    if (window.addEventListener) {
      window.addEventListener("blur", handleBlur, false);
      document.addEventListener("focus", handleFocus, true);
    } else {
      window.attachEvent("onBlur", handleBlur);
      document.attachEvent("onFocus", handleFocus);
    }
  }

  function teardownScopedFocus() {
    modalElement = null;

    if (window.addEventListener) {
      window.removeEventListener("blur", handleBlur);
      document.removeEventListener("focus", handleFocus);
    } else {
      window.detachEvent("onBlur", handleBlur);
      document.detachEvent("onFocus", handleFocus);
    }
  }
});
unwrapExports(focusManager);
var focusManager_1 = focusManager.handleBlur;
var focusManager_2 = focusManager.handleFocus;
var focusManager_3 = focusManager.markForFocusLater;
var focusManager_4 = focusManager.returnFocus;
var focusManager_5 = focusManager.popWithoutFocus;
var focusManager_6 = focusManager.setupScopedFocus;
var focusManager_7 = focusManager.teardownScopedFocus;
var scopeTab_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = scopeTab;

  var _tabbable2 = _interopRequireDefault(tabbable_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function scopeTab(node, event) {
    var tabbable = (0, _tabbable2.default)(node);

    if (!tabbable.length) {
      // Do nothing, since there are no elements that can receive focus.
      event.preventDefault();
      return;
    }

    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1]; // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.

    if (node === document.activeElement) {
      if (!shiftKey) return;
      target = tail;
    }

    if (tail === document.activeElement && !shiftKey) {
      target = head;
    }

    if (head === document.activeElement && shiftKey) {
      target = tail;
    }

    if (target) {
      event.preventDefault();
      target.focus();
      return;
    } // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.


    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null; // If we are not in safari desktop, let the browser control
    // the focus

    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(document.activeElement);

    if (x > -1) {
      x += shiftKey ? -1 : 1;
    }

    target = tabbable[x]; // If the tabbable element does not exist,
    // focus head/tail based on shiftKey

    if (typeof target === "undefined") {
      event.preventDefault();
      target = shiftKey ? tail : head;
      target.focus();
      return;
    }

    event.preventDefault();
    target.focus();
  }

  module.exports = exports["default"];
});
unwrapExports(scopeTab_1);
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);

    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;
var exenv = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2015 Jed Watson.
    Based on code that is Copyright 2013-2015, Facebook, Inc.
    All rights reserved.
  */

  /* global define */
  (function () {
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
      canUseDOM: canUseDOM,
      canUseWorkers: typeof Worker !== 'undefined',
      canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
      canUseViewport: canUseDOM && !!window.screen
    };

    if (module.exports) {
      module.exports = ExecutionEnvironment;
    } else {
      window.ExecutionEnvironment = ExecutionEnvironment;
    }
  })();
});
var safeHTMLElement = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.canUseDOM = undefined;

  var _exenv2 = _interopRequireDefault(exenv);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var EE = _exenv2.default;
  var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
  var canUseDOM = exports.canUseDOM = EE.canUseDOM;
  exports.default = SafeHTMLElement;
});
unwrapExports(safeHTMLElement);
var safeHTMLElement_1 = safeHTMLElement.canUseDOM;
var ariaAppHider = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.assertNodeList = assertNodeList;
  exports.setElement = setElement;
  exports.validateElement = validateElement;
  exports.hide = hide;
  exports.show = show;
  exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
  exports.resetForTesting = resetForTesting;

  var _warning2 = _interopRequireDefault(warning_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var globalElement = null;

  function assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) {
      throw new Error("react-modal: No elements were found for selector " + selector + ".");
    }
  }

  function setElement(element) {
    var useElement = element;

    if (typeof useElement === "string" && safeHTMLElement.canUseDOM) {
      var el = document.querySelectorAll(useElement);
      assertNodeList(el, useElement);
      useElement = "length" in el ? el[0] : el;
    }

    globalElement = useElement || globalElement;
    return globalElement;
  }

  function validateElement(appElement) {
    if (!appElement && !globalElement) {
      (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
      return false;
    }

    return true;
  }

  function hide(appElement) {
    if (validateElement(appElement)) {
      (appElement || globalElement).setAttribute("aria-hidden", "true");
    }
  }

  function show(appElement) {
    if (validateElement(appElement)) {
      (appElement || globalElement).removeAttribute("aria-hidden");
    }
  }

  function documentNotReadyOrSSRTesting() {
    globalElement = null;
  }

  function resetForTesting() {
    globalElement = null;
  }
});
unwrapExports(ariaAppHider);
var ariaAppHider_1 = ariaAppHider.assertNodeList;
var ariaAppHider_2 = ariaAppHider.setElement;
var ariaAppHider_3 = ariaAppHider.validateElement;
var ariaAppHider_4 = ariaAppHider.hide;
var ariaAppHider_5 = ariaAppHider.show;
var ariaAppHider_6 = ariaAppHider.documentNotReadyOrSSRTesting;
var ariaAppHider_7 = ariaAppHider.resetForTesting;
var classList = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.dumpClassLists = dumpClassLists;
  var htmlClassList = {};
  var docBodyClassList = {};

  function dumpClassLists() {
    if (process.env.NODE_ENV !== "production") {
      var classes = document.getElementsByTagName("html")[0].className;
      var buffer = "Show tracked classes:\n\n";
      buffer += "<html /> (" + classes + "):\n";

      for (var x in htmlClassList) {
        buffer += "  " + x + " " + htmlClassList[x] + "\n";
      }

      classes = document.body.className; // eslint-disable-next-line max-len

      buffer += "\n\ndoc.body (" + classes + "):\n";

      for (var _x in docBodyClassList) {
        buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
      }

      buffer += "\n"; // eslint-disable-next-line no-console

      console.log(buffer);
    }
  }
  /**
   * Track the number of reference of a class.
   * @param {object} poll The poll to receive the reference.
   * @param {string} className The class name.
   * @return {string}
   */


  var incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) {
      poll[className] = 0;
    }

    poll[className] += 1;
    return className;
  };
  /**
   * Drop the reference of a class.
   * @param {object} poll The poll to receive the reference.
   * @param {string} className The class name.
   * @return {string}
   */


  var decrementReference = function decrementReference(poll, className) {
    if (poll[className]) {
      poll[className] -= 1;
    }

    return className;
  };
  /**
   * Track a class and add to the given class list.
   * @param {Object} classListRef A class list of an element.
   * @param {Object} poll         The poll to be used.
   * @param {Array}  classes      The list of classes to be tracked.
   */


  var trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function (className) {
      incrementReference(poll, className);
      classListRef.add(className);
    });
  };
  /**
   * Untrack a class and remove from the given class list if the reference
   * reaches 0.
   * @param {Object} classListRef A class list of an element.
   * @param {Object} poll         The poll to be used.
   * @param {Array}  classes      The list of classes to be untracked.
   */


  var untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function (className) {
      decrementReference(poll, className);
      poll[className] === 0 && classListRef.remove(className);
    });
  };
  /**
   * Public inferface to add classes to the document.body.
   * @param {string} bodyClass The class string to be added.
   *                           It may contain more then one class
   *                           with ' ' as separator.
   */


  var add = exports.add = function add(element, classString) {
    return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
  };
  /**
   * Public inferface to remove classes from the document.body.
   * @param {string} bodyClass The class string to be added.
   *                           It may contain more then one class
   *                           with ' ' as separator.
   */


  var remove = exports.remove = function remove(element, classString) {
    return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
  };
});
unwrapExports(classList);
var classList_1 = classList.dumpClassLists;
var classList_2 = classList.add;
var classList_3 = classList.remove;
var portalOpenInstances_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  } // Tracks portals that are open and emits events to subscribers


  var PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;

    _classCallCheck(this, PortalOpenInstances);

    this.register = function (openInstance) {
      if (_this.openInstances.indexOf(openInstance) !== -1) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("React-Modal: Cannot register modal instance that's already open");
        }

        return;
      }

      _this.openInstances.push(openInstance);

      _this.emit("register");
    };

    this.deregister = function (openInstance) {
      var index = _this.openInstances.indexOf(openInstance);

      if (index === -1) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
        }

        return;
      }

      _this.openInstances.splice(index, 1);

      _this.emit("deregister");
    };

    this.subscribe = function (callback) {
      _this.subscribers.push(callback);
    };

    this.emit = function (eventType) {
      _this.subscribers.forEach(function (subscriber) {
        return subscriber(eventType, // shallow copy to avoid accidental mutation
        _this.openInstances.slice());
      });
    };

    this.openInstances = [];
    this.subscribers = [];
  };

  var portalOpenInstances = new PortalOpenInstances();
  exports.default = portalOpenInstances;
  module.exports = exports["default"];
});
unwrapExports(portalOpenInstances_1);
var bodyTrap_1 = createCommonjsModule(function (module) {
  var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } // Body focus trap see Issue #742


  var before = void 0,
      after = void 0,
      instances = [];

  function focusContent() {
    if (instances.length === 0) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Open instances > 0 expected");
      }

      return;
    }

    instances[instances.length - 1].focusContent();
  }

  function bodyTrap(eventType, openInstances) {
    if (!before || !after) {
      before = document.createElement("div");
      before.setAttribute("data-react-modal-body-trap", "");
      before.style.position = "absolute";
      before.style.opacity = "0";
      before.setAttribute("tabindex", "0");
      before.addEventListener("focus", focusContent);
      after = before.cloneNode();
      after.addEventListener("focus", focusContent);
    }

    instances = openInstances;

    if (instances.length > 0) {
      // Add focus trap
      if (document.body.firstChild !== before) {
        document.body.insertBefore(before, document.body.firstChild);
      }

      if (document.body.lastChild !== after) {
        document.body.appendChild(after);
      }
    } else {
      // Remove focus trap
      if (before.parentElement) {
        before.parentElement.removeChild(before);
      }

      if (after.parentElement) {
        after.parentElement.removeChild(after);
      }
    }
  }

  _portalOpenInstances2.default.subscribe(bodyTrap);
});
unwrapExports(bodyTrap_1);
var ModalPortal_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes);

  var focusManager$1 = _interopRequireWildcard(focusManager);

  var _scopeTab2 = _interopRequireDefault(scopeTab_1);

  var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);

  var classList$1 = _interopRequireWildcard(classList);

  var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);

  var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  } // so that our CSS is statically analyzable


  var CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  };
  var TAB_KEY = 9;
  var ESC_KEY = 27;
  var ariaHiddenInstances = 0;

  var ModalPortal = function (_Component) {
    _inherits(ModalPortal, _Component);

    function ModalPortal(props) {
      _classCallCheck(this, ModalPortal);

      var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

      _this.setOverlayRef = function (overlay) {
        _this.overlay = overlay;
        _this.props.overlayRef && _this.props.overlayRef(overlay);
      };

      _this.setContentRef = function (content) {
        _this.content = content;
        _this.props.contentRef && _this.props.contentRef(content);
      };

      _this.afterClose = function () {
        var _this$props = _this.props,
            appElement = _this$props.appElement,
            ariaHideApp = _this$props.ariaHideApp,
            htmlOpenClassName = _this$props.htmlOpenClassName,
            bodyOpenClassName = _this$props.bodyOpenClassName; // Remove classes.

        bodyOpenClassName && classList$1.remove(document.body, bodyOpenClassName);
        htmlOpenClassName && classList$1.remove(document.getElementsByTagName("html")[0], htmlOpenClassName); // Reset aria-hidden attribute if all modals have been removed

        if (ariaHideApp && ariaHiddenInstances > 0) {
          ariaHiddenInstances -= 1;

          if (ariaHiddenInstances === 0) {
            ariaAppHider$1.show(appElement);
          }
        }

        if (_this.props.shouldFocusAfterRender) {
          if (_this.props.shouldReturnFocusAfterClose) {
            focusManager$1.returnFocus();
            focusManager$1.teardownScopedFocus();
          } else {
            focusManager$1.popWithoutFocus();
          }
        }

        if (_this.props.onAfterClose) {
          _this.props.onAfterClose();
        }

        _portalOpenInstances2.default.deregister(_this);
      };

      _this.open = function () {
        _this.beforeOpen();

        if (_this.state.afterOpen && _this.state.beforeClose) {
          clearTimeout(_this.closeTimer);

          _this.setState({
            beforeClose: false
          });
        } else {
          if (_this.props.shouldFocusAfterRender) {
            focusManager$1.setupScopedFocus(_this.node);
            focusManager$1.markForFocusLater();
          }

          _this.setState({
            isOpen: true
          }, function () {
            _this.setState({
              afterOpen: true
            });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        }
      };

      _this.close = function () {
        if (_this.props.closeTimeoutMS > 0) {
          _this.closeWithTimeout();
        } else {
          _this.closeWithoutTimeout();
        }
      };

      _this.focusContent = function () {
        return _this.content && !_this.contentHasFocus() && _this.content.focus();
      };

      _this.closeWithTimeout = function () {
        var closesAt = Date.now() + _this.props.closeTimeoutMS;

        _this.setState({
          beforeClose: true,
          closesAt: closesAt
        }, function () {
          _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
        });
      };

      _this.closeWithoutTimeout = function () {
        _this.setState({
          beforeClose: false,
          isOpen: false,
          afterOpen: false,
          closesAt: null
        }, _this.afterClose);
      };

      _this.handleKeyDown = function (event) {
        if (event.keyCode === TAB_KEY) {
          (0, _scopeTab2.default)(_this.content, event);
        }

        if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
          event.stopPropagation();

          _this.requestClose(event);
        }
      };

      _this.handleOverlayOnClick = function (event) {
        if (_this.shouldClose === null) {
          _this.shouldClose = true;
        }

        if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
          if (_this.ownerHandlesClose()) {
            _this.requestClose(event);
          } else {
            _this.focusContent();
          }
        }

        _this.shouldClose = null;
      };

      _this.handleContentOnMouseUp = function () {
        _this.shouldClose = false;
      };

      _this.handleOverlayOnMouseDown = function (event) {
        if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
          event.preventDefault();
        }
      };

      _this.handleContentOnClick = function () {
        _this.shouldClose = false;
      };

      _this.handleContentOnMouseDown = function () {
        _this.shouldClose = false;
      };

      _this.requestClose = function (event) {
        return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
      };

      _this.ownerHandlesClose = function () {
        return _this.props.onRequestClose;
      };

      _this.shouldBeClosed = function () {
        return !_this.state.isOpen && !_this.state.beforeClose;
      };

      _this.contentHasFocus = function () {
        return document.activeElement === _this.content || _this.content.contains(document.activeElement);
      };

      _this.buildClassName = function (which, additional) {
        var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
          base: CLASS_NAMES[which],
          afterOpen: CLASS_NAMES[which] + "--after-open",
          beforeClose: CLASS_NAMES[which] + "--before-close"
        };
        var className = classNames.base;

        if (_this.state.afterOpen) {
          className = className + " " + classNames.afterOpen;
        }

        if (_this.state.beforeClose) {
          className = className + " " + classNames.beforeClose;
        }

        return typeof additional === "string" && additional ? className + " " + additional : className;
      };

      _this.attributesFromObject = function (prefix, items) {
        return Object.keys(items).reduce(function (acc, name) {
          acc[prefix + "-" + name] = items[name];
          return acc;
        }, {});
      };

      _this.state = {
        afterOpen: false,
        beforeClose: false
      };
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
      return _this;
    }

    _createClass(ModalPortal, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.isOpen) {
          this.open();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (process.env.NODE_ENV !== "production") {
          if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
            // eslint-disable-next-line no-console
            console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
          }

          if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
            // eslint-disable-next-line no-console
            console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
          }
        }

        if (this.props.isOpen && !prevProps.isOpen) {
          this.open();
        } else if (!this.props.isOpen && prevProps.isOpen) {
          this.close();
        } // Focus only needs to be set once when the modal is being opened


        if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
          this.focusContent();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.state.isOpen) {
          this.afterClose();
        }

        clearTimeout(this.closeTimer);
      }
    }, {
      key: "beforeOpen",
      value: function beforeOpen() {
        var _props = this.props,
            appElement = _props.appElement,
            ariaHideApp = _props.ariaHideApp,
            htmlOpenClassName = _props.htmlOpenClassName,
            bodyOpenClassName = _props.bodyOpenClassName; // Add classes.

        bodyOpenClassName && classList$1.add(document.body, bodyOpenClassName);
        htmlOpenClassName && classList$1.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

        if (ariaHideApp) {
          ariaHiddenInstances += 1;
          ariaAppHider$1.hide(appElement);
        }

        _portalOpenInstances2.default.register(this);
      } // Don't steal focus from inner elements

    }, {
      key: "render",
      value: function render() {
        var _props2 = this.props,
            id = _props2.id,
            className = _props2.className,
            overlayClassName = _props2.overlayClassName,
            defaultStyles = _props2.defaultStyles;
        var contentStyles = className ? {} : defaultStyles.content;
        var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
        return this.shouldBeClosed() ? null : _react2.default.createElement("div", {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, _react2.default.createElement("div", _extends({
          id: id,
          ref: this.setContentRef,
          style: _extends({}, contentStyles, this.props.style.content),
          className: this.buildClassName("content", className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), this.props.children));
      }
    }]);

    return ModalPortal;
  }(React.Component);

  ModalPortal.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  };
  ModalPortal.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    defaultStyles: _propTypes2.default.shape({
      content: _propTypes2.default.object,
      overlay: _propTypes2.default.object
    }),
    style: _propTypes2.default.shape({
      content: _propTypes2.default.object,
      overlay: _propTypes2.default.object
    }),
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    ariaHideApp: _propTypes2.default.bool,
    appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
    onAfterOpen: _propTypes2.default.func,
    onAfterClose: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    children: _propTypes2.default.node,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func,
    id: _propTypes2.default.string,
    testId: _propTypes2.default.string
  };
  exports.default = ModalPortal;
  module.exports = exports["default"];
});
unwrapExports(ModalPortal_1);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);

  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  } // Binding "this" is important for shallow renderer support.


  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
} // React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.


componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  } // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.


  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;

  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }

  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }

  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }

  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  } // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.


  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  } // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.


  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  polyfill: polyfill
});

var _reactLifecyclesCompat = getCjsExportFromNamespace(reactLifecyclesCompat_es);

var Modal_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.bodyOpenClassName = exports.portalClassName = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(React);

  var _reactDom2 = _interopRequireDefault(ReactDOM);

  var _propTypes2 = _interopRequireDefault(PropTypes);

  var _ModalPortal2 = _interopRequireDefault(ModalPortal_1);

  var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);

  var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var portalClassName = exports.portalClassName = "ReactModalPortal";
  var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
  var isReact16 = _reactDom2.default.createPortal !== undefined;

  var getCreatePortal = function getCreatePortal() {
    return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
  };

  function getParentElement(parentSelector) {
    return parentSelector();
  }

  var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Modal);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
        !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
        var parent = getParentElement(_this.props.parentSelector);

        if (parent) {
          parent.removeChild(_this.node);
        } else {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
        }
      }, _this.portalRef = function (ref) {
        _this.portal = ref;
      }, _this.renderPortal = function (props) {
        var createPortal = getCreatePortal();
        var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({
          defaultStyles: Modal.defaultStyles
        }, props)), _this.node);

        _this.portalRef(portal);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Modal, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!safeHTMLElement.canUseDOM) return;

        if (!isReact16) {
          this.node = document.createElement("div");
        }

        this.node.className = this.props.portalClassName;
        var parent = getParentElement(this.props.parentSelector);
        parent.appendChild(this.node);
        !isReact16 && this.renderPortal(this.props);
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function getSnapshotBeforeUpdate(prevProps) {
        var prevParent = getParentElement(prevProps.parentSelector);
        var nextParent = getParentElement(this.props.parentSelector);
        return {
          prevParent: prevParent,
          nextParent: nextParent
        };
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, _, snapshot) {
        if (!safeHTMLElement.canUseDOM) return;
        var _props = this.props,
            isOpen = _props.isOpen,
            portalClassName = _props.portalClassName;

        if (prevProps.portalClassName !== portalClassName) {
          this.node.className = portalClassName;
        }

        var prevParent = snapshot.prevParent,
            nextParent = snapshot.nextParent;

        if (nextParent !== prevParent) {
          prevParent.removeChild(this.node);
          nextParent.appendChild(this.node);
        } // Stop unnecessary renders if modal is remaining closed


        if (!prevProps.isOpen && !isOpen) return;
        !isReact16 && this.renderPortal(this.props);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (!safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
        var state = this.portal.state;
        var now = Date.now();
        var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

        if (closesAt) {
          if (!state.beforeClose) {
            this.portal.closeWithTimeout();
          }

          setTimeout(this.removePortal, closesAt - now);
        } else {
          this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (!safeHTMLElement.canUseDOM || !isReact16) {
          return null;
        }

        if (!this.node && isReact16) {
          this.node = document.createElement("div");
        }

        var createPortal = getCreatePortal();
        return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
          ref: this.portalRef,
          defaultStyles: Modal.defaultStyles
        }, this.props)), this.node);
      }
    }], [{
      key: "setAppElement",
      value: function setAppElement(element) {
        ariaAppHider$1.setElement(element);
      }
      /* eslint-disable react/no-unused-prop-types */

      /* eslint-enable react/no-unused-prop-types */

    }]);

    return Modal;
  }(React.Component);

  Modal.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    style: _propTypes2.default.shape({
      content: _propTypes2.default.object,
      overlay: _propTypes2.default.object
    }),
    portalClassName: _propTypes2.default.string,
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
      base: _propTypes2.default.string.isRequired,
      afterOpen: _propTypes2.default.string.isRequired,
      beforeClose: _propTypes2.default.string.isRequired
    })]),
    overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
      base: _propTypes2.default.string.isRequired,
      afterOpen: _propTypes2.default.string.isRequired,
      beforeClose: _propTypes2.default.string.isRequired
    })]),
    appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
    onAfterOpen: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    ariaHideApp: _propTypes2.default.bool,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    parentSelector: _propTypes2.default.func,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func
  };
  Modal.defaultProps = {
    isOpen: false,
    portalClassName: portalClassName,
    bodyOpenClassName: bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    parentSelector: function parentSelector() {
      return document.body;
    }
  };
  Modal.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  };
  (0, _reactLifecyclesCompat.polyfill)(Modal);
  exports.default = Modal;
});
unwrapExports(Modal_1);
var Modal_2 = Modal_1.bodyOpenClassName;
var Modal_3 = Modal_1.portalClassName;
var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Modal2 = _interopRequireDefault(Modal_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Modal2.default;
  module.exports = exports["default"];
});
var ReactModal = unwrapExports(lib); // ReactModal.setAppElement("#___gatsby");

var config$8 = {
  color: {
    light: "modal--light",
    dark: "modal--dark"
  },
  size: {
    xxs: "container--xxs",
    xs: "container--xs",
    sm: "container--sm",
    md: "container--md",
    lg: "container--lg",
    xl: "container--xl",
    fluid: "container--fluid"
  }
};

var RenderDismissButton = function RenderDismissButton(_ref) {
  var dismiss = _ref.dismiss;
  return (
    /*#__PURE__*/
    React.createElement(Button, {
      className: "dismiss",
      color: "transparent",
      onClick: dismiss,
      title: "Close (Esc)"
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      type: "close",
      className: "icon--base"
    }))
  );
};

var Modal = function Modal(props) {
  var className = props.className,
      children = props.children,
      color = props.color,
      dismiss = props.dismiss,
      paywall = props.paywall,
      size = props.size,
      other = _objectWithoutProperties(props, ["className", "children", "color", "dismiss", "paywall", "size"]);

  var classes = ["modal", className];
  return (
    /*#__PURE__*/
    React.createElement(ReactModal, _extends({
      ariaHideApp: false,
      className: getClassNames(classes),
      onRequestClose: dismiss,
      overlayClassName: "modal-overlay ".concat(config$8.color[color]),
      bodyOpenClassName: "modal-open",
      shouldCloseOnEsc: !paywall,
      shouldCloseOnOverlayClick: !paywall
    }, other), !paywall &&
    /*#__PURE__*/
    React.createElement(RenderDismissButton, {
      dismiss: dismiss
    }),
    /*#__PURE__*/
    React.createElement("div", {
      className: "modal-content-wrapper"
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "container ".concat(size ? config$8.size[size] : "")
    }, children)))
  );
};

Modal.defaultProps = {
  color: "light",
  size: "xxs",
  paywall: false
};
Modal.propTypes = {
  color: PropTypes.oneOf(Object.keys(config$8.color)),
  size: PropTypes.oneOf(Object.keys(config$8.size)),
  paywall: PropTypes.bool
};

var Nav = function Nav(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  return (
    /*#__PURE__*/
    React.createElement("nav", _extends({
      role: "navigation",
      className: className ? "site-nav ".concat(className) : "site-nav"
    }, props), children)
  );
};

var ItemInner = function ItemInner(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      label = _ref.label,
      notification = _ref.notification;
  var itemClassNames = getClassNames(["site-nav__item-label", className, icon ? "ml-1" : null]);
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null, icon &&
    /*#__PURE__*/
    React.createElement(Icon, {
      type: icon,
      className: "site-nav__item-icon",
      disableTitle: true
    }), label &&
    /*#__PURE__*/
    React.createElement("span", {
      className: itemClassNames
    }, label), !!notification &&
    /*#__PURE__*/
    React.createElement("span", {
      className: "site-nav__item-notification"
    }, notification))
  );
};

var NavItemInnerSingleLabel = function NavItemInnerSingleLabel(props) {
  if (props.notification) {
    return (
      /*#__PURE__*/
      React.createElement("span", {
        className: "site-nav__item-label-wrapper"
      },
      /*#__PURE__*/
      React.createElement(ItemInner, props))
    );
  }

  return (
    /*#__PURE__*/
    React.createElement(ItemInner, props)
  );
}; // Advanced / Multi-label nav-item.


var NavItemInnerMultiLabel = function NavItemInnerMultiLabel(_ref2) {
  var subLabel = _ref2.subLabel,
      props = _objectWithoutProperties(_ref2, ["subLabel"]);

  return (
    /*#__PURE__*/
    React.createElement("span", {
      className: "site-nav__item-label-wrapper"
    },
    /*#__PURE__*/
    React.createElement("span", {
      className: "site-nav__item-sublabel"
    }, subLabel),
    /*#__PURE__*/
    React.createElement(ItemInner, props))
  );
};

var NavItemInner = function NavItemInner(props) {
  if (props.subLabel) {
    return (
      /*#__PURE__*/
      React.createElement(NavItemInnerMultiLabel, props)
    );
  }

  return (
    /*#__PURE__*/
    React.createElement(NavItemInnerSingleLabel, props)
  );
};

var config$9 = {
  size: {
    sm: "site-nav__dropdown--sm",
    md: "site-nav__dropdown--md",
    lg: "site-nav__dropdown--lg"
  }
};

var NavDropdown = function NavDropdown(_ref) {
  var className = _ref.className,
      level = _ref.level,
      size = _ref.size,
      isActive = _ref.isActive,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "level", "size", "isActive", "children"]);

  var classes = getClassNames(["site-nav__dropdown", "site-nav__level-".concat(level), config$9.size[size], className]);
  return (
    /*#__PURE__*/
    React.createElement("ul", _extends({
      "data-nav-level": level,
      className: isActive ? "active ".concat(classes) : classes
    }, props), children)
  );
};

NavDropdown.defaultProps = {
  level: 1
};

var NavItem =
/*#__PURE__*/
function (_Component) {
  _inherits(NavItem, _Component);

  var _super = _createSuper(NavItem);

  function NavItem(props) {
    var _this;

    _classCallCheck(this, NavItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleDropdown", function (e) {
      e.preventDefault();

      _this.setState({
        isActive: !_this.state.isActive
      });
    });

    _this.state = {
      isActive: false,
      type: _this.props.subLabel ? "advanced" : "basic"
    };
    return _this;
  }

  _createClass(NavItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          href = _this$props.href,
          icon = _this$props.icon,
          level = _this$props.level,
          label = _this$props.label,
          notifications = _this$props.notifications,
          size = _this$props.size,
          subLabel = _this$props.subLabel,
          linkComponent = _this$props.linkComponent,
          onClick = _this$props.onClick,
          other = _objectWithoutProperties(_this$props, ["className", "children", "href", "icon", "level", "label", "notifications", "size", "subLabel", "linkComponent", "onClick"]); // const dropdownType = children
      // ? href || level > 1
      //   ? "click"
      //   : "hover"
      // : null;
      // Note: 08/07 all dropdown types are now click types.
      // const dropdownType = children ? (level > 1 ? "click" : "hover") : null;


      var dropdownType = !!children && "click";
      var isNoLinkDropDown = href === "#" && dropdownType === "click";
      var classes = getClassNames(["site-nav__item", children ? "site-nav__item--has-children" : null, icon && !label && "site-nav__item--icon-only", className]);

      var LinkComponent = function LinkComponent(_ref) {
        var children = _ref.children;
        return children;
      };

      if (href && linkComponent) {
        LinkComponent = linkComponent;
      }

      return (
        /*#__PURE__*/
        React.createElement("li", _extends({
          className: classes,
          "data-navitem": this.state.type,
          "data-dropdown": dropdownType,
          "data-dropdown-status": this.state.isActive ? "open" : null,
          "data-notification": notifications
        }, other),
        /*#__PURE__*/
        React.createElement(LinkComponent, {
          href: href
        },
        /*#__PURE__*/
        React.createElement("a", {
          className: "site-nav__item-link",
          href: href // onClick={onClick}
          ,
          onClick: isNoLinkDropDown ? this.handleDropdown : onClick
        },
        /*#__PURE__*/
        React.createElement(NavItemInner, {
          icon: icon,
          label: label,
          subLabel: subLabel,
          type: this.state.type,
          dropdownType: dropdownType,
          notification: notifications
        }))), dropdownType === "click" &&
        /*#__PURE__*/
        React.createElement(Button // className="nav-item__dropdown--btn"
        , {
          className: !!isNoLinkDropDown ? "nav-item__dropdown--btn nav-item__dropdown--nolink" : "nav-item__dropdown--btn",
          color: "transparent",
          size: "sm",
          onClick: this.handleDropdown
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          type: this.state.isActive ? "arrow-nav-up" : "arrow-nav-down"
        })), children &&
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement(NavDropdown, {
          isActive: this.state.isActive,
          level: parseFloat(level) + 1,
          size: size
        }, React.Children.map(children, function (child) {
          return (
            /*#__PURE__*/
            React.cloneElement(child, _objectSpread2(_objectSpread2({}, child.props), {
              level: parseFloat(level) + 1
            }))
          );
        }))))
      );
    }
  }]);

  return NavItem;
}(Component);

NavItem.defaultProps = {
  href: "#",
  level: 1
};

var ProfileImageUpload = function ProfileImageUpload(_ref) {
  var className = _ref.className,
      id = _ref.id,
      onChange = _ref.onChange,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["className", "id", "onChange", "size"]);

  var uploadRef = useRef(null);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "profile-image__upload ".concat(className ? className : ""),
      id: id,
      onClick: function onClick() {
        uploadRef.current.click();
      },
      style: {
        width: size,
        height: size
      }
    },
    /*#__PURE__*/
    React.createElement("input", _extends({
      style: {
        display: "none"
      },
      type: "file",
      accept: "image/*",
      ref: uploadRef,
      onChange: onChange
    }, props)),
    /*#__PURE__*/
    React.createElement(Icon, {
      type: "account",
      color: "gray"
    }),
    /*#__PURE__*/
    React.createElement("span", {
      className: "profile-image__upload-label "
    }, "Add",
    /*#__PURE__*/
    React.createElement("br", null), "Photo"))
  );
};

var ProfileImage = function ProfileImage(_ref) {
  var align = _ref.align,
      className = _ref.className,
      profileImg = _ref.profileImg,
      onClick = _ref.onClick,
      onChangePhoto = _ref.onChangePhoto,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "70px" : _ref$size;
  var alignment = {
    center: "align-center",
    left: "align-left",
    right: "align-right"
  };
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: className ? "profile-image ".concat(className) : "profile-image"
    }, profileImg ?
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement("div", {
      className: "profile-image__img ".concat(align ? alignment[align] : ""),
      style: {
        width: size,
        height: size,
        backgroundImage: "url(".concat(profileImg, ")")
      },
      alt: "profile image"
    }), onChangePhoto &&
    /*#__PURE__*/
    React.createElement(Button, {
      className: "mt-2 align-center",
      color: "secondary",
      display: "block",
      icon: "edit",
      onClick: onChangePhoto,
      size: "sm"
    }, "Change Photo")) :
    /*#__PURE__*/
    React.createElement(ProfileImageUpload, {
      className: align && alignment[align],
      size: size,
      onChange: function onChange(event) {
        onClick(event);
      }
    }))
  );
};

var RegisteredBadge = "data:image/svg+xml,%3csvg fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 11.71V0l5.6.71L11.2 0v11.71L5.6 14 0 11.71z' fill='url(%23paint0_linear)'/%3e%3cmask id='a' maskUnits='userSpaceOnUse' x='0' y='0' width='12' height='14'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 11.71V0l5.6.71L11.2 0v11.71L5.6 14 0 11.71z' fill='url(%23paint1_linear)'/%3e%3c/mask%3e%3cg mask='url(%23a)'%3e%3cpath d='M-1.75 13.13s5.66-9.84 16.63-11.1v-3.78H-1.75v14.88z' fill='url(%23paint2_linear)'/%3e%3c/g%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.39 7.23l3.9-3.73 1.34 1.28L4.37 9.8 1.75 7.29l1.35-1.3L4.4 7.24z' fill='white'/%3e%3cdefs%3e%3clinearGradient id='paint0_linear' x1='5.6' y1='0' x2='5.6' y2='14' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233DB4E7'/%3e%3cstop offset='1' stop-color='%2328628F'/%3e%3c/linearGradient%3e%3clinearGradient id='paint1_linear' x1='5.6' y1='0' x2='5.6' y2='14' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%233DB4E7'/%3e%3cstop offset='1' stop-color='%2328628F'/%3e%3c/linearGradient%3e%3clinearGradient id='paint2_linear' x1='6.56' y1='13.13' x2='6.56' y2='-1.75' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='white' stop-opacity='.9'/%3e%3cstop offset='.9' stop-color='white' stop-opacity='0'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
var VerifiedBadge = "data:image/svg+xml,%3csvg fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 11.71V0l5.6.71L11.2 0v11.71L5.6 14 0 11.71z' fill='url(%23paint0_linear)'/%3e%3cmask id='a' maskUnits='userSpaceOnUse' x='0' y='0' width='12' height='14'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 11.71V0l5.6.71L11.2 0v11.71L5.6 14 0 11.71z' fill='url(%23paint1_linear)'/%3e%3c/mask%3e%3cg mask='url(%23a)'%3e%3cpath opacity='.8' d='M-1.75 13.13s5.66-9.84 16.63-11.1v-3.78H-1.75v14.88z' fill='url(%23paint2_linear)'/%3e%3c/g%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.69 8.73L3.25 10.5l.85-2.98-2.35-1.89 2.96-.07.98-2.93.98 2.93 2.96.07-2.36 1.89.85 2.98L5.7 8.73z' fill='white'/%3e%3cdefs%3e%3clinearGradient id='paint0_linear' x1='5.6' y1='0' x2='5.6' y2='14' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F5BD1F'/%3e%3cstop offset='1' stop-color='%23DAA520'/%3e%3c/linearGradient%3e%3clinearGradient id='paint1_linear' x1='5.6' y1='0' x2='5.6' y2='14' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F5BD1F'/%3e%3cstop offset='1' stop-color='%23DAA520'/%3e%3c/linearGradient%3e%3clinearGradient id='paint2_linear' x1='6.56' y1='13.13' x2='6.56' y2='-1.75' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='white' stop-opacity='.9'/%3e%3cstop offset='.9' stop-color='white' stop-opacity='0'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
var CovidBadge = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M13.796 4.93l-1.604-2.786a.443.443 0 00-.598-.16L9.042 3.47V.51a.439.439 0 00-.438-.438H5.396a.439.439 0 00-.438.437v2.96L2.392 1.984a.45.45 0 00-.598.16L.19 4.93a.45.45 0 00.16.598L2.917 7 .35 8.473c-.204.131-.277.394-.146.598l1.604 2.785c.117.204.38.277.598.16l2.552-1.487v2.96c0 .234.19.438.438.438h3.208c.234 0 .438-.19.438-.437v-2.96l2.566 1.472a.45.45 0 00.598-.16l1.604-2.786a.45.45 0 00-.16-.598L11.083 7l2.567-1.473c.204-.131.277-.394.146-.598z' fill='%23BC4239' fill-rule='nonzero'/%3e%3c/svg%3e";
var config$a = {
  registered: {
    badge: RegisteredBadge,
    alt: "Registered Supplier"
  },
  verified: {
    badge: VerifiedBadge,
    alt: "Verified Supplier"
  },
  covid: {
    badge: CovidBadge,
    alt: "Covid-19 Response Supplier"
  }
};

var ThomasBadge = function ThomasBadge(_ref) {
  var className = _ref.className,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["className", "type"]);

  var badgeConfig = config$a[type ? type.toLowerCase() : ""];

  if (!badgeConfig) {
    return null;
  }

  return (
    /*#__PURE__*/
    React.createElement("img", _extends({
      className: className ? "icon thomas-badge ".concat(className) : "icon thomas-badge",
      src: badgeConfig.badge,
      alt: badgeConfig.alt
    }, props))
  );
};

var NavItemProfile = function NavItemProfile(_ref) {
  var className = _ref.className,
      href = _ref.href,
      onClick = _ref.onClick,
      profileImg = _ref.profileImg,
      badge = _ref.badge,
      label = _ref.label,
      subLabel = _ref.subLabel,
      onEdit = _ref.onEdit;
  return (
    /*#__PURE__*/
    React.createElement("li", {
      className: className ? "".concat(className, " site-nav__item site-nav__item-profile") : "site-nav__item site-nav__item-profile"
    }, onEdit &&
    /*#__PURE__*/
    React.createElement("a", {
      href: href,
      className: "edit-profile-btn link link--white",
      title: "Click to edit",
      onClick: onEdit
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      type: "edit",
      disableTitle: true
    })),
    /*#__PURE__*/
    React.createElement(ProfileImage, {
      className: "site-nav__item-profile-image",
      onClick: onClick,
      profileImg: profileImg
    }),
    /*#__PURE__*/
    React.createElement("div", null,
    /*#__PURE__*/
    React.createElement("h3", {
      className: "site-nav__item-profile-label"
    }, label, badge &&
    /*#__PURE__*/
    React.createElement("span", {
      style: {
        marginLeft: ".25rem"
      }
    },
    /*#__PURE__*/
    React.createElement(ThomasBadge, {
      type: badge,
      style: {
        verticalAlign: "-.25em"
      }
    }))),
    /*#__PURE__*/
    React.createElement("p", {
      className: "site-nav__item-profile-sublabel"
    }, subLabel)))
  );
};

NavItemProfile.defaultProps = {
  label: "John Smith",
  desc: "Add a description",
  onClick: function onClick() {
    return alert("Add onclick handler");
  }
};
var config$b = {
  type: {
    danger: "notification-banner--danger",
    info: "notification-banner--info",
    success: "notification-banner--success",
    warning: "notification-banner--warning"
  },
  variant: {
    global: "notification-banner--global",
    local: "notification-banner--local"
  }
};

var Notification = function Notification(_ref) {
  var className = _ref.className,
      children = _ref.children,
      dismiss = _ref.dismiss,
      href = _ref.href,
      id = _ref.id,
      icon = _ref.icon,
      label = _ref.label,
      type = _ref.type,
      variant = _ref.variant;
  var classes = getClassNames(["notification-banner", className, config$b.type[type], config$b.variant[variant], dismiss && "notification-banner--dismissible"]);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: classes,
      id: id
    },
    /*#__PURE__*/
    React.createElement(Container, {
      className: "notification-banner__container"
    },
    /*#__PURE__*/
    React.createElement(href ? "a" : "p", {
      className: "notification-banner__text",
      href: href
    }, icon &&
    /*#__PURE__*/
    React.createElement(Icon, {
      className: "mr-1",
      type: icon
    }), label, children), dismiss &&
    /*#__PURE__*/
    React.createElement(Button, {
      "aria-label": "close",
      className: "notification-banner__dismiss-btn",
      color: "transparent",
      icon: "close",
      onClick: function onClick() {
        return dismiss(id);
      }
    })))
  );
};

Notification.defaultProps = {
  type: "info",
  variant: "global"
};
Notification.propTypes = {
  // id: function(props, propName, componentName) {
  //   if (props["dismiss"] && !props["id"]) {
  //     return new Error(
  //       `The prop "${propName}" is required for "${componentName}" that has prop type dismiss. The value for prop "${propName}" is "${props["id"]}"`
  //     );
  //   }
  // },
  href: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(config$b.type)),
  variant: PropTypes.oneOf(Object.keys(config$b.variant))
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config$c = {
  disabled: false
};
var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
var TransitionGroupContext = React.createContext(null);
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config$c.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config$c.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React.cloneElement(React.Children.only(children), childProps))
    );
  };

  return Transition;
}(React.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : PropTypes.instanceOf(Element)
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass$1 = function removeClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["classNames"]);

    return (
      /*#__PURE__*/
      React.createElement(Transition, _extends$1({}, props, {
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }))
    );
  };

  return CSSTransition;
}(React.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$1({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */


function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized$1(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$1({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return (
        /*#__PURE__*/
        React.createElement(TransitionGroupContext.Provider, {
          value: contextValue
        }, children)
      );
    }

    return (
      /*#__PURE__*/
      React.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      },
      /*#__PURE__*/
      React.createElement(Component, props, children))
    );
  };

  return TransitionGroup;
}(React.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var NotificationGroup = function NotificationGroup(_ref) {
  var className = _ref.className,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? "div" : _ref$component,
      data = _ref.data;
  return (
    /*#__PURE__*/
    React.createElement(TransitionGroup, {
      className: "notification-group ".concat(className ? className : ""),
      component: component
    }, data.map(function (_ref2, index) {
      var id = _ref2.id,
          text = _ref2.text,
          props = _objectWithoutProperties(_ref2, ["id", "text"]);

      return (
        /*#__PURE__*/
        React.createElement(CSSTransition, {
          classNames: "notification-fade",
          key: id || index,
          timeout: 500
        },
        /*#__PURE__*/
        React.createElement(Notification, _extends({
          id: id
        }, props), text))
      );
    }))
  );
};

var NotificationContext =
/*#__PURE__*/
createContext();

var NotificationContextProvider = function NotificationContextProvider(_ref) {
  var children = _ref.children,
      _ref$maxLocalNotifica = _ref.maxLocalNotification,
      maxLocalNotification = _ref$maxLocalNotifica === void 0 ? 5 : _ref$maxLocalNotifica;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      localNotifications = _useState2[0],
      setLocalNotifications = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      globalNotifications = _useState4[0],
      setGlobalNotifications = _useState4[1]; // TEST Timeout: Make local notification disappear after X seconds
  // const timeout = 1000;
  // useEffect(() => {
  //   if (localNotifications.length > 0) {
  //     const timer = setTimeout(
  //       () => setNotifications(notifications => notifications.slice(1)),
  //       timeout
  //     );
  //     return () => clearTimeout(timer);
  //   }
  // }, [localNotifications]);


  useEffect(function () {
    // Limit # of local notifications
    if (localNotifications.length > maxLocalNotification) {
      setLocalNotifications(_toConsumableArray(localNotifications.slice(1)));
    }
  }, [localNotifications]);
  var addNotification = useCallback(function (notification) {
    if (notification.variant === "global") {
      setGlobalNotifications(function (globalNotifications) {
        return [].concat(_toConsumableArray(globalNotifications), [notification]);
      });
    } else {
      setLocalNotifications(function (localNotifications) {
        return [].concat(_toConsumableArray(localNotifications), [notification]);
      });
    }
  }, [globalNotifications, localNotifications]);
  var dismissNotification = useCallback(function (id) {
    setGlobalNotifications(function (globalNotifications) {
      return _toConsumableArray(globalNotifications.filter(function (n) {
        return n.id != id;
      }));
    });
    setLocalNotifications(function (localNotifications) {
      return _toConsumableArray(localNotifications.filter(function (n) {
        return n.id != id;
      }));
    });
  }, [globalNotifications, localNotifications]);
  return (
    /*#__PURE__*/
    React.createElement(NotificationContext.Provider, {
      value: {
        addNotification: addNotification,
        dismissNotification: dismissNotification
      }
    },
    /*#__PURE__*/
    React.createElement(NotificationGroup, {
      data: globalNotifications
    }),
    /*#__PURE__*/
    React.createElement(NotificationGroup, {
      className: "notification-group--local",
      data: localNotifications
    }), children)
  );
};

var Table = function Table(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement("div", {
      className: "table-wrap"
    },
    /*#__PURE__*/
    React.createElement("table", _extends({
      className: "table ".concat(className ? className : "")
    }, props), children)))
  );
};

Table.propTypes = {
  className: PropTypes.string
};

var TableBtnGroup = function TableBtnGroup(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "span" : _ref$type,
      _ref$btngroup = _ref.btngroup,
      btngroup = _ref$btngroup === void 0 ? [] : _ref$btngroup,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["type", "btngroup", "className"]);

  return (
    /*#__PURE__*/
    React.createElement(type, _objectSpread2({
      className: "table__action-buttons ".concat(className ? className : "")
    }, props), btngroup.map(function (_ref2, index) {
      var _ref2$label = _ref2.label,
          label = _ref2$label === void 0 ? "enter label" : _ref2$label,
          className = _ref2.className,
          btnprops = _objectWithoutProperties(_ref2, ["label", "className"]);

      return (
        /*#__PURE__*/
        React.createElement(Button, _extends({
          key: index,
          className: className,
          size: "sm"
        }, btnprops), label)
      );
    }))
  );
};

var TableData = function TableData(props) {
  var btngroup = props.btngroup,
      className = props.className,
      children = props.children,
      render = props.render,
      handleDropdown = props.handleDropdown,
      other = _objectWithoutProperties(props, ["btngroup", "className", "children", "render", "handleDropdown"]);

  return (
    /*#__PURE__*/
    React.createElement("td", _extends({
      className: "tabledata ".concat(className ? className : "")
    }, other), render ? render(handleDropdown) : children, btngroup &&
    /*#__PURE__*/
    React.createElement(TableBtnGroup, {
      btngroup: btngroup,
      className: "table__action-buttons--td"
    }))
  );
};

TableData.propTypes = {
  btngroup: PropTypes.oneOfType([PropTypes.array, PropTypes.bool, PropTypes.object]),
  className: PropTypes.string,
  children: PropTypes.any
};

var TableDataLabel = function TableDataLabel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      label = _ref.label,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["children", "className", "href", "label", "type"]);

  var componentClassNames = [className, "tabledata__label", "td--link"].filter(Boolean).join(" ");
  return (
    /*#__PURE__*/
    React.createElement(href ? "a" : type, _objectSpread2({
      className: componentClassNames,
      href: href
    }, props), label, children)
  );
};

TableDataLabel.defaultProps = {
  type: "span"
};

var TableDataSubLabel = function TableDataSubLabel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      label = _ref.label,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["children", "className", "href", "label", "type"]);

  var componentClassNames = [className, "tabledata__subLabel"].filter(Boolean).join(" ");
  return (
    /*#__PURE__*/
    React.createElement(href ? "a" : type, _objectSpread2({
      className: componentClassNames,
      href: href
    }, props), label, children)
  );
};

TableDataSubLabel.defaultProps = {
  type: "span"
};

var TableHead = function TableHead(_ref) {
  var children = _ref.children,
      id = _ref.id,
      isSortAscending = _ref.isSortAscending,
      isSortActive = _ref.isSortActive,
      isSortEnabled = _ref.isSortEnabled,
      props = _objectWithoutProperties(_ref, ["children", "id", "isSortAscending", "isSortActive", "isSortEnabled"]);

  return (
    /*#__PURE__*/
    React.createElement("th", _extends({
      id: id,
      "data-sortby": isSortEnabled ? id : null,
      scope: "col"
    }, props), children, isSortEnabled &&
    /*#__PURE__*/
    React.createElement(Icon, {
      className: isSortActive ? "tablehead__sort tablehead__sort--active" : "tablehead__sort",
      type: isSortAscending ? "arrow-nav-up" : "arrow-nav-down",
      style: {
        height: ".75em",
        marginLeft: ".25rem",
        pointerEvents: "none",
        verticalAlign: "-0.05em",
        width: ".75em"
      }
    }))
  );
};

var TableRowCheckbox = function TableRowCheckbox(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      type = _ref.type;
  return (
    /*#__PURE__*/
    React.createElement(type, {
      width: 5
    },
    /*#__PURE__*/
    React.createElement(Checkbox, {
      checked: checked,
      onChange: onChange
    }))
  );
};

TableRowCheckbox.defaultProps = {
  type: "td"
};

var TableRowDropdown = function TableRowDropdown(props) {
  var className = props.className,
      dropdown = props.dropdown,
      handleDropdown = props.handleDropdown,
      isExpanded = props.isExpanded;

  if (!isExpanded) {
    return false;
  }

  return (
    /*#__PURE__*/
    React.createElement("tr", {
      className: "tablerow__dropdown ".concat(className ? className : "")
    },
    /*#__PURE__*/
    React.createElement("td", {
      colSpan: "100"
    },
    /*#__PURE__*/
    React.createElement(Button, {
      className: "dismiss",
      color: "transparent",
      icon: "close",
      onClick: handleDropdown,
      size: "md"
    }),
    /*#__PURE__*/
    React.createElement(Container, {
      className: "tablerow__dropdown-container"
    }, dropdown && dropdown())))
  );
};

var TableRow =
/*#__PURE__*/
function (_Component) {
  _inherits(TableRow, _Component);

  var _super = _createSuper(TableRow);

  function TableRow(props) {
    var _this;

    _classCallCheck(this, TableRow);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleDropdown", function () {
      var isExpanded = !_this.state.isExpanded;

      _this.setState({
        isExpanded: isExpanded
      });

      if (_this.props.onDropdownChange) {
        _this.props.onDropdownChange(isExpanded);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckbox", function () {
      _this.setState({
        isChecked: !_this.state.isChecked
      });
    });

    _this.state = {
      isExpanded: !!_this.props.isExpanded
    };
    return _this;
  }

  _createClass(TableRow, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isExpanded !== this.props.isExpanded) {
        return this.setState({
          isExpanded: this.props.isExpanded
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          btngroup = _this$props.btngroup,
          className = _this$props.className,
          children = _this$props.children,
          checkbox = _this$props.checkbox,
          dropdown = _this$props.dropdown,
          isChecked = _this$props.isChecked,
          handleCheckbox = _this$props.handleCheckbox,
          render = _this$props.render;
      var classes = getClassNames(["tablerow", this.state.isExpanded && "active", className]); // If dropdown is enable and not using render prop
      // "Automagically" map primary button action to handledropdown • As per Table Spec.

      if (!!dropdown && !!btngroup && !render) {
        btngroup[0]["onClick"] = this.handleDropdown;
      }

      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement("tr", {
          className: classes
        }, checkbox &&
        /*#__PURE__*/
        React.createElement(TableRowCheckbox, {
          checked: !!isChecked,
          onChange: handleCheckbox,
          type: children[0].type === "th" ? "th" : "td"
        }), render ? render(this.state, this.handleDropdown) : React.Children.map(children, function (child, index) {
          var isDropdown = dropdown && index === 0;
          var isLastItem = index === React.Children.count(children) - 1;

          if (child.type === "th") {
            return (
              /*#__PURE__*/
              React.createElement(TableHead, _extends({
                btngroup: index === 0 ? btngroup : null
              }, child.props), child.props.children)
            );
          }

          return (
            /*#__PURE__*/
            React.createElement(TableData, _extends({
              btngroup: isLastItem && btngroup,
              handleDropdown: isDropdown && _this2.handleDropdown
            }, child.props), child.props.children)
          );
        })),
        /*#__PURE__*/
        React.createElement(TableRowDropdown, {
          dropdown: dropdown,
          handleDropdown: this.handleDropdown,
          isExpanded: this.state.isExpanded
        }))
      );
    }
  }]);

  return TableRow;
}(Component);

TableRow.propTypes = {
  checkbox: PropTypes.bool
};
TableRow.defaultProps = {// isChecked: true,
  // thBtnGroup: [{ label: "Hello" }],
};

var TableUtilityBarTitle = function TableUtilityBarTitle(_ref) {
  var totalResults = _ref.totalResults,
      pagination = _ref.pagination,
      title = _ref.title;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "table-utilitybar__title-wrapper"
    }, title &&
    /*#__PURE__*/
    React.createElement("h2", {
      className: "table-utilitybar__title font-size-md"
    }, title), pagination ?
    /*#__PURE__*/
    React.createElement("p", {
      className: title ? "table-utilitybar__results font-size-sm" : "table-utilitybar__results ml-0 font-size-sm"
    }, "Displaying ", pagination.start, "-", pagination.end, " out of ", totalResults) : totalResults != null ? "Displaying ".concat(totalResults, " Results") : null)
  );
};

var TableUtilityBarSelectCounter = function TableUtilityBarSelectCounter(_ref) {
  var isCheckedCount = _ref.isCheckedCount;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "table-utilitybar__select-count"
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "table-utilitybar__select-count--circle"
    },
    /*#__PURE__*/
    React.createElement("span", {
      className: "table-utilitybar__select-count--value"
    }, isCheckedCount)),
    /*#__PURE__*/
    React.createElement("h4", {
      className: "table-utilitybar__select-count--title"
    }, "Selected"))
  );
};

var TableUtiltyBar = function TableUtiltyBar(_ref) {
  var btngroup = _ref.btngroup,
      btngroupSecondary = _ref.btngroupSecondary,
      _ref$isCheckedCount = _ref.isCheckedCount,
      isCheckedCount = _ref$isCheckedCount === void 0 ? 0 : _ref$isCheckedCount,
      pagination = _ref.pagination,
      totalResults = _ref.totalResults,
      title = _ref.title;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "table-utilitybar"
    }, isCheckedCount <= 0 ?
    /*#__PURE__*/
    React.createElement(TableUtilityBarTitle, {
      pagination: pagination,
      totalResults: totalResults,
      title: title
    }) :
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(TableUtilityBarSelectCounter, {
      isCheckedCount: isCheckedCount
    }),
    /*#__PURE__*/
    React.createElement(TableBtnGroup, {
      btngroup: btngroup,
      className: "table-utilitybar__btngroup",
      type: "div"
    })), btngroupSecondary &&
    /*#__PURE__*/
    React.createElement(TableBtnGroup, {
      className: "table-utilitybar__btngroup-secondary",
      btngroup: btngroupSecondary,
      type: "div"
    }))
  );
};

TableUtiltyBar.propType = {
  btngroup: PropTypes.array.isRequired,
  btngroupSecondary: PropTypes.array
};
TableUtiltyBar.defaultProps = {
  btngroup: []
};

var TabControllerItem = function TabControllerItem(_ref) {
  var active = _ref.active,
      icon = _ref.icon,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["active", "icon", "label"]);

  return (
    /*#__PURE__*/
    React.createElement("li", _extends({
      className: active ? "tab-controller__item active" : "tab-controller__item"
    }, props), icon &&
    /*#__PURE__*/
    React.createElement(Icon, {
      type: icon,
      className: "mr-1"
    }), label)
  );
};

TabControllerItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string
};

var TabController = function TabController(_ref) {
  var active = _ref.active,
      className = _ref.className,
      children = _ref.children,
      handleTabClick = _ref.handleTabClick;
  return (
    /*#__PURE__*/
    React.createElement("ul", {
      className: "tab-controller ".concat(className ? className : "")
    }, React.Children.map(children, function (child, index) {
      return (
        /*#__PURE__*/
        React.createElement(TabControllerItem, {
          active: active === index,
          icon: child.props.icon,
          label: child.props.label,
          onClick: function onClick() {
            return handleTabClick(index);
          }
        })
      );
    }))
  );
};

var Tabs =
/*#__PURE__*/
function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (index) {
      _this.setState({
        activeTabIndex: index
      });
    });

    _this.state = {
      activeTabIndex: _this.props.activeTabIndex || 0
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var activeTabIndex = this.state.activeTabIndex;
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          _this$props$hideTabCo = _this$props.hideTabController,
          hideTabController = _this$props$hideTabCo === void 0 ? false : _this$props$hideTabCo;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className ? "content-tabs ".concat(className) : "content-tabs"
        }, !hideTabController &&
        /*#__PURE__*/
        React.createElement(TabController, {
          handleTabClick: this.handleTabClick,
          active: activeTabIndex
        }, children),
        /*#__PURE__*/
        React.createElement("div", {
          className: "content-tabs__body"
        }, React.Children.toArray(children)[activeTabIndex]))
      );
    }
  }]);

  return Tabs;
}(Component);

var TabItem = function TabItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  return (
    /*#__PURE__*/
    React.createElement("div", _extends({
      className: className ? "tab-item ".concat(className) : className
    }, props), children)
  );
};

export { Button, Card, Container, index$1 as Form, Icon, Icon as Icons, Logo, Modal, Nav, NavDropdown, NavItem, NavItemProfile, Notification, NotificationContext, NotificationContextProvider, NotificationGroup, ProfileImage, Spinner, TabItem, Table, TableBtnGroup, TableData, TableDataLabel, TableDataSubLabel, TableHead, TableRow, TableUtiltyBar as TableUtilityBar, Tabs, Tag };